import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import {
  order_delete_action,
  order_edit_details,
  get_follow_up_action,
  follow_up_add_action,
  order_cancel_reason_action,
  download_performa_invoice_action,
  download_no_due_action,
  generate_nodue_action,
  order_approval_action,
  update_exit_pass_action,
  event_closure_action,
  download_exitPass_action,
  update_additional_service_approval_action,
  update_additional_hour,
  update_additional_discount,
  update_rental_discount,
  update_security_deposit,
  update_event_service, send_approval_pi_mail_action,
  download_booking_form_action
} from "../../../actions/myOrders_action/myOrders_action";
import { fill_action } from "../../../actions/fillList_action";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Loader from "../../../utils/Loader";
import Header from "../../../common_components/Header";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  BASE_URL,
  cancellationReasonActionId,
  downloadReport,
  orderRejectionActionId,
  sessionExpireMessage,
  standardPremiumActionId,
  toastError,
  tokenInavlidMessage,
  vendorActionId,
} from "../../../utils/constants";
import Select from "react-select";
import { Modal, Button, Tab, Nav } from "react-bootstrap";
import {
  client_detail_action,
  client_add_action,
} from "../../../actions/master_actions/client_action";
import {
  accountTypeActionId,
  cityActionId,
  companyStatusActionId,
  countryActionId,
  stateActionId,
} from "../../../utils/constants";
import {
  addressValidator,
  emailValidator,
  gstNoValidator,
  mobileNoValidator,
  notMendetoryEmailValidator,
  notMendetoryMobileNoValidator,
  panNoValidator,
  pincodeValidator,
  requiredValidator,
  tanNoValidator,
} from "../../../utils/Validator";

import {
  get_additional_services_action,
  getServiceVendorPackageDetail_action,
} from "../../../actions/bookingDetails_action/aditionalServices_action";
import { get_booking_Details_action } from "../../../actions/bookingDetails_action/bookingDetails_action";
import {
  get_possession_list_action,
  get_exist_list_action,
} from "../../../actions/checkList_action/checkList_action";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link, Element } from "react-scroll";
const floatingLabelCSS = `
.floating-label-outside{
  top:-7px !important;
  font-size:10px !important;
  background:#fff !important;
}
.mendatory_class{
  font-size:12px;
}
`;
const marks = [];

for (let i = 0; i <= 100000; i++) {
  if (i % 250 === 0) {
    marks.push({
      value: i,
    });
  }
}
class OrdersEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isEdit: 1,
      isAccordionExpanded: false,
      followInfoCollapse: false,
      PiShow: false,
      piSendShow: false, piFilePath: '', exitPiFilePath: '', taxInvoiceFilePath: '',
      PiType: "",
      isAdditionalHourAllow: true,
      isOverNightChargesAllow: true,
      isInsertDiscountAllow: true,
      isAdditionalDiscountAllow: true,
      isEventServiceAllow: true,
      isSDAllow: true,
      editShow: false,
      isModifyEdit: false,
      AdditionalDiscount: "",
      AdditionalDiscountNote: "",
      deleteShow: false,
      followUpShow: false,
      approveShow: false,
      rejectShow: false,
      isEditMode: true,
      PiShow: false,
      adminCompanyInfoUpdate: 1,
      OrderAmount: "",
      ConvenienceFee: "",
      AdminRemark: "",
      RefundAmount: "",
      userId: "",
      OrderID: "",
      RoleID: "",
      UUID: "",
      Note: "",
      OrderNo: "",
      Date: "",
      StatusID: "",
      OrderDate: "",
      ItmeCenter: "",
      TypeOfEventID: "",
      DeliveryStatus: "",
      TypeOfEvent: "",
      EventName: "",
      grandTotal: "",
      Is_NoDue: false,
      NoDueDate: "",
      NoDueBy: "",
      Is_ExitPass: false,
      IsExitPassDate: "",
      ExitPassBy: "",
      Is_Approved: false,
      RejectReasonID: "",
      RejectReason: "",
      RejectionNote: "",
      MyOrdersData: [],
      proformaList: [],
      additionalChargesData: [],
      additionalChargesDetails: [],
      filteredData: [],
      eventFillList: [],
      cancellationReasonList: [],
      rejectionReasonList: [],
      ChargeHeadID: "",
      ChargeHeadName: "",
      Charges: "",
      AdditionalHours: "",
      AdditionalHourCharges: "",
      OvernightCharges: "",
      SecurityDeposit: "",
      SecurityDepositRemark: "",
      RentalDiscount: "",
      DiscountAmountNote: "",
      EventServiceAmount: "",
      EventServiceNote: "",
      //client list
      checkboxFlag: false,
      AreaCode: "",
      SAAAReaCode: "",
      stateId: "",
      stateList: [],
      countryId: "",
      clientUser: "",
      countryList: [],
      firstName: "",
      lastName: "",
      designation: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      cityId: "",
      cityList: [],
      pincode: "",
      Mobile1: "",
      Mobile2: "",
      primaryEmailID: "",
      secondaryEmailID: "",
      website: "",
      mobileISD1: "",
      mobileISD2: "",
      accountType: "",
      accountTypeList: [],
      VendorEmailID: "",

      SameAsAbove: false,

      SAAFirstName: "",
      SAALastName: "",
      SAADesignation: "",
      SAACompanyName: "",
      SAAAddressLine1: "",
      SAAAddressLine2: "",
      SAACityId: "",
      SAAPincode: "",
      SAAMobile1: "",
      SAAMobile2: "",
      SAAPrimaryEmailID: "",
      SAASecondaryEmailID: "",
      SAAWebsite: "",
      SAAStateId: "",
      SAACountryId: "",
      SAATelephoneNumber: "",
      SAAMobileISD1: "",
      SAAMobileISD2: "",
      SAAISD: "",
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",
      TelephoneNumber: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
      EventCordinatorName: "",
      EventCordinatorDesignation: "",
      EventCordinatorEmail: "",
      EventCordinatorMobile: "",
      PrimaryContactName: "",
      PrimaryContactDesignation: "",
      PrimaryContactEmail: "",
      PrimaryContactMobile: "",
      adminCompanyInfoUpdate: "",
      preTel: "",
      SAAPreTel: "",

      EventCordinatorNameErr: "",
      EventCordinatorDesignationErr: "",
      EventCordinatorEmailErr: "",
      EventCordinatorMobileErr: "",
      PrimaryContactNameErr: "",
      PrimaryContactDesignationErr: "",
      PrimaryContactEmailErr: "",
      PrimaryContactMobileErr: "",
      CityName: "",
      tempCityList: [],
      SAACityName: "",
      companyStatusList: [],
      ISD: "",

      CenterID: "",
      OrderID: "",
      ClientID: "",
      Is_CenterID: false,
      MaxPAX: "",
      LastDate: "",
      // input validate
      companyStatusErr: "",
      firstNameErr: "",
      lastNameErr: "",
      organizerErr: "",
      addressLine1Err: "",
      addressLine2Err: "",
      CityNameErr: "",
      countryIdErr: "",
      pincodeErr: "",
      Mobile1Err: "",
      primaryEmailIDErr: "",
      SAAFirstNameErr: "",
      SAALastNameErr: "",
      SAAAddressLine1Err: "",
      SAAAddressLine2Err: "",
      SAACityNameErr: "",
      SAACountryIdErr: "",
      SAAPincodeErr: "",
      SAAMobile1Err: "",
      SAAPrimaryEmailIDErr: "",
      PANCardNoErr: "",
      NameonPANCardErr: "",
      accountNameErr: "",
      accountNoErr: "",
      accountTypeErr: "",
      bankNameErr: "",
      branchNameErr: "",
      SAACompanyNameErr: "",
      preTel: "",
      SAAPreTel: "",
      AreaCode: "",
      SAAAreaCode: "",
      isDisplayCityList: false,
      isSAADisplayCityList: false,

      isDisplayStateList: false,
      tempStateList: [],

      isSAADisplayStateList: false,
      tempSAAStateList: [],

      SAAStateList: [],
      SAAtempStateList: [],

      SAACityList: [],
      SAAtempCityList: [],
      CancellationReasonID: "",
      CancellationReason: "",
      cancelNote: "",
      DeletedBy: "",
      DeletedDate: "",
      CancellationNote: "",
      //payment
      paymentType: "",
      ToPay: "",
      isLoadPayment: false,
      encPayload: "",
      orderId: "",
      changeAmt: 1,
      paymentAccessCode: "AVVI64IL27CE56IVEC",
      finalCurrency: "",
      currencyErr: false,
      //Additional Services
      additionalServicesList: [],
      serviceName: "",
      addRequirement: "",
      standardPremiumId: "",
      standardPremiumList: [],
      isQuantity: "",
      Ammount: "",
      standerdArray: [],
      premiumArray: [],
      tempStandardArray: [],
      tempStandardArray2: [],
      isOpen: false,
      checkboxFlag: false,
      is_checkbox: "",
      Quantity: "",
      sList: [],
      CenterID: "",
      OrderID: "",
      fileList: [],
      currentImageIndex: 0,
      ClientID: "",
      orderDtlID: "",
      DetailsPremiumArray: [],
      DetailsStandardArray: [],
      show: false,
      CurrencyID: "",
      unlistedAddServices: "",
      includedServices: [],
      externalServices: [],
      vendorPackageList: [],
      dummyVendorPackageList: [],
      OtherInformation: "",
      downloadUrl: "",
      showtable: false,
      showPackageDetailsData: "",
      indexOfExternalService: "",
      //Booking Details
      EntryType: "",
      TypeOfEvent: "",
      SittingArrangement: "",
      bookingList: [],
      BookingEventDataList: [],
      PossesionStartDate: "",
      PossesionEndDate: "",
      PossesionStartTime: "",
      PossesionEndTime: "",
      eventStartDate: "",
      eventEndDate: "",
      eventStartTime: "",
      eventEndTime: "",
      dismantleStartDate: "",
      dismantleEndDate: "",
      dismantleStartTime: "",
      dismantleEndTime: "",
      //checkList
      possessionIncludedServicesList: [],
      possessionInhouseServicesList: [],
      exitConsumableList: [],
      possessionConsumableList: [],
      PossessionContactNameAndNumber: "",
      ExitContactNameAndNumber: "",
      possessionCheckList: [],
      isPossessionList: [],
      signatureData: "",
      isSignatureSaved: false,
      isSignatureSaveFlag: false,
      showCountryId: "",
      exitIncludedServicesList: [],
      ExitSubmittedUser: "",
      exitInhouseServicesList: [],
      exitCheckList: [],
      isExitList: [],
      ExitSubmittedBy: "",
      ExitSubmittedDate: "",
      exitListShow: true,
      signatureData2: "",
      isSignatureSaved2: false,
      isSignatureSaveFlag2: false,
      exitDataListFlag: false,
      possessionDataListFlag: false,
      ExitSignatureData: "",
      possessionSignatureData: "",
      submitOrApproveAdditional: "",
      possessionTime: "",
      exitTime: "",
      possessionCheckList: [],
      PossesionSubmittedUser: "",
      PossesionSubmittedDate: "",
      ExitSubmittedUser: "",
      exitSub: false,
      possessionSub: false,
      possessionCheckListAllSelected: false,
      possessionMaterialNameAndServiceName: "",
      PosssesionOperationNameContact: "",
      oppPossessionSignatureData: "",
      ExitOperationNameContact: "",
      oppExitSignatureData: "",
      possessionMaterialList: [],
      exitCheckListAllSelected: false,
      possessionSecurityList: [],
      PossessionSecurityChecklistNote: "",
      exitMaterialList: [],
      exitSecurityList: [],
      exitInstructionList: [],
      ExitSecurityChecklistNote: "",
      exitMaterialNameAndServiceName: "",
      AdditionHours: "",
      ExitSubmittedUser: "",
      exitVendorList: [],
      possessionVendorList: [],
      AdditionHoursExit: "",
      unlistedAddServicesExit: "",
      exitVendorList: [],
      electricityExit: "",
      electricityPossesion: "",
      existDataListFlag: false,
      isCollapsed: false,
      SliderValue: [0, 100000],
      minPrice: null,
      maxPrice: null,
      vendorNameList: [],
      //rest
      vendorFillList: [],
      VendorID: "",
      NameOfTheVendor: "",
      AdditionalServiceApprovalStatus: "",
      submitOrApproveAdditional: "",
      downloadUrl: "",
      MembershipFilePath: "",
    };
    this.submitfrm = React.createRef();
    this.formatOrderDate = this.formatOrderDate.bind(this);
    this.createOrderConfirmationList =
      this.createOrderConfirmationList.bind(this);
    this.editCompany = this.editCompany.bind(this);
  }
  async componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    const sortUrl = BASE_URL.split("/api");

    this.setState({ downloadUrl: sortUrl[0] });
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 2 ||
          sessionStorage.getItem("roleId") == 1 ? (
          <></>
        ) : (
          this.props.navigate("/normalView")
        );
      }
    }, 10);
    this.setState({
      OrderID:
        this.props.location.state != null &&
          this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",
      OrderNo:
        this.props.location.state != null &&
          this.props.location.state.OrderNo != null
          ? this.props.location.state.OrderNo
          : "",
      ClientID:
        this.props.location.state != null &&
          this.props.location.state.ClientID != null
          ? this.props.location.state.ClientID
          : "",
      CenterID:
        this.props.location.state != null &&
          this.props.location.state.CenterID != null
          ? this.props.location.state.CenterID
          : "",
      CompanyName:
        this.props.location.state != null &&
          this.props.location.state.CompanyName != null
          ? this.props.location.state.CompanyName
          : "",
      PrimaryEmailID:
        this.props.location.state != null &&
          this.props.location.state.PrimaryEmailID != null
          ? this.props.location.state.PrimaryEmailID
          : "",

      ProformaInvoiceID:
        this.props.location.state != null &&
          this.props.location.state.ProformaInvoiceID != null
          ? this.props.location.state.ProformaInvoiceID
          : "",
      ProformaInvoice_No:
        this.props.location.state != null &&
          this.props.location.state.ProformaInvoice_No != null
          ? this.props.location.state.ProformaInvoice_No
          : "",

      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });


    const { userId } = this.state;
    this.getFillList(stateActionId, "", 1, "").then(() => {
      this.getFillList(countryActionId, '', '1', '').then(() => {
        this.getFillList(cityActionId, '', '1', '').then(() => {
          this.getFillList(companyStatusActionId, '', '', '').then(() => {
            this.getFillList(accountTypeActionId, '', '', '').then(() => {
              this.getFillList(cancellationReasonActionId, userId, '', '').then(() => {
                this.getFillList(orderRejectionActionId, userId, '', '').then(() => {
                  this.getFillList(standardPremiumActionId, userId, '', '').then(() => {
                    this.getFillList(vendorActionId, userId, '', '').then(() => {
                      setTimeout(() => {
                        this.getOrderEditDetails();
                        this.setState({ isLoading: false })
                      }, 200);
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .fill_action(
          value,
          userId == "" || userId == null ? null : userId,
          keyword != "" ? keyword : null,
          keyvalue != "" ? keyvalue : null
        )
        .then((data) => {
          if (data.error != 1) {
            if (value == stateActionId) {
              this.setState({
                stateList: data.data,
                tempStateList: data.data,

                SAAStateList: data.data,
                SAAtempStateList: data.data,
              }, () => resolve(true)
              )
            }
            if (value == countryActionId) {
              this.setState({ countryList: data.data }, () => resolve(true));
            }
            if (value == cityActionId) {
              this.setState({
                cityList: data.data,
                tempCityList: data.data,

                SAACityList: data.data,
                SAAtempCityList: data.data,
              }, () => resolve(true));
            }
            if (value == companyStatusActionId) {
              this.setState({ companyStatusList: data.data }, () => resolve(true));
            }
            if (value == accountTypeActionId) {
              this.setState({ accountTypeList: data.data }, () => resolve(true));
            }
            if (value == cancellationReasonActionId) {
              this.setState({
                cancellationReasonList: data.data,
              }, () => resolve(true));
            }
            if (value == orderRejectionActionId) {
              this.setState({
                rejectionReasonList: data.data,
              }, () => resolve(true));
            }
            if (value == standardPremiumActionId) {
              this.setState({ standardPremiumList: data.data }, () => resolve(true));
            }
            if (value == vendorActionId) {
              this.setState({ vendorFillList: data.data }, () => resolve(true));
            }
          }
        })
    })
      .catch((e) => {
        console.log(e);
      });
  }
  vendorModalShow = (filePath) => {
    this.setState({
      show: true,
    });
    if (filePath != null) {
      const filePathArray = [];
      filePathArray.push(filePath.split(","));
      this.setState({ fileList: filePathArray[0] });
    }
  };
  vendorModalClose = () => {
    this.setState({ show: false });
  };

  tablePackageDetailsShow = (data) => {
    this.setState({ showtable: true, showPackageDetailsData: data });
  };

  tablePackageDetailsClose = () => {
    this.setState({ showtable: false });
  };

  serviceModalShow = (id, index, serviceName, requirement) => {
    this.setState({
      isOpen: true,
      serviceName: serviceName,
      addRequirement: requirement,
      addRequirementID: id,
      addRequirementIndex: index,
      // minPrice:null,
      // maxPrice:null
    });
    setTimeout(() => {
      this.getServiceVendorPackageDetail(id, index);
    }, 100);
  };
  serviceModalClose = () => {
    this.setState({ isOpen: false });
  };
  onSearchPackage() {
    const { addRequirementID, addRequirementIndex } = this.state;
    this.getServiceVendorPackageDetail(addRequirementID, addRequirementIndex);
  }
  getOrderEditDetails() {
    const { userId, OrderID, OrderNo, CompanyName, PrimaryEmailID } =
      this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    if (OrderID != null) {
      this.props
        .order_edit_details(
          userId,
          OrderID || this.props.location.state.OrderID
        )
        .then((data) => {
          if (data.error !== 1) {
            setTimeout(() => {
              this.createOrderConfirmationList(
                data.data,
                OrderNo,
                CompanyName,
                PrimaryEmailID
              );
              this.setState({ isLoading: false });
            }, 300);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((err) => {
          console.error(err); // Logging the error for debugging
          this.setState({ isLoading: false });
        });
    } else {
      this.props.navigate("/orders");
    }
  }

  createOrderConfirmationList(data, OrderNo, CompanyName, PrimaryEmailID) {
    const { MyOrdersData } = this.state;
    const orderIDList = [];
    const finalList = [];
    const proformaList = [];

    for (const order of data[1]) {
      const orderID = order.OrderID;
      if (!orderIDList.includes(orderID)) {
        orderIDList.push(orderID);

        const summaryArr = data[0].filter(
          (booking) => booking.OrderID === orderID
        );
        const additionalServicesArr = [];
        const data2 = data[2].filter((service) => service.OrderID === orderID);
        data2.map((item) => {
          if (item.GrossAmount !== null) {
            if (item.Type === "S") {
              additionalServicesArr.push(item);
            } else if (item.Type === "P") {
              additionalServicesArr.push(item);
            }
          }
        });

        const objectID = {
          OrderID: orderID,
          summary: summaryArr,
          additionalServices: additionalServicesArr,
          centerName: order.CenterName,
          centerAdd: order.ADDRESS,
          OrderNo: order.OrderNo,
          DeliveryStatus: order.OrderStatus,
          StatusID: order.StatusID,
          paymentStatus: order.PaymentStatus,
          Is_NoDue: order.Is_NoDue,
          NoDueDate: order.NoDueDate,
          NoDueBy: order.NoDueBy,
          Is_ExitPass: order.Is_ExitPass,
          IsExitPassDate: order.IsExitPassDate,
          AdditionalDiscount: order.AdditionalDiscount,
          AdditionalDiscountNote: order.AdditionalDiscountNote,
          DiscountAmount: order.DiscountAmount,
          DiscountAmountNote: order.DiscountAmountNote,
          EventServiceAmount: order.EventServiceAmount,
          EventServiceNote: order.EventServiceNote,
          SecurityDeposit: order.SecurityDeposit,
          SecurityDepositRemark: order.SecurityDepositRemark,
          ExitPassBy: order.ExitPassBy,
          Is_Closure: order.Is_Closure,
          currency: order.Currency,
          RoleID: order.RoleID,
          CenterID: order.CenterID,
          ClientID: order.ClientID,
          orderDate: this.formatOrderDate(order.OrderDate),
          UUID: order.UUID,
          IsMemberShip: order.IsMemberShip,
          piFilePath: order.piFilePath,
          exitPiFilePath: order.exitPiFilePath,
          taxInvoiceFilePath: order.taxInvoiceFilePath,

        };

        const priceData = data[3].find((price) => price.OrderID === orderID);
        const proformaData = data[4].filter(
          (proformaDetails) => proformaDetails.OrderID === orderID
        );
        const cancellationData = data[5].filter(
          (cancel) => cancel.OrderID === orderID
        );
        const rejectionData = data[6].filter(
          (rejected) => rejected.OrderID === orderID
        );
        const additionalChargesData = data[7].filter(
          (addhourGet) => addhourGet.OrderID === orderID
        );
        const additionalChargesDetails = data[8].find(
          (addhourDetails) => addhourDetails.OrderID === orderID
        );
        objectID.Price = priceData;
        objectID.proformaDetails = proformaData;
        objectID.cancelArr = cancellationData;
        objectID.RejectionData = rejectionData;
        objectID.additionalChargesData = additionalChargesData;
        objectID.additionalChargesDetails = additionalChargesDetails;

        finalList.push(objectID);
        proformaList.push(proformaData);

        const isMoreThan7Days = (bookingDate, bookingSlot) => {
          const [startTime] = bookingSlot.split(" - ");
          const [startHour, startPeriod] = startTime.split(" ");
          const [startHourNum, startMinute] = startHour.split(":");
          const startDate = new Date(
            `${bookingDate} ${startHourNum}:${startMinute} ${startPeriod}`
          );

          const currentTime = new Date();
          const timeDifferenceInDays =
            (startDate - currentTime) / (1000 * 60 * 60 * 24); // Difference in days

          return timeDifferenceInDays > 7;
        };

        const isBookingToday = (bookingDate) => {
          const bookingDateObj = new Date(bookingDate);
          const currentDate = new Date();

          return bookingDateObj.toDateString() === currentDate.toDateString();
        };

        const isAnyBookingMoreThan7Days = summaryArr.some(
          ({ BookingDate, BookingSlot }) =>
            isMoreThan7Days(BookingDate, BookingSlot)
        );

        const isAnyBookingToday = summaryArr.some(({ BookingDate }) =>
          isBookingToday(BookingDate)
        );

        this.setState({
          AdditionalServiceStatus: isAnyBookingMoreThan7Days ? 0 : 1,
          AdditionalServiceApprovalStatus: isAnyBookingToday ? 1 : 0,
        });
      }
    }

    this.setState({
      MyOrdersData: finalList,
      proformaList: proformaList,
      AdditionalHours: finalList.map(
        (data) => data.additionalChargesDetails.AdditionalHours
      ),
      AdditionalHourCharges: finalList.map(
        (data) => data.additionalChargesDetails.AdditionalHourCharges
      ),
      OvernightCharges: finalList
        .map((data) => data.additionalChargesDetails.OvernightCharges)
        .join(" "),
      AdditionalDiscount: finalList.map((data) => data.AdditionalDiscount),
      AdditionalDiscountNote: finalList
        .map((data) => data.AdditionalDiscountNote)
        .join(" "),
      DiscountAmountNote: finalList
        .map((data) => data.DiscountAmountNote)
        .join(" "),
      RentalDiscount: finalList.map((data) => data.DiscountAmount).join(" "),
      SecurityDeposit: finalList.map((data) => data.SecurityDeposit).join(" "),
      SecurityDepositRemark: finalList
        .map((data) => data.SecurityDepositRemark)
        .join(" "),
      EventServiceAmount: finalList
        .map((data) => data.EventServiceAmount)
        .join(" "),
      EventServiceNote: finalList
        .map((data) => data.EventServiceNote)
        .join(" "),
      CenterID: finalList.map((data) => data.CenterID).join(" "),
      ClientID: finalList.map((data) => data.ClientID).join(" "),
      StatusID: finalList.map((data) => data.StatusID).join(" "),
      piFilePath: finalList.map((data) => data.piFilePath),
      exitPiFilePath: finalList.map((data) => data.exitPiFilePath),
      taxInvoiceFilePath: finalList.map((data) => data.taxInvoiceFilePath),
    });
    if (
      (finalList.map((data) => data.CenterID) != null &&
        finalList.map((data) => data.ClientID) != null) ||
      (this.props.location.state.ClientID != null &&
        this.props.location.state.CenterID != null)
    ) {
      this.setState({
        CenterID: finalList.map((data) => data.CenterID).join(", "),
        ClientID: finalList.map((data) => data.ClientID).join(", "),
        DeliveryStatus: finalList.map((data) => data.DeliveryStatus),
      });

      this.props
        .client_detail_action(
          finalList.map((data) => data.ClientID).join(", ") ||
          this.props.location.state.ClientID
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });

            this.setState({
              firstName: data.data[0]["FirstName"],
              lastName: data.data[0]["LastName"],
              designation: data.data[0]["Designation"],
              companyName: data.data[0]["CompanyName"],
              addressLine1: data.data[0]["AddressLine1"],
              addressLine2: data.data[0]["AddressLine2"],
              cityId: data.data[0]["CityName"],
              SAACityId: data.data[0]["Inv_CityName"],
              stateId: data.data[0]["StateName"],
              countryId: data.data[0]["CountryID"],
              pincode: data.data[0]["Pincode"],
              Mobile1: data.data[0]["Mobile1"],
              Mobile2: data.data[0]["Mobile2"],
              TelephoneNumber: data.data[0]["Telephone"],
              primaryEmailID: data.data[0]["PrimaryEmailID"],
              secondaryEmailID: data.data[0]["SecondaryEmailID"],
              website: data.data[0]["Website"],
              SameAsAbove: data.data[0]["IS_SameAsAbove"],
              SAAFirstName: data.data[0]["Inv_FirstName"],
              SAALastName: data.data[0]["Inv_LastName"],
              SAADesignation: data.data[0]["Inv_Designation"],
              SAACompanyName: data.data[0]["Inv_CompanyName"],
              SAAAddressLine1: data.data[0]["Inv_AddressLine1"],
              SAAAddressLine2: data.data[0]["Inv_AddressLine2"],
              SAACityName: data.data[0]["Inv_CityName"],
              SAAStateId: data.data[0]["Inv_StateName"],
              SAACountryId: data.data[0]["Inv_CountryID"],
              SAAPincode: data.data[0]["Inv_Pincode"],
              SAAMobile1: data.data[0]["Inv_Mobile1"],
              SAAMobile2: data.data[0]["Inv_Mobile2"],
              SAATelephoneNumber: data.data[0]["Inv_Telephone"],
              SAAPrimaryEmailID: data.data[0]["Inv_PrimaryEmailID"],
              SAASecondaryEmailID: data.data[0]["Inv_SecondaryEmailID"],
              SAAWebsite: data.data[0]["Inv_Website"],
              registrationNumber: data.data[0]["CompanyRegistrationNo"],
              PANCardNo: data.data[0]["PanNo"],
              NameonPANCard: data.data[0]["NameOnPanCard"],
              GSTNo: data.data[0]["GSTNo"],
              TANNumber: data.data[0]["TanNo"],
              UINNumber: data.data[0]["UINNo"],
              ClientID: data.data[0]["ClientID"],
              accountName: data.data[0]["AccountName"],
              accountNo: data.data[0]["AccountNo"],
              accountType: data.data[0]["AccountType"],
              bankName: data.data[0]["BankName"],
              branchName: data.data[0]["BranchName"],
              IFSCCode: data.data[0]["IFSCCode"],
              clientUser: data.data[0]["UserID"],
              EventCordinatorName: data.data[0]["EventCordinatorName"],
              EventCordinatorDesignation:
                data.data[0]["EventCordinatorDesignation"],
              EventCordinatorEmail: data.data[0]["EventCordinatorEmail"],
              EventCordinatorMobile: data.data[0]["EventCordinatorMobile"],
              PrimaryContactName: data.data[0]["PrimaryContactName"],
              PrimaryContactDesignation:
                data.data[0]["PrimaryContactDesignation"],
              PrimaryContactEmail: data.data[0]["PrimaryContactEmail"],
              PrimaryContactMobile: data.data[0]["PrimaryContactMobile"],
            });
            const { countryList, countryId } = this.state;

            if (
              data.data[0]["Telephone"] != null &&
              data.data[0]["Telephone"].includes("-")
            ) {
              const concateData = data.data[0]["Telephone"].split("-");
              this.setState({
                preTel: concateData[0],
                AreaCode: concateData[1],
                TelephoneNumber: concateData[2],
              });
            } else {
              this.setState({ TelephoneNumber: data.data[0]["Telephone"] });
            }

            if (
              data.data[0]["Inv_Telephone"] != null &&
              data.data[0]["Inv_Telephone"].includes("-")
            ) {
              const concateData = data.data[0]["Inv_Telephone"].split("-");
              this.setState({
                SAAPreTel: concateData[0],
                SAAAreaCode: concateData[1],
                SAATelephoneNumber: concateData[2],
              });
            } else {
              this.setState({
                SAATelephoneNumber: data.data[0]["Inv_Telephone"],
              });
            }

            setTimeout(() => {
              countryList.map((itme) => {
                if (itme.Countryid == data.data[0]["CountryID"]) {
                  this.setState({ ISD: itme.ExtensionCode });
                }
                if (itme.Countryid == data.data[0]["Inv_CountryID"]) {
                  this.setState({ SAAISD: itme.ExtensionCode });
                }
              });
              this.getAdditionalServicesList();
              this.getBookingDetails();
            }, 500);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }

    const currencyArr = [...new Set(finalList.map((item) => item.currency))];
    const grandTotal = finalList.reduce(
      (total, item) => total + item.Price?.Total,
      0
    );
    this.setState({ grandTotal });
    if (currencyArr.length === 1) {
      this.setState({ finalCurrency: currencyArr[0] });
    }
  }
  getAdditionalServicesList() {
    const { orderDtlID } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    // this.setState({ isLoading: true })
    this.props
      .get_additional_services_action(OrderID, CenterID)
      .then((data) => {
        if (data.error != 1) {
          if (data.data["externalServices"] != "") {
            data.data["externalServices"].map((item) => {
              if (item.Qty == 0) {
                item.Qty = null;
              }
            });
            this.setState({
              externalServices: data.data["externalServices"],
            });
          }
          if (data.data["additionServices"] != "") {
            this.setState({
              CurrencyID: data.data["additionServices"][0]["CurrencyID"],
            });
          }
          if (data.data["otherData"] != "") {
            this.setState({
              unlistedAddServices: data.data["otherData"][0][
                "UnlistedAddServices"
              ]
                ? data.data["otherData"][0]["UnlistedAddServices"]
                : "",
            });
          }
          if (data.data["includedServices"] != "") {
            this.setState({ includedServices: data.data["includedServices"] });
          }

          for (let i = 0; i < data.data["additionServices"].length; i++) {
            const filterData = data.data["additionServices"].filter(
              (item) => item.Name == data.data["additionServices"][i]["Name"]
            );

            if (filterData.length == 2) {
              data.data["additionServices"][i]["Disabled"] = 2;
            } else {
              data.data["additionServices"][i]["Disabled"] = 1;
            }

            if (filterData.length == 2) {
              filterData.map((item) => {
                if (item.IsSelected == 1) {
                  item.Is_SelectedServiceId = 1;
                }
              });
            }

            let checked = filterData.every((obj) => obj.IsSelected == 0);
            if (checked) {
              data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
            } else {
              if (data.data["additionServices"][i]["ServiceType"] == "S") {
                data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
              }
            }

            data.data["additionServices"].map((item) => {
              if (item.CurrencyID == 1) {
                const electricityFlag =
                  item.Name.split(" ").includes("Electricity");
                if (electricityFlag) {
                  item.Amount =
                    item.Amount != "" && item.Amount != null
                      ? item.Amount
                      : data.PriceInUSD != 0
                        ? data.PriceInUSD * 30
                        : "";
                } else {
                  item.Amount =
                    item.Amount != "" && item.Amount != null
                      ? item.Amount
                      : data.PriceInINR != 0
                        ? data.PriceInINR
                        : "";
                }
              } else {
                const electricityFlag =
                  item.Name.split(" ").includes("Electricity");
                if (electricityFlag) {
                  item.Amount =
                    item.Amount != "" && item.Amount != null
                      ? item.Amount
                      : data.PriceInUSD != 0
                        ? data.PriceInUSD * 30
                        : "";
                } else {
                  item.Amount =
                    item.Amount != "" && item.Amount != null
                      ? item.Amount
                      : data.PriceInINR != 0
                        ? data.PriceInINR
                        : "";
                }
              }
            });
          }

          this.setState({
            additionalServicesList: data.data["additionServices"],
          });
          if (data.data["materialList"] != "") {
            const selectedData = data.data["materialList"].map((item) => ({
              ServiceID: item.ServiceID,
              VendorID: item.VendorID,
              VendorServicesMaterialID: item.VendorServicesMaterialID,
            }));
            this.setState(
              {
                SelectedExtService: selectedData,
              },
              () => {
                this.getpossesionList(selectedData);
                this.getExitList(selectedData);
              }
            );
          } else {
            const filteredServices = data.data["externalServices"].filter(
              (item) => item.IsSelected === 1
            );
            const selectedData = filteredServices.map((item) => ({
              ServiceID: item.ServiceID,
              VendorID: item.VendorID,
              VendorServicesMaterialID: null,
            }));
            // Update the state with the filtered services
            this.setState(
              {
                SelectedExtService: selectedData,
              },
              () => {
                this.getpossesionList(selectedData);
                this.getExitList(selectedData);
              }
            );
          }
          this.setState({ isLoading: false });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getServiceVendorPackageDetail(serviceId, index) {
    const {
      orderDtlID,
      externalServices,
      dummyVendorPackageList,
      maxPrice,
      minPrice,
    } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    this.setState({ isLoading: true });
    this.props
      .getServiceVendorPackageDetail_action(
        CenterID,
        serviceId,
        OrderID,
        minPrice,
        maxPrice
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            var array = [];
            data.data.map((item) => {
              item.index = index;
            });
            array = data.data;
            array.map((item) => {
              dummyVendorPackageList.push(item);
            });

            setTimeout(() => {
              const arrayOfObjects = this.removeDuplicatesFromArray(
                dummyVendorPackageList
              );
              this.setState({ dummyVendorPackageList: arrayOfObjects });

              const newObject = this.calculateFrequencyAndConvert(data.data);
              const array = [];
              data.data.map((item, i) => {
                if (!array.some((obj) => obj.VendorID == item.VendorID)) {
                  array.push({
                    name: item.CompanyName,
                    VendorID: item.VendorID,
                    isCollapsed: false,
                  });
                }
              });

              array.map((item, i) => {
                newObject.map((obj, i) => {
                  if (item.VendorID == obj.VendorID) {
                    item.frequency = newObject[i]["frequency"];
                  }
                });
              });
              if (data.price != "") {
                const priceArray = [];
                priceArray.push(
                  data.price[0]["MinPrice"],
                  data.price[0]["MaxPrice"]
                );

                this.setState({
                  SliderValue: priceArray,
                  minPrice: data.price[0]["MinPrice"],
                  maxPrice: data.price[0]["MaxPrice"],
                });
              }

              this.setState({
                vendorPackageList: data.data,
                vendorNameList: array,
              });
            }, 100);

            this.setState({ indexOfExternalService: index, isLoading: false });
          } else {
            this.setState({
              isLoading: false,
              vendorPackageList: [],
              vendorNameList: [],
            });
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  removeDuplicatesFromArray(arrayOfObjects) {
    // Create a map to store unique combinations of id and index
    let uniqueMap = {};

    // Filter out duplicates based on id and index
    let uniqueArray = arrayOfObjects.filter((obj) => {
      // Create a unique key based on id and index
      let key = obj.VendorID + "-" + obj.index;

      // If the key is not in the map, add it and return true (include in the result)
      if (!uniqueMap[key]) {
        uniqueMap[key] = true;
        return true;
      }

      // If the key is already in the map, return false (exclude from the result)
      return false;
    });

    return uniqueArray;
  }

  checkVendorPackageSelectedOrNot() {
    const { vendorPackageList } = this.state;

    const condition = vendorPackageList.some((item) => item.IsSelected == 1);

    return condition;
  }

  isQuantity(e, index, name) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, "");
    cList.forEach((data, i) => {
      // if (i === index) {
      // data.Quantity = event
      // data.Amount = data.PriceInINR * event

      if (data.Name == name) {
        if (event > 0) {
          data.Quantity = event;
        } else {
          data.Quantity = "";
        }

        this.setState({
          additionalServicesList: cList,
        });
      }

      // }
    });

    this.setState({
      additionalServicesList: cList,
    });
  }
  isAmountQuantity(e, index, name, maxQantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, "");

    const electricityFlag = name.split(" ").includes("Electricity");
    console.log("event electricityFlag", electricityFlag);

    cList.forEach((data, i) => {
      if (data.Name == name) {
        if (event != "") {
          data.Amount = parseInt(event);
        } else {
          data.Amount = 0;
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }
  externalServicesAdditionalRequirement(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value;

    cList.forEach((data, i) => {
      if (i === index) {
        data.AdditionalRequirement = event;
      }
    });

    this.setState({
      externalServices: cList,
    });
  }

  externalServicesQuantity(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value.replace(/\D/, "");

    cList.forEach((data, i) => {
      if (i === index) {
        if (event != "") {
          data.Qty = event;
        } else {
          data.Qty = "";
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
  }

  includedServicesCheckbox(index, IsSelected, e) {
    const { includedServices } = this.state;
    const cList = [...includedServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
        }
      }
    });

    this.setState({
      includedServices: cList,
    });
  }

  externalServicesCheckbox(index, IsSelected, e) {
    const { externalServices } = this.state;
    const cList = [...externalServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
          data.Qty = "";
          data.Package = null;
          data.Price = 0;
          data.PackageID = 0;
          data.VendorName = "";
          data.AdditionalRequirement = "";
          data.VendorID = "";
          this.clearPackageValue();
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
  }
  checkbox(index, IsSelected, e) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.checked;
    cList.forEach((data, i) => {
      if (i === index) {
        const electricityFlag = data.Name.split(" ").includes("Electricity");
        if (data.CurrencyID == 1) {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInINR * 30;
            } else {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInINR;
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        } else {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD * 30;
            } else {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD;
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
  }
  onServicetypechange(e, index, name, Quantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.value;
    var List;

    cList.forEach((data, i) => {
      // if (i === index) {
      if (data.Name == name) {
        if (data.ServiceType == event[0].toString()) {
          data.Is_SelectedServiceId = 1;
          data.IsSelected = 1;
          data.Quantity = Quantity;
          this.setState({
            additionalServicesList: cList,
          });
        } else {
          data.Is_SelectedServiceId = 0;
          data.IsSelected = 0;
          this.setState({
            additionalServicesList: cList,
          });
        }
      }
      // }
    });

    this.setState({
      additionalServicesList: cList,
    });
  }

  handleKeyDown(e) {
    if (e.code === "Enter") {
      this.handleSubmit(e);
    }
  }

  vendorPackageCheckbox(index, IsSelected, e) {
    const {
      vendorPackageList,
      indexOfExternalService,
      externalServices,
      dummyVendorPackageList,
    } = this.state;
    const cList = [...vendorPackageList];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (event) {
          data.IsSelected = 1;
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 1;
            } else {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = data.Package;
              item.Price = data.Rate;
              item.PackageID = data.VendorServicesPackageID;
              item.VendorName = data.VendorName;
              item.CompanyName = data.CompanyName;
              item.VendorID = data.VendorID;
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        } else {
          data.IsSelected = 0;
          data.Description = "";
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = null;
              item.Price = 0;
              item.PackageID = 0;
              item.VendorName = "";
              item.CompanyName = "";
              item.VendorID = "";
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        }
      } else {
        data.IsSelected = 0;
      }
    });
    setTimeout(() => { }, 200);

    this.setState({
      vendorPackageList: cList,
    });
  }

  additionRequirement(item) {
    const { externalServices, addRequirementID } = this.state;
    externalServices.map((data) => {
      if (addRequirementID == data.ServiceID) {
        if (data != "") {
          data.AdditionalRequirement = item;
        } else {
          data.AdditionalRequirement = "";
        }
      }
    });

    this.setState({ externalServices: externalServices });
  }

  onPrice(e, type) {
    const { minPrice, maxPrice } = this.state;
    const event = e.target.value.replace(/\D/, "");
    if (type == "min") {
      if (event <= maxPrice) {
        this.setState({ minPrice: event, SliderValue: [event, maxPrice] });
      }
    } else {
      if (event >= minPrice) {
        this.setState({ maxPrice: event, SliderValue: [minPrice, event] });
      }
    }
  }

  calculateFrequencyAndConvert(data) {
    const frequencyMap = {};
    data.forEach((obj) => {
      const value = obj.VendorID;
      frequencyMap[value] = (frequencyMap[value] || 0) + 1;
    });
    const result = [];
    for (const key in frequencyMap) {
      result.push({ frequency: frequencyMap[key], VendorID: parseInt(key) });
    }

    return result;
  }
  onSliderHandleChange(e, value) {
    const { } = this.state;
    this.setState({ minPrice: value[0], maxPrice: value[1] });
    setTimeout(() => {
      this.onSearchPackage();
    }, 200);
  }

  toggleCollapseAdditionalService(isCollapsed, index) {
    const { vendorNameList } = this.state;

    // const $content = $('#collapseContent');

    vendorNameList.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true;
        } else {
          item.isCollapsed = false;
        }
      }
    });

    this.setState({ vendorNameList: vendorNameList });

    // if (!isCollapsed) {
    //     $content.slideDown();
    // } else {
    //     $content.slideUp();
    // }
  }
  getBookingDetails() {
    const { OrderID } = this.state;
    this.setState({ isLoading: true });
    this.props
      .get_booking_Details_action(OrderID)
      .then((data) => {
        if (data.error != 1) {
          const BookingEventDataList = data.data["tableData"].map((item) => {
            return {
              EventStartDate: item.EventStartDate,
              EventEndDate: item.EventEndDate,
              EventStartTime: item.EventStartTime,
              EventEndTime: item.EventEndTime,
            };
          });

          this.setState({
            TypeOfEvent: data.data["data"][0]["TypeOfEvent"],
            SittingArrangement: data.data["data"][0]["SittingType"],
            bookingList: data.data["tableData"],
            BookingEventDataList: BookingEventDataList,
            // possesion
            PossesionStartDate:
              data.data["tableData"][0]["PossessionStartDate"] != "" &&
                data.data["tableData"][0]["PossessionStartDate"] != null
                ? moment(
                  data.data["tableData"][0]["PossessionStartDate"],
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                : "",
            PossesionEndDate:
              data.data["tableData"][0]["PossessionEndDate"] != "" &&
                data.data["tableData"][0]["PossessionEndDate"] != null
                ? moment(
                  data.data["tableData"][0]["PossessionEndDate"],
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                : "",
            PossesionStartTime:
              data.data["tableData"][0]["PossessionStartTime"] != "" &&
                data.data["tableData"][0]["PossessionStartTime"] != null
                ? data.data["tableData"][0]["PossessionStartTime"]
                : "",
            PossesionEndTime:
              data.data["tableData"][0]["PossessionEndTime"] != "" &&
                data.data["tableData"][0]["PossessionEndTime"] != null
                ? data.data["tableData"][0]["PossessionEndTime"]
                : "",

            // Dismantle
            dismantleStartDate:
              data.data["tableData"][0]["DismentalStartDate"] != "" &&
                data.data["tableData"][0]["DismentalStartDate"] != null
                ? moment(
                  data.data["tableData"][0]["DismentalStartDate"],
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                : "",
            dismantleEndDate:
              data.data["tableData"][0]["DismentalEndDate"] != "" &&
                data.data["tableData"][0]["DismentalEndDate"] != null
                ? moment(
                  data.data["tableData"][0]["DismentalEndDate"],
                  "YYYY-MM-DD"
                ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                : "",
            dismantleStartTime:
              data.data["tableData"][0]["DismentalStartTime"] != "" &&
                data.data["tableData"][0]["DismentalStartTime"] != null
                ? data.data["tableData"][0]["DismentalStartTime"]
                : "",
            dismantleEndTime:
              data.data["tableData"][0]["DismentalEndTime"] != "" &&
                data.data["tableData"][0]["DismentalEndTime"] != null
                ? data.data["tableData"][0]["DismentalEndTime"]
                : "",
          });

          if (
            data.data["data"][0]["SittingTypeID"] != "" &&
            data.data["data"][0]["SittingTypeID"] != null
          ) {
            this.setState({ NoOfPAXFlag: false });
          } else {
            this.setState({ NoOfPAXFlag: true, NoofPAX: "" });
          }

          this.setState({
            MembershipFilePath: data.data["data"][0]["MembershipFilePath"],
          });

          for (let i = 0; i < data.data["tableData"].length; i++) {
            if (data.data["tableData"].length - 1 == i) {
              this.setState({
                LastDate: data.data["tableData"][i]["Date"],
              });

              // this.setState({ LastDate: data.data['recordsets'][1] != '' ? moment(data.data['recordsets'][1][i]['Date']).format('DD-MM-YYYY') : <></> })
            }
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  //Checklist Details
  toggleCollapse(isCollapsed, index) {
    const { possessionMaterialNameAndServiceName } = this.state;

    // const $content = $('#collapseContent');

    possessionMaterialNameAndServiceName.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true;
        } else {
          item.isCollapsed = false;
        }
      } else {
        item.isCollapsed = false;
      }
    });

    this.setState({
      possessionMaterialNameAndServiceName:
        possessionMaterialNameAndServiceName,
    });
  }
  toggleCollapse2(isCollapsed, index) {
    const { exitMaterialNameAndServiceName } = this.state;

    // const $content = $('#collapseContent');

    exitMaterialNameAndServiceName.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true;
        } else {
          item.isCollapsed = false;
        }
      } else {
        item.isCollapsed = false;
      }
    });

    this.setState({
      exitMaterialNameAndServiceName: exitMaterialNameAndServiceName,
    });
  }
  getpossesionList(VendorIdAndServiceIdList) {
    const { userId, OrderID, CenterID, existDataListFlag } = this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    if (OrderID != null) {
      this.props
        .get_possession_list_action(
          CenterID,
          OrderID,
          VendorIdAndServiceIdList != "" ? VendorIdAndServiceIdList : null
        )
        .then((data) => {
          if (data.error !== 1) {
            this.setState({
              isLoading: false,
              possessionIncludedServicesList:
                data.data["possesionIncludedServices"],
              possessionCheckList: data.data["possessionCheckList"],
              PossesionSubmittedUser:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossesionSubmittedUser"]
                  : "",
              PossesionSubmittedDate:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSubmittedDate"]
                  : "",
              possessionTime:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSubmittedDate"]
                  : new Date(
                    new Date().getTime() -
                    new Date().getTimezoneOffset() * 60000
                  ).toISOString(),
              possessionVendorList: data.data["vendorList"],
              electricityPossesion:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionElectricityUnit"]
                  : "",
              PossessionContactNameAndNumber:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionContactNameAndNumber"]
                  : "",
              PosssesionOperationNameContact:
                data.data["data"] != ""
                  ? data.data["data"][0]["PosssesionOpeartionNameContact"]
                  : "",
              PossessionSecurityChecklistNote:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSecurityChecklistNote"]
                  : "",
              possessionConsumableList: data.data["consumableList"],
              possessionSecurityList: data.data["securityList"],
            });
            if (data.data["materialList"] != "") {
              data.data["materialList"].map((item) => {
                item.isCollapsed = false;
              });
              const arrayOfObjects = this.removeDuplicatesFromArray(
                data.data["materialList"]
              );
              this.setState({
                possessionMaterialNameAndServiceName: arrayOfObjects,
                possessionMaterialList: data.data["materialList"],
              });
            }
            if (existDataListFlag) {
              this.setState({
                electricityExit:
                  data.data["data"] != ""
                    ? data.data["data"][0]["PossessionElectricityUnit"]
                    : "",
              });
            }
            data.data["possessionInhouseServices"] != "" ? (
              data.data["possessionInhouseServices"].map((item) => {
                if (item.ServiceType == "S") {
                  this.state.possessionInhouseServicesList.push(item);
                }
              })
            ) : (
              <></>
            );

            if (
              data.data["possessionImg"] != [] &&
              data.data["possessionImg"] != ""
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["possessionImg"];
              this.setState({ possessionSignatureData: dataURL });
              this.setState({
                possessionDataListFlag: true,
                possessionCheckListAllSelected: true,
              });
            }
            if (
              data.data["possessionOppImg"] != [] &&
              data.data["possessionOppImg"] != ""
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["possessionOppImg"];
              this.setState({
                oppPossessionSignatureData: dataURL,
                oppIsSignatureSaved: true,
              });
            }
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toastError(data.msg);
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((err) => {
          console.error(err); // Logging the error for debugging
          this.setState({ isLoading: false });
        });
    } else {
      this.props.navigate("/orders");
    }
  }
  getExitList(VendorIdAndServiceIdList) {
    const { userId, OrderID, CenterID } = this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    if (OrderID != null) {
      this.props
        .get_exist_list_action(
          CenterID,
          OrderID,
          VendorIdAndServiceIdList != "" ? VendorIdAndServiceIdList : null
        )
        .then((data) => {
          if (data.error !== 1) {
            if (data.data["ExitSubmittedUser"] != undefined) {
              this.setState({
                ExitSubmittedUser: data.data["ExitSubmittedUser"],
                ExitSubmittedDate: data.data["ExitSubmittedDate"],
                exitTime: data.data["ExitSubmittedDate"],
              });
            }

            this.setState({
              isLoading: false,
              exitInstructionList: data.data["ExitCheckList"],
              exitVendorList: data.data["VendorList"],
              unlistedAddServices: data.data["ExitRemark"]
                ? data.data["ExitRemark"]
                : "",
              AdditionHours:
                data.data["data"] != ""
                  ? data.data["data"][0]["AdditionHours"]
                  : "",
              electricityExit:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitElectricityUnit"]
                  : "",
              ExitContactNameAndNumber:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitContactNameAndNumber"]
                  : "",
              ExitOperationNameContact:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitOperationNameContact"]
                  : "",

              ExitSecurityChecklistNote:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitSecurityChecklistNote"]
                  : "",
              exitConsumableList: data.data["consumableList"],
              exitSecurityList: data.data["securityList"],
              FinalExitSubmit: data.data?.["data"]?.[0]?.["FinalExitSubmit"] || [],
            });
            if (data.data["materialList"] != "") {
              data.data["materialList"].map((item) => {
                item.isCollapsed = false;
              });
              const arrayOfObjects = this.removeDuplicatesFromArray(
                data.data["materialList"]
              );
              this.setState({
                exitMaterialNameAndServiceName: arrayOfObjects,
                exitMaterialList: data.data["materialList"],
              });
            }

            data.data["ExitIncludedServices"] != "" ? (
              data.data["ExitIncludedServices"].map((item) => {
                if (item.IsSelected == 1) {
                  item.Is_checked = 1;
                } else {
                  item.Is_checked = 0;
                }
              })
            ) : (
              <></>
            );

            this.setState({
              exitIncludedServicesList: data.data["ExitIncludedServices"],
            });

            const list = [];
            data.data["ExitInhouseServices"] != "" ? (
              data.data["ExitInhouseServices"].map((item) => {
                if (item.ServiceType == "S") {
                  if (item.IsSelected == 1) {
                    item.Is_checked = 1;
                  } else {
                    item.Is_checked = 0;
                  }
                  list.push(item);
                }
              })
            ) : (
              <></>
            );
            this.setState({ exitInhouseServicesList: list });

            if (
              data.data["ExitFilePath"] != "" &&
              data.data["ExitFilePath"] != []
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["ExitFilePath"];
              this.setState({
                ExitSignatureData: dataURL,
                isSignatureSaved2: true,
              });
              if (data.data["data"][0]["FinalExitSubmit"]) {
                this.setState({
                  exitCheckListAllSelected: true,
                  existDataListFlag:
                    data.data["ExitFilePath"] != "" ? true : false,
                });
              } else {
                const checked = data.data["ExitCheckList"].every(
                  (item) => item.IsSelected == 1
                );
                if (checked) {
                  this.setState({ exitCheckListAllSelected: true });
                } else {
                  this.setState({ exitCheckListAllSelected: false });
                }
              }
            }
            if (
              data.data["oppExitFilePath"] != "" &&
              data.data["oppExitFilePath"] != []
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["oppExitFilePath"];
              this.setState({
                oppExitSignatureData: dataURL,
                oppIsSignatureSaved2: true,
              });
            }
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/login");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toastError(data.msg);
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((err) => {
          console.error(err); // Logging the error for debugging
          this.setState({ isLoading: false });
        });
    } else {
      this.props.navigate("/orders");
    }
  }
  backToOrders() {
    this.props.navigate("/orders");
  }
  editAdditionalHours(isAdditionalHourAllow, iscancel) {
    const {
      OrderID,
      MyOrdersData,
      AdditionalHours,
      AdditionalHourCharges,
      OvernightCharges,
    } = this.state;
    if (iscancel === true) {
      this.setState({
        isAdditionalHourAllow: true,
        additionalChargesDetails: [],
        AdditionalHours: "",
      });
    } else {
      if (isAdditionalHourAllow === false) {
        const AdditionalHourChargesExtract = MyOrdersData.map((data) =>
          data.additionalChargesData.find(
            (data2) => data2.ChargeHeadName === "Additional Hour Charges"
          )
        );
        const AdditionalHourCharges = AdditionalHours * AdditionalHourChargesExtract?.map((data) => data?.Charges || 0);

        if (AdditionalHours == "" || AdditionalHourCharges == 0) {
          toast.error("Additional Hours cannot be blank", {
            theme: "colored",
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          const Confirmed = window.confirm(
            "Are you sure to Add this Additional Hour?"
          );
          if (Confirmed) {
            this.props
              .update_additional_hour(
                OrderID,
                AdditionalHours,
                AdditionalHourCharges,
                OvernightCharges
              )
              .then((data) => {
                if (data.error !== 1) {
                  this.setState({ isLoading: false }, () => {
                    this.getOrderEditDetails();
                    toast.success("Additional Hour Submitted Successfully", {
                      theme: "colored",
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
          this.setState({
            isAdditionalHourAllow: true,
            additionalChargesDetails: AdditionalHourChargesExtract,
          });
        }
      } else {
        this.setState({
          isAdditionalHourAllow: false,
          additionalChargesDetails: [],
        });
      }
    }
  }
  editOvernightCharges(isOverNightChargesAllow, iscancel) {
    const {
      OrderID,
      MyOrdersData,
      AdditionalHours,
      OvernightCharges,
      AdditionalHourCharges,
    } = this.state;
    if (iscancel === true) {
      this.setState({
        isOverNightChargesAllow: true,
        additionalChargesDetails: [],
        OvernightCharges: "",
      });
    } else {
      if (isOverNightChargesAllow === false) {
        if (OvernightCharges == "" || OvernightCharges == 0) {
          toast.error("Overnight Charges cannot be blank", {
            theme: "colored",
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          const Confirmed = window.confirm(
            "Are you sure to Add this Overnight Charges?"
          );
          if (Confirmed) {
            this.props
              .update_additional_hour(
                OrderID,
                AdditionalHours,
                AdditionalHourCharges,
                OvernightCharges
              )
              .then((data) => {
                if (data.error !== 1) {
                  this.setState({ isLoading: false }, () => {
                    this.getOrderEditDetails();
                    toast.success("Overnight Charges Submitted Successfully", {
                      theme: "colored",
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
          this.setState({
            isOverNightChargesAllow: true,
          });
        }
      } else {
        this.setState({
          isOverNightChargesAllow: false,
          additionalChargesDetails: [],
        });
      }
    }
  }
  updateRentalDiscount(isInsertDiscountAllow, iscancel) {
    const { OrderID, RentalDiscount, DiscountAmountNote } = this.state;
    if (iscancel === true) {
      this.setState({
        isInsertDiscountAllow: true,
        RentalDiscount: "",
      });
    } else {
      if (isInsertDiscountAllow === false) {
        if (RentalDiscount == "") {
          toast.error("Kindly enter Discount", {
            theme: "colored",
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else if (DiscountAmountNote == "") {
          toast.error("Kindly enter Discount Note", {
            theme: "colored",
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          const Confirmed = window.confirm(
            "Are you sure to Add this Discount?"
          );
          if (Confirmed) {
            this.props
              .update_rental_discount(
                OrderID,
                RentalDiscount,
                DiscountAmountNote
              )
              .then((data) => {
                if (data.error !== 1) {
                  this.setState({ isLoading: false }, () => {
                    this.getOrderEditDetails();
                    toast.success("Rental Discount Submitted Successfully", {
                      theme: "colored",
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          }
          this.setState({
            isInsertDiscountAllow: true,
          });
        }
      } else {
        this.setState({
          isInsertDiscountAllow: false,
        });
      }
    }
  }

  isAdditionalHourShowFunction(
    DeliveryStatus,
    additionalChargesData,
    additionalChargesDetails
  ) {
    const { isAdditionalHourAllow, AdditionalHours, Is_NoDue } = this.state;
    if (
      DeliveryStatus === "Incomplete" &&
      DeliveryStatus === "Pending for Verification"
    ) {
      return null;
    } else {
      return (
        <>
          <div
            className="d-flex align-items-center gap-2 text-muted"
            style={{ justifyContent: "space-between" }}
          >
            <div className="width_100 my_color">
              {DeliveryStatus === "Pending for Verification" ? "Insert" : ""}{" "}
              Additional Hours
            </div>
            {DeliveryStatus === "Pending for Verification" ? (
              <div className="my_color row" style={{ width: "15%" }}>
                <div class="col-md-7">
                  <input
                    type="text"
                    class="form-control"
                    value={AdditionalHours}
                    onChange={(e) => {
                      const value = e.target.value;

                      const numericValue = value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1");
                      this.setState({
                        AdditionalHours: numericValue,
                      });
                    }}
                    disabled={isAdditionalHourAllow && Is_NoDue == 0}
                  />
                </div>
                <div class="col-md-5">
                  {Is_NoDue == 0 ? (
                    isAdditionalHourAllow ? (
                      <i
                        className="fa fa-edit action_btn_table"
                        onClick={() =>
                          this.editAdditionalHours(isAdditionalHourAllow, false)
                        }
                      />
                    ) : (
                      <>
                        <i
                          className="fa fa-save action_btn_table"
                          onClick={() =>
                            this.editAdditionalHours(isAdditionalHourAllow, false)
                          }
                        />
                        <i
                          className="fa fa-close action_btn_table"
                          onClick={() =>
                            this.editAdditionalHours(isAdditionalHourAllow, true)
                          }
                        />
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <>
                <h5 className="fs-14 mb-0 my_color">
                  <span className="product-line-price">
                    {parseInt(AdditionalHours, 10)
                      ? parseInt(AdditionalHours, 10).toLocaleString("en-IN")
                      : "0"}
                  </span>
                </h5>
              </>
            )}
          </div>
          <hr />
        </>
      );
    }
  }
  isOvernightShowFunction(
    DeliveryStatus,
    additionalChargesData,
    additionalChargesDetails, currency
  ) {
    const { isOverNightChargesAllow, OvernightCharges, Is_NoDue } = this.state;
    if (
      DeliveryStatus === "Incomplete" &&
      DeliveryStatus === "Pending for Verification"
    ) {
      return null;
    } else {
      return (
        <div
          className="d-flex align-items-center gap-2 text-muted"
          style={{ justifyContent: "space-between", background: "#f1f1f1" }}
        >
          <div className="width_100 my_color">
            {DeliveryStatus === "Pending for Verification" ? "Insert" : ""}{" "}
            Overnight Charges
          </div>
          {DeliveryStatus === "Pending for Verification" ? (
            <div className="my_color row" style={{ width: "15%" }}>
              <div class="col-md-7">
                <input
                  type="text"
                  class="form-control"
                  value={OvernightCharges}
                  onChange={(e) => {
                    const value = e.target.value;

                    const numericValue = value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1");
                    this.setState({
                      OvernightCharges: numericValue,
                    });
                  }}
                  disabled={isOverNightChargesAllow && Is_NoDue == 0}
                />
              </div>
              <div class="col-md-5">
                {Is_NoDue == 0 ? (
                  isOverNightChargesAllow ? (
                    <i
                      className="fa fa-edit action_btn_table"
                      onClick={() =>
                        this.editOvernightCharges(
                          isOverNightChargesAllow,
                          false
                        )
                      }
                    />
                  ) : (
                    <>
                      <i
                        className="fa fa-save action_btn_table"
                        onClick={() =>
                          this.editOvernightCharges(
                            isOverNightChargesAllow,
                            false
                          )
                        }
                      />
                      <i
                        className="fa fa-close action_btn_table"
                        onClick={() =>
                          this.editOvernightCharges(
                            isOverNightChargesAllow,
                            true
                          )
                        }
                      />
                    </>
                  )
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : (
            <>
              <h5 className="fs-14 mb-0 my_color">
                {currency == "INR" ? "₹" : "$"}
                <span className="product-line-price">
                  {parseInt(OvernightCharges, 10)
                    ? parseInt(OvernightCharges, 10).toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                    : "0.00"}
                </span>
              </h5>
            </>
          )}
        </div>
      );
    }
  }

  navigateToMemberShip(ClientID, CenterID, OrderID, OrderNo, clientUser) {
    sessionStorage.removeItem("navAgain");
    sessionStorage.setItem("Is_modify", true);
    sessionStorage.setItem("OrderID", OrderID);
    sessionStorage.setItem("OrderNo", OrderNo);
    sessionStorage.setItem("centerID", CenterID);
    sessionStorage.removeItem("bookArray");
    sessionStorage.removeItem("validationDateList");
    this.props.navigate("/companyInfo", {
      state: {
        isEdit: 1,
        ClientID: ClientID,
        CenterID: CenterID,
        OrderID: OrderID,
        UserID: clientUser,
      },
    });
  }
  navigateToDebitNote(OrderID, ClientID, PrimaryEmailID) {
    this.props.navigate("/debitNoteau", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
        PrimaryEmailID: PrimaryEmailID,
        AddTag: true,
      },
    });
  }
  navigateToCreditNote(OrderID, ClientID, PrimaryEmailID) {
    this.props.navigate("/creditNoteau", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
        PrimaryEmailID: PrimaryEmailID,
        AddTag: true,
      },
    });
  }
  getFollowUpNote = async () => {
    const { userId, OrderID } = this.state;
    this.setState({ isLoading: true });

    this.props
      .get_follow_up_action(userId, OrderID)
      .then((data) => {
        const filteredData = data.data.filter(
          (item) =>
            item.OrderID === this.props.location.state.OrderID || OrderID
        );

        if (filteredData.length > 0) {
          const sortedData = filteredData.sort((a, b) => {
            const dateA = new Date(a.FollowupDate);
            const dateB = new Date(b.FollowupDate);
            return dateB - dateA;
          });

          this.setState({
            followUpList: sortedData,
            isLoading: false,
            currentPage: 1,
          });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({
              followUpList: [], // Clear the followUpList
              isLoading: false,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // search city
  onCitytSearch(e) {
    const {
      cityList,
      tempCityList,
      billTempCityList,
      cityId,
      countryId,
      SameAsAbove,
    } = this.state;
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchCityList = tempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          CityNameErr: "",
          tempCityList: searchCityList,
          isDisplayCityList: true,
        });
      } else {
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempCityList: cityList,
          isDisplayCityList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    } else {
      this.setState({
        cityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayCityList: false,
        CityNameErr: "",
      });
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    }
  }

  // render city
  renderCityList() {
    const { tempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainCityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }

  mainCityListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      cityId: data.CityName,
      isDisplayCityList: false,
      CityNameErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAACityId: data.CityName, SAACityNameErr: "" });
    }
  }
  // same as above search city
  onSAACitytSearch(e) {
    const {
      SAACityList,
      SAAtempCityList,
      billTempCityList,
      cityId,
      SAACountryId,
    } = this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      if (e.target.value != "") {
        var searchCityList = SAAtempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
          SAAtempCityList: searchCityList,
          isSAADisplayCityList: true,
        });
      } else {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAtempCityList: SAACityList,
          isSAADisplayCityList: false,
        });
      }
    } else {
      this.setState({
        SAACityNameErr: "",
        SAACityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayCityList: false,
      });
    }
  }
  // same as above render city
  renderSAACityList() {
    const { SAAtempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {SAAtempCityList.length > 0 &&
          SAAtempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAACityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }
  mainSAACityListData(data) {
    this.setState({
      SAACityId: data.CityName,
      isSAADisplayCityList: false,
      SAACityNameErr: "",
    });
  }
  // search State
  onStateSearch(e) {
    const { stateList, tempStateList, SameAsAbove, countryId } = this.state;
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchStateList = tempStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: searchStateList,
          isDisplayStateList: true,
        });
      } else {
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: stateList,
          isDisplayStateList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    } else {
      this.setState({
        stateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayStateList: false,
        stateErr: "",
      });
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    }
  }
  // render State
  renderStateList() {
    const { tempStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainStateListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      stateId: data.Description,
      isDisplayStateList: false,
      stateErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAAStateId: data.Description, SAAStateErr: "" });
    }
  }
  // same as above search State
  onSAAStateSearch(e) {
    const { SAAStateList, tempSAAStateList, isDisplayStateList, SAACountryId } =
      this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      if (e.target.value != "") {
        var searchStateList = tempSAAStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
          tempSAAStateList: searchStateList,
          isSAADisplayStateList: true,
        });
      } else {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempSAAStateList: SAAStateList,
          isSAADisplayStateList: false,
        });
      }
    } else {
      this.setState({
        SAAStateErr: "",
        SAAStateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayStateList: false,
      });
    }
  }
  //same as above render State
  renderSAAStateList() {
    const { tempSAAStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempSAAStateList.length > 0 &&
          tempSAAStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAAStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainSAAStateListData(data) {
    this.setState({
      SAAStateId: data.Description,
      isSAADisplayStateList: false,
      stateErr: "",
    });
  }
  SameAsAbove(e) {
    const {
      SameAsAbove,
      firstName,
      lastName,
      designation,
      TelephoneNumber,
      addressLine1,
      addressLine2,
      city,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      STD,
      primaryEmailID,
      secondaryEmailID,
      website,
      mobileISD1,
      mobileISD2,
      stateId,
      countryId,
      CityName,
      companyName,
      cityId,
      preTel,
      AreaCode,
    } = this.state;
    this.setState({ SameAsAbove: !SameAsAbove });
    if (!SameAsAbove) {
      this.setState({
        SAAFirstName: firstName,
        SAALastName: lastName,
        SAADesignation: designation,
        SAACompanyName: companyName,
        SAAAddressLine1: addressLine1,
        SAAAddressLine2: addressLine2,
        SAACityId: cityId,
        SAAPincode: pincode,
        SAAMobile1: Mobile1,
        SAAMobile2: Mobile2,
        SAAISD: ISD,
        SAASTD: STD,
        SAAPrimaryEmailID: primaryEmailID,
        SAASecondaryEmailID: secondaryEmailID,
        SAAWebsite: website,
        SAAStateId: stateId,
        SAACountryId: countryId,
        SAATelephoneNumber: TelephoneNumber,
        SAAMobileISD1: mobileISD1,
        SAAMobileISD2: mobileISD2,
        SAAPreTel: preTel,
        SAAAreaCode: AreaCode,
        SAAFirstNameErr: "",
        SAALastNameErr: "",
        SAACompanyNameErr: "",
        SAAAddressLine1Err: "",
        SAACityNameErr: "",
        SAACountryIdErr: "",
        SAAPincodeErr: "",
        SAAMobile1Err: "",
        SAAPrimaryEmailIDErr: "",
        SAAStateErr: "",
      });
    } else {
      this.setState({
        SAAFirstName: "",
        SAALastName: "",
        SAADesignation: "",
        SAACompanyName: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        SAACityId: "",
        SAAPincode: "",
        SAAMobile1: "",
        SAAMobile2: "",
        SAAISD: "",
        SAASTD: "",
        SAAPrimaryEmailID: "",
        SAASecondaryEmailID: "",
        SAAWebsite: "",
        SAAStateId: "",
        SAACountryId: "",
        SAATelephoneNumber: "",
        SAAMobileISD1: "",
        SAAMobileISD2: "",
        SAACityId: "",
        SAAPreTel: "",
      });
    }
  }
  inputValidate() {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,

      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      countryId,
      SAACompanyName,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
    } = this.state;
    if (firstName == "" || firstName == null) {
      this.setState({ firstNameErr: "Please enter first name" });
    }
    if (lastName == "" || lastName == null) {
      this.setState({ lastNameErr: "Please enter last name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ organizerErr: "Please enter organizer name" });
    }
    if (addressLine1 == "" || addressLine1 == null) {
      this.setState({ addressLine1Err: "Please enter address line 1" });
    }
    if (addressLine2 == "" || addressLine2 == null) {
      this.setState({ addressLine2Err: "Please enter address line 2" });
    }
    if (cityId == "" || cityId == null) {
      this.setState({
        CityNameErr: "Please enter city",
        isDisplayCityList: false,
      });
    }
    if (stateId == "" || stateId == null) {
      this.setState({ stateErr: "Please select state" });
    }
    if (countryId == "" || countryId == "Country*" || countryId == null) {
      this.setState({ countryIdErr: "Please select country" });
    }
    if (pincode == "" || pincode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ pincodeErr: "Please enter pincode" });
      } else {
        this.setState({ pincodeErr: "Please enter zipCode" });
      }
    }
    if (Mobile1 == "" || Mobile1 == null) {
      this.setState({ Mobile1Err: "Please enter mobile number" });
    }
    if (primaryEmailID == "" || primaryEmailID == null) {
      this.setState({ primaryEmailIDErr: "Please enter email id" });
    }
    if (SAAFirstName == "" || SAAFirstName == null) {
      this.setState({ SAAFirstNameErr: "Please enter first name" });
    }
    if (SAALastName == "" || SAALastName == null) {
      this.setState({ SAALastNameErr: "Please enter last name" });
    }
    if (SAACompanyName == "" || SAACompanyName == null) {
      this.setState({ SAACompanyNameErr: "Please enter organizer name" });
    }
    if (SAAAddressLine1 == "" || SAAAddressLine1 == null) {
      this.setState({ SAAAddressLine1Err: "Please enter address line 1" });
    }
    if (SAAAddressLine2 == "" || SAAAddressLine2 == null) {
      this.setState({ SAAAddressLine2Err: "Please enter address line 2" });
    }
    if (SAACityId == "" || SAACityId == null) {
      this.setState({
        SAACityNameErr: "Please enter city",
        isSAADisplayCityList: false,
      });
    }
    if (SAAStateId == "" || SAAStateId == null) {
      this.setState({ SAAStateErr: "Please select state" });
    }
    if (
      SAACountryId == "" ||
      SAACountryId == "Country*" ||
      SAACountryId == null
    ) {
      this.setState({ SAACountryIdErr: "Please select country" });
    }
    if (SAAPincode == "" || SAAPincode == null) {
      if (
        SAACountryId == "91" ||
        SAACountryId == "" ||
        SAACountryId == "Country*"
      ) {
        this.setState({ SAAPincodeErr: "Please enter pincode" });
      } else {
        this.setState({ SAAPincodeErr: "Please enter zipCode" });
      }
    }
    if (SAAMobile1 == "" || SAAMobile1 == null) {
      this.setState({ SAAMobile1Err: "Please enter mobile number" });
    }
    if (SAAPrimaryEmailID == "" || SAAPrimaryEmailID == null) {
      this.setState({ SAAPrimaryEmailIDErr: "Please enter email id" });
    }
    if (PANCardNo == "" || PANCardNo == null) {
      this.setState({ PANCardNoErr: "Please enter pancard number" });
    }
    if (NameonPANCard == "" || NameonPANCard == null) {
      this.setState({ NameonPANCardErr: "Please enter name on pancard" });
    }
    if (accountName == "" || accountName == null) {
      this.setState({ accountNameErr: "Please enter account name" });
    }
    if (accountNo == "" || accountNo == null) {
      this.setState({ accountNoErr: "Please enter account number" });
    }
    if (
      accountType == "" ||
      accountType == "Select" ||
      accountType == "Account Type*" ||
      accountType == null
    ) {
      this.setState({ accountTypeErr: "Please select account type" });
    }
    if (bankName == "" || bankName == null) {
      this.setState({ bankNameErr: "Please enter bank name" });
    }
    if (branchName == "" || branchName == null) {
      this.setState({ branchNameErr: "Please enter branch name" });
    }
    if (IFSCCode == "" || IFSCCode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ IFSCCodeErr: "Please enter IFSC code" });
      } else {
        this.setState({ IFSCCodeErr: "Please enter Swift code" });
      }
    }
    // event Cordinator details
    if (EventCordinatorName == "" || EventCordinatorName == null) {
      this.setState({
        EventCordinatorNameErr: "Please enter event cordinator name",
      });
    }
    if (
      EventCordinatorDesignation == "" ||
      EventCordinatorDesignation == null
    ) {
      this.setState({
        EventCordinatorDesignationErr:
          "Please enter event cordinator designation",
      });
    }
    if (EventCordinatorEmail == "" || EventCordinatorEmail == null) {
      this.setState({
        EventCordinatorEmailErr: "Please enter event cordinator email",
      });
    }

    if (EventCordinatorMobile == "" || EventCordinatorMobile == null) {
      this.setState({
        EventCordinatorMobileErr: "Please enter event cordinator mobile no",
      });
    }

    // primary contact details
    if (PrimaryContactName == "" || PrimaryContactName == null) {
      this.setState({
        PrimaryContactNameErr: "Please enter primary contact name",
      });
    }
    if (PrimaryContactDesignation == "" || PrimaryContactDesignation == null) {
      this.setState({
        PrimaryContactDesignationErr:
          "Please enter primary contact designation",
      });
    }
    if (PrimaryContactEmail == "" || PrimaryContactEmail == null) {
      this.setState({
        PrimaryContactEmailErr: "Please enter primary contact email",
      });
    }
    if (PrimaryContactMobile == "" || PrimaryContactMobile == null) {
      this.setState({
        PrimaryContactMobileErr: "Please enter primary contact mobile no",
      });
    }
  }
  onCountryId(e) {
    const { countryList, countryId, SameAsAbove, ISD } = this.state;
    this.setState({ countryId: e.target.value, countryIdErr: "" });

    countryList.map((data) => {
      if (data.Countryid == e.target.value) {
        this.setState({ ISD: data.ExtensionCode });
        if (SameAsAbove) {
          this.setState({ SAAISD: data.ExtensionCode });
        }
      }
    });

    setTimeout(() => {
      if (SameAsAbove) {
        this.setState({
          SAACountryId: e.target.value,
          SAACountryIdErr: "",
        });
        if (e.target.value != 91) {
          this.setState({
            SAAPincode: "",
            SAACityId: "",
            SAAStateId: "",
            SAAAddressLine1: "",
            SAAAddressLine2: "",
          });
        }
      }
    }, 100);

    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    } else {
      this.setState({
        PANCardNo: "",
        PANCardNoErr: "",
        TANNumber: "",
        UINNumber: "",
        GSTNo: "",
        registrationNumber: "",
        NameonPANCard: "",
        NameonPANCardErr: "",
        PANCardNoErr: "",
        NameonPANCardErr: "",
        accountName: "",
        accountNo: "",
        accountType: "",
        bankName: "",
        branchName: "",
        IFSCCode: "",
        accountNameErr: "",
        accountNoErr: "",
        accountTypeErr: "",
        bankNameErr: "",
        branchNameErr: "",
        IFSCCodeErr: "",
      });
    }

    if (e.target.value != 91) {
      this.setState({
        cityId: "",
        stateId: "",
        pincode: "",
        isDisplayStateList: false,
        isDisplayCityList: false,
        addressLine1: "",
        addressLine2: "",
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    } else {
      this.setState({
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    }
  }

  onSAACountryId(e) {
    const { countryList, SAACountryId } = this.state;
    this.setState({ SAACountryId: e.target.value, SAACountryIdErr: "" });
    if (e.target.value != "") {
      countryList.map((data) => {
        if (data.Countryid == e.target.value) {
          setTimeout(() => {
            this.setState({ SAAISD: data.ExtensionCode });
          }, 100);
        } else {
          this.setState({
            SAAISD: "",
          });
        }
      });
    }
    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    }
    if (e.target.value != 91) {
      this.setState({
        SAACityId: "",
        SAAStateId: "",
        SAAPincode: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        isSAADisplayStateList: false,
        isSAADisplayCityList: false,
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    } else {
      this.setState({
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    }
  }
  firstName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      firstName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      firstNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAFirstName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAFirstNameErr: "",
      });
    }
  }

  lastName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      lastName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      lastNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAALastName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAALastNameErr: "",
      });
    }
  }

  designation(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      designation: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
    if (SameAsAbove) {
      this.setState({
        SAADesignation: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      });
    }
  }

  organizerName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      companyName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      organizerErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAACompanyName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAACompanyNameErr: "",
      });
    }
  }

  addressLine1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine1: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine1Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine1: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine1Err: "",
      });
    }
  }

  addressLine2(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine2: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine2Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine2: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine2Err: "",
      });
    }
  }

  pincode(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      pincode: e.target.value.replace(/\D/, ""),
      pincodeErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAPincode: e.target.value.replace(/\D/, ""),
        SAAPincodeErr: "",
      });
    }
  }

  mobile1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      Mobile1: e.target.value.replace(/\D/, ""),
      Mobile1Err: "",
    });
    if (SameAsAbove) {
      this.setState({ SAAMobile1: e.target.value, SAAMobile1Err: "" });
    }
  }

  mobile2(e) {
    const { SameAsAbove } = this.state;
    this.setState({ Mobile2: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAAMobile2: e.target.value });
    }
  }
  preTelephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ preTel: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAPreTel: e.target.value });
    }
  }
  areaCode(e) {
    const { SameAsAbove } = this.state;
    this.setState({ AreaCode: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAAreaCode: e.target.value });
    }
  }
  telephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ TelephoneNumber: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAATelephoneNumber: e.target.value });
    }
  }

  primaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ primaryEmailID: e.target.value, primaryEmailIDErr: "" });
    if (SameAsAbove) {
      this.setState({
        SAAPrimaryEmailID: e.target.value,
        SAAPrimaryEmailIDErr: "",
      });
    }
  }

  secondaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ secondaryEmailID: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAASecondaryEmailID: e.target.value });
    }
  }

  website(e) {
    const { SameAsAbove } = this.state;
    this.setState({ website: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAWebsite: e.target.value });
    }
  }

  clearFields() {
    this.setState({
      ClientID: "",
      FirstName: "",
      LastName: "",
      Designation: "",
      CompanyName: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      Countryid: "",
      Pincode: "",
      Mobile1: "",
      Mobile2: "",
      Telephone: "",
      PrimaryEmailID: "",
      SecondaryEmailID: "",
      Website: "",
      IS_SameAsAbove: "",
      Inv_FirstName: "",
      Inv_LastName: "",
      Inv_Designation: "",
      Inv_CompanyName: "",
      Inv_AddressLine1: "",
      Inv_AddressLine2: "",
      Inv_CityID: "",
      Inv_StateID: "",
      Inv_Countryid: "",
      Inv_Pincode: "",
      Inv_Mobile1: "",
      Inv_Mobile2: "",
      Inv_Telephone: "",
      Inv_PrimaryEmailID: "",
      Inv_SecondaryEmailID: "",
      Inv_Website: "",
      CompanyRegistrationNo: "",
      PanNo: "",
      NameOnPanCard: "",
      GSTNo: "",
      TanNo: "",
      UINNo: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
    });
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  editCompany(event) {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      countryId,
      pincode,
      Mobile1,
      Mobile2,
      TelephoneNumber,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      cityId,
      SAAStateId,
      SAACountryId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAATelephoneNumber,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      SAACityId,
      CityName,
      cityList,
      SAACityName,
      ClientID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      CenterID,
      bookingList,
      SAACompanyName,
      SAAPreTel,
      preTel,
      is_Update_Membership,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      AreaCode,
      SAAAreaCode,
    } = this.state;
    const isEdit =
      this.props.location.state != null &&
        this.props.location.state.isEdit != null
        ? this.props.location.state.isEdit
        : null;

    setTimeout(() => {
      this.inputValidate();
    }, 100);
    if (countryId == "91") {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        addressLine1 != "" &&
        addressLine1 != null &&
        stateId != null &&
        stateId != "" &&
        countryId != "" &&
        countryId != null &&
        countryId == "91" &&
        countryId != "Country*" &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "Country*" &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        PANCardNo != "" &&
        PANCardNo != null &&
        NameonPANCard != "" &&
        NameonPANCard != null &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        var panErrMsg = panNoValidator(PANCardNo);
        var gstErrMsg = gstNoValidator(GSTNo);
        var tanErrMsg = tanNoValidator(TANNumber);
        var pincodeErrMsg = pincodeValidator(pincode);
        var pincodeSaaErrMsg = pincodeValidator(SAAPincode);
        var mobile1ErrMsg = mobileNoValidator(Mobile1);
        var mobile2ErrMsg = notMendetoryMobileNoValidator(Mobile2);
        var SAAMobile1ErrMsg = mobileNoValidator(SAAMobile1);
        var SAAMobile2ErrMsg = notMendetoryMobileNoValidator(SAAMobile2);
        var EventCordinatorMobileErrMsg = mobileNoValidator(
          EventCordinatorMobile
        );
        var PrimaryContactMobileErrMsg =
          mobileNoValidator(PrimaryContactMobile);
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);

        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          panErrMsg != "" ||
          pincodeErrMsg != "" ||
          pincodeSaaErrMsg != "" ||
          mobile1ErrMsg != "" ||
          SAAMobile1ErrMsg != "" ||
          EventCordinatorMobileErrMsg != "" ||
          PrimaryContactMobileErrMsg != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : panErrMsg != ""
                  ? panErrMsg
                  : pincodeErrMsg != ""
                    ? pincodeErrMsg
                    : pincodeSaaErrMsg != ""
                      ? pincodeSaaErrMsg
                      : mobile1ErrMsg != ""
                        ? mobile1ErrMsg
                        : SAAMobile1ErrMsg != ""
                          ? SAAMobile1ErrMsg
                          : EventCordinatorMobileErrMsg != ""
                            ? EventCordinatorMobileErrMsg
                            : PrimaryContactMobileErrMsg != ""
                              ? PrimaryContactMobileErrMsg
                              : EventCordinatorEmailErrMsg != ""
                                ? EventCordinatorEmailErrMsg
                                : PrimaryContactEmailErrMsg != ""
                                  ? PrimaryContactEmailErrMsg
                                  : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (panErrMsg) {
            this.setState({ PANCardNoErr: "Please enter proper PAN No" });
          } else if (pincodeErrMsg) {
            this.setState({ pincodeErr: "Please Enter proper pincode" });
          } else if (pincodeSaaErrMsg) {
            this.setState({ SAAPincodeErr: "Please Enter proper pincode" });
          } else if (mobile1ErrMsg) {
            this.setState({ Mobile1Err: "Please Enter proper mobile number" });
          } else if (SAAMobile1ErrMsg) {
            this.setState({
              SAAMobile1Err: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorMobileErrMsg) {
            this.setState({
              EventCordinatorMobileErr: "Please Enter proper mobile number",
            });
          } else if (PrimaryContactMobileErrMsg) {
            this.setState({
              PrimaryContactMobileErr: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        } else if (
          gstErrMsg != "" ||
          tanErrMsg != "" ||
          errMsg2 != "" ||
          errMsg4 != "" ||
          mobile2ErrMsg != "" ||
          SAAMobile2ErrMsg != ""
        ) {
          toast.error(
            gstErrMsg != ""
              ? gstErrMsg
              : tanErrMsg != ""
                ? tanErrMsg
                : errMsg2 != ""
                  ? errMsg2
                  : errMsg4 != ""
                    ? errMsg4
                    : mobile2ErrMsg != ""
                      ? mobile2ErrMsg
                      : SAAMobile2ErrMsg != ""
                        ? SAAMobile2ErrMsg
                        : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );
        } else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });

            this.props
              .client_add_action(
                ClientID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != "" &&
                  TelephoneNumber != null &&
                  preTel != "" &&
                  preTel != null
                  ? preTel + "-" + TelephoneNumber
                  : TelephoneNumber,
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != "" &&
                  SAATelephoneNumber != null &&
                  SAAPreTel != "" &&
                  SAAPreTel != null
                  ? SAAPreTel + "-" + SAATelephoneNumber
                  : SAATelephoneNumber,
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile,
                1
              )
              .then((data) => {
                if (data.error != 1) {
                  this.setState({ isLoading: false, isEditMode: true });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error(
              "Provide Different Contact Number for Event Coordinator!",
              {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              }
            );
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    } else {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        countryId != "" &&
        countryId != null &&
        countryId != "Country*" &&
        stateId != null &&
        stateId != "" &&
        addressLine1 != "" &&
        addressLine1 != null &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "" &&
        SAACountryId != "Country*" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);
        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : EventCordinatorEmailErrMsg != ""
                  ? EventCordinatorEmailErrMsg
                  : PrimaryContactEmailErrMsg != ""
                    ? PrimaryContactEmailErrMsg
                    : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        }
        // else if (errMsg2 != '' || errMsg4 != '' || mobile2ErrMsg != '' || SAAMobile2ErrMsg != '') {

        //     toast.error(
        //         errMsg2 != '' ? errMsg2 :
        //             errMsg4 != '' ? errMsg4 :
        //                 mobile2ErrMsg != '' ? mobile2ErrMsg :
        //                     SAAMobile2ErrMsg != '' ? SAAMobile2ErrMsg :
        //                         '',
        //         {
        //             position: "top-center",
        //             theme: 'colored',
        //             autoClose: 1000,
        //             hideProgressBar: true,
        //         })

        // }
        else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });
            this.props
              .client_add_action(
                ClientID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != "" &&
                TelephoneNumber != null &&
                (AreaCode != "" && preTel != ""
                  ? preTel + "-" + AreaCode + "-" + TelephoneNumber
                  : preTel != ""
                    ? preTel + "-" + TelephoneNumber
                    : TelephoneNumber),
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != "" &&
                SAATelephoneNumber != null &&
                (SAAAreaCode != "" && SAAPreTel != ""
                  ? SAAPreTel + "-" + SAAAreaCode + "-" + TelephoneNumber
                  : SAAPreTel != ""
                    ? preTel + "-" + SAATelephoneNumber
                    : SAATelephoneNumber),
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile,
                1
              )
              .then((data) => {
                if (data.error != 1) {
                  this.setState({ isLoading: false, isEditMode: true });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error("MobileNo can not be same!", {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            });
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    }
  }
  CompanyEditTrue() {
    const { isEditMode } = this.state;
    this.setState({ isEditMode: false });
  }
  CompanyEditFalse() {
    const { isEditMode } = this.state;
    this.setState({ isEditMode: true });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  //Add Additional Services part

  isQuantity(e, index, name, maxQantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, "");

    const electricityFlag = name.split(" ").includes("Electricity");
    cList.forEach((data, i) => {
      if (data.Name == name) {
        if (data.CurrencyID == 1) {
          if (event > 0) {
            if (maxQantity >= event) {
              if (electricityFlag) {
                data.Quantity = event;
                data.Amount = data.PriceInINR * 30 * event;
              } else {
                data.Quantity = event;
                data.Amount = data.PriceInINR * event;
              }
            } else {
              toastError(`Max Qantity is ${maxQantity}`);
              data.Amount = data.PriceInINR;
              data.Quantity = "";
            }
          } else {
            if (electricityFlag) {
              data.Quantity = "";
              data.Amount = data.PriceInINR * 30;
            } else {
              data.Quantity = "";
              data.Amount = data.PriceInINR;
            }
          }
        } else {
          if (event > 0) {
            if (maxQantity >= event) {
              if (electricityFlag) {
                data.Quantity = event;
                data.Amount = data.PriceInUSD * 30 * event;
              } else {
                data.Quantity = event;
                data.Amount = data.PriceInUSD * event;
              }
            } else {
              toastError(`Max Qantity is ${maxQantity}`);
              data.Amount = data.PriceInUSD;
              data.Quantity = "";
            }
          } else {
            if (electricityFlag) {
              data.Quantity = "";
              data.Amount = data.PriceInUSD * 30;
            } else {
              data.Quantity = "";
              data.Amount = data.PriceInUSD;
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
  }

  externalServicesDescription(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value;

    cList.forEach((data, i) => {
      if (i === index) {
        data.Description = event;
      }
    });

    this.setState({
      externalServices: cList,
    });
  }
  externalVendor(e, i) {
    const { externalServices } = this.state;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedVendorID = selectedOption.value;
    const selectedVendorName = selectedOption.text;

    const updatedExternalServices = externalServices.map((data, index) => {
      if (i === index) {
        return {
          ...data,
          VendorID: selectedVendorID,
          VendorName: selectedVendorName,
        };
      }
      return data;
    });

    this.setState({ externalServices: updatedExternalServices });
  }

  includedServicesCheckbox(index, IsSelected, e) {
    const { includedServices } = this.state;
    const cList = [...includedServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
        }
      }
    });

    this.setState({
      includedServices: cList,
    });
  }
  externalServicesCheckbox(index, IsSelected, e) {
    const { externalServices } = this.state;
    const cList = [...externalServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected === 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
          // Reset the vendor ID and name when the checkbox is unchecked
          data.VendorID = "";
          data.VendorName = "";
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
  }
  checkbox(index, IsSelected, e) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.checked;
    cList.forEach((data, i) => {
      if (i === index) {
        const electricityFlag = data.Name.split(" ").includes("Electricity");
        if (data.CurrencyID == 1) {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              if (data.Name != "Event Services") {
                data.Quantity = 1;
              }
              data.Amount = data.PriceInINR != 0 ? data.PriceInINR * 30 : "";
            } else {
              data.IsSelected = 1;
              if (data.Name != "Event Services") {
                data.Quantity = 1;
              }
              data.Amount = data.PriceInINR != 0 ? data.PriceInINR : "";
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        } else {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD != 0 ? data.PriceInUSD * 30 : "";
            } else {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD != 0 ? data.PriceInUSD : "";
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX checkboxFlag XXXXXXX", cList);
  }
  onServicetypechange(e, index, name, Quantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.value;
    var List;

    cList.forEach((data, i) => {
      // if (i === index) {
      if (data.Name == name) {
        if (data.ServiceType == event[0].toString()) {
          data.Is_SelectedServiceId = 1;
          data.IsSelected = 1;
          data.Quantity = Quantity;
          this.setState({
            additionalServicesList: cList,
          });
        } else {
          data.Is_SelectedServiceId = 0;
          data.IsSelected = 0;
          this.setState({
            additionalServicesList: cList,
          });
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
  }


  handleOrderApproval(Is_Approved) {
    const {
      RejectReasonID,
      RejectionNote,
      RejectReason,
      rejectionReasonList,
      OrderID,
      OrderNo,
      primaryEmailID,
      companyName,
      isAdditionalHourAllow,
      MyOrdersData,
    } = this.state;

    if (isAdditionalHourAllow) {
      let confirmed;
      if (Is_Approved === 1) {
        confirmed = window.confirm(
          "Are you sure you want to Confirm this Order?"
        );
      } else {
        confirmed = window.confirm(
          "Are you sure you want to Reject this Order?"
        );
      }

      let isProformaInsert;

      if (
        MyOrdersData.every(
          (data) =>
            data.proformaDetails != "" && data.proformaDetails.length > 0
        )
      ) {
        isProformaInsert = false;
      } else {
        isProformaInsert = true;
      }
      var AsAmount;
      MyOrdersData.map((data) => (AsAmount = data.Price.ServiceTotal));

      if (confirmed) {
        this.setState({ isLoading: true });
        this.props
          .order_approval_action(
            OrderID,
            Is_Approved,
            RejectReasonID,
            RejectReason,
            RejectionNote,
            OrderNo,
            companyName,
            primaryEmailID,
            AsAmount,
            isProformaInsert
          )
          .then((data) => {
            this.setState({ isLoading: false });

            if (data.error !== 1) {
              if (Is_Approved == 1) {
                const url = BASE_URL.split("/api")[0];
                const structurePath = data.data.filePath.replace('./', '/');
                const piFilePath = `${url}${structurePath}`;
                this.setState({ piSendShow: true, piFilePath: piFilePath, PiType: "Order" }, () => {

                  this.openSendPiModal(
                    "Order",
                    data.data[0].ProformaInvoiceID,
                    data.data[0].ProformaInvoice_No,
                    data.data[0].OrderID, piFilePath, OrderNo
                  );
                })
              }
              const message =
                Is_Approved === 1
                  ? "Order Confirmed Successfully"
                  : "Order Rejected Successfully";
              toast.success(message, {
                theme: "colored",
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
              });
              // this.getOrderEditDetails();
            } else {
              if (
                data.msg === sessionExpireMessage ||
                data.msg === tokenInavlidMessage
              ) {
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }, 500);
              } else {
                toast.error(data.msg, {
                  theme: "colored",
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
          });
      } else {
        window.location.reload();
      }
    } else {
      toast.error("Kindly check and save the Additional Hours", {
        theme: "colored",
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
      });
    }
  }

  handleOrderAdditionalServiceApproval() {
    const {
      OrderNo,
      additionalServicesList,
      orderDtlID,
      submitOrApproveAdditional,
      unlistedAddServices,
      OtherInformation,
      externalServices,
      companyName,
      primaryEmailID,
      MyOrdersData,
    } = this.state;
    this.setState({ isLoading: false });
    const { CenterID, OrderID, ClientID } = this.state;
    const externalNewArray = [];
    if (externalServices != "") {
      externalServices.map((item) => {
        if (item.IsSelected == 1) {
          externalNewArray.push(item);
        }
      });
    }
    var externalServicesCondition = externalNewArray.every(
      (item) => item.Package != null
    );

    const newArray = [];

    additionalServicesList.map((data, i) => {
      // data.Amount == null ? data.Quantity*data.PriceInINR
      if (data.IsSelected == 1) {
        newArray.push(
          data.CurrencyID != 2
            ? {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Price: data.PriceInINR,
              Quantity: data.Quantity != "" ? data.Quantity : 1,
              Amount: data.Amount,
            }
            : {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Price: data.PriceInUSD,
              Quantity: data.Quantity != "" ? data.Quantity : 1,
              Amount: data.Amount,
            }
        );
      }
    });
    const AsAmount = additionalServicesList
      .filter((data) => data.IsSelected == 1)
      .reduce((sum, data) => sum + (data.Amount || 0), 0);

    let isProformaInsert;

    if (
      MyOrdersData.every(
        (data) => data.proformaDetails != "" && data.proformaDetails.length > 0
      )
    ) {
      isProformaInsert = false;
    } else {
      isProformaInsert = true;
    }
    const externalServicesNewArray = [];

    externalServices.map((data, i) => {
      // data.Amount == null ? data.Quantity*data.PriceInINR
      if (data.IsSelected == 1) {
        externalServicesNewArray.push({
          CenterServiceID: data.CenterServicesID,
          Service: data.Service,
          VendorservicepackageID: data.PackageID,
          Price: 0,
          Qty: 0,
          AdditionalRequirement: data.AdditionalRequirement,
          ServiceID: data.ServiceID,
          VendorID: data.VendorID,
        });
      }
    });
    const VendorMailData = [];
    externalServices.map((data, i) => {
      if (data.IsSelected == 1) {
        VendorMailData.push({
          Service: data.Service,
          VendorEmailID: data.VendorEmailID,
          VendorName: data.VendorName,
          OrderNo: OrderNo,
        });
      }
    });
    var UnlistedAddServices =
      unlistedAddServices != null ||
        unlistedAddServices != "" ||
        unlistedAddServices != []
        ? unlistedAddServices.toString()
        : "";
    if (externalServicesCondition) {
      this.props
        .update_additional_service_approval_action(
          OrderID,
          OrderNo,
          companyName,
          primaryEmailID,
          orderDtlID,
          CenterID,
          1,
          UnlistedAddServices,
          OtherInformation,
          newArray,
          externalServicesNewArray,
          AsAmount,
          isProformaInsert,
          VendorMailData
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isLoading: false });
            const url = BASE_URL.split("/api")[0];
            const structurePath = data.data.filePath.replace('./', '/');
            const piFilePath = `${url}${structurePath}`;
            this.setState({ piSendShow: true, piFilePath: piFilePath, PiType: "Additional" }, () => {

              this.openSendPiModal(
                "Additional",
                data.data[0].ProformaInvoiceID,
                data.data[0].ProformaInvoice_No,
                data.data[0].OrderID, piFilePath, OrderNo
              );
            })
            setTimeout(() => {
              toast.success("Services Submitted Successfully", {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      this.setState({ isLoading: false });
      toastError("Please select package of additional vendor services");
    }
  }
  openSendPiModal(PiType, ProformaInvoiceID, ProformaInvoice_No, OrderID, filePath, OrderNo) {
    console.log("sendPi", PiType, ProformaInvoiceID, ProformaInvoice_No, OrderID, filePath, OrderNo)
    // const url = BASE_URL.split("/api")[0];
    // const structurePath = filePath[0].replace('./', '/');
    // const FilePath = `${url}${structurePath}`;
    // console.log(url, filePath,structurePath, FilePath,'path') 
    this.setState({
      piSendShow: true, PiType: PiType, ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No, OrderID: OrderID, piFilePath: filePath, OrderNo: OrderNo
    })
  }
  sendPIMail(PiType, OrderID, OrderNo, companyName, primaryEmailID, ProformaInvoiceID, ProformaInvoice_No) {
    const { externalServices } = this.state;
    this.setState({ isLoading: true })
    var VendorMailData = [];
    if (PiType == 'Order') {
      VendorMailData = []
    } else {
      externalServices.map((data, i) => {
        if (data.IsSelected == 1) {
          VendorMailData.push({
            Service: data.Service,
            VendorEmailID: data.VendorEmailID,
            VendorName: data.VendorName,
            OrderNo: OrderNo,
          });
        }
      });
    }
    this.props.send_approval_pi_mail_action(PiType, OrderID, OrderNo, companyName, primaryEmailID, ProformaInvoiceID, ProformaInvoice_No, VendorMailData)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false, piSendShow: false });
          setTimeout(() => {
            toast.success("Proforma Sent Successfully", {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }, 500);
          this.getOrderEditDetails();
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
  }

  rejectModalShow() {
    this.setState({
      rejectShow: true,
    });
  }
  rejectModalClose() {
    this.setState({ rejectShow: false });
  }
  deleteModalShow(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    RoleID,
    OrderAmount,
    BookingDate,
    CancellationReasonID,
    cancelNote,
    DeliveryStatus
  ) {
    const { ConvenienceFee, RefundAmount } = this.state;

    if (DeliveryStatus == "confirmed") {
      this.setState({
        deleteShow: true,
        OrderID: OrderID,
        OrderNo: OrderNo,
        CompanyName: CompanyName,
        PrimaryEmailID: PrimaryEmailID,
        RoleID: RoleID,
        OrderAmount: OrderAmount,
        BookingDate: BookingDate,
        CancellationReasonID: CancellationReasonID,
        cancelNote: cancelNote,
        DeliveryStatus: DeliveryStatus,
      });

      // Check if BookingDate is null or empty
      if (!BookingDate || BookingDate.trim() === "") {
        BookingDate = null; // Set BookingDate to null if it's empty
      } else {
        // Split the BookingDate string into an array of individual date strings
        const dateStrings = BookingDate.split(",");

        // Parse the date strings and find the most recent date
        let mostRecentDate = null;
        for (const dateString of dateStrings) {
          const [day, month, year] = dateString.trim().split("/");
          const bookingDate = new Date(`${year}-${month}-${day}`);
          if (!mostRecentDate || bookingDate > mostRecentDate) {
            mostRecentDate = bookingDate;
          }
        }

        // Calculate deduction and finalAmount based on the most recent date
        let deduction = 0;
        let finalAmount = OrderAmount;
        const today = new Date();
        const timeDifference = mostRecentDate - today;
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        if (daysDifference > 15) {
          deduction = 0; // No deduction
        } else if (daysDifference <= 15 && daysDifference > 10) {
          deduction = OrderAmount * 0.25;
          finalAmount -= deduction;
        } else if (daysDifference <= 10 && daysDifference > 5) {
          deduction = OrderAmount * 0.75;
          finalAmount -= deduction;
        } else {
          deduction = OrderAmount;
          finalAmount = 0;
        }

        this.setState({
          BookingDate: mostRecentDate, // Set BookingDate to the most recent date
          ConvenienceFee: deduction.toLocaleString("en-IN"), // Set ConvenienceFee to deduction
          RefundAmount: finalAmount.toLocaleString("en-IN"), // Set RefundAmount to finalAmount
        });
      }
    } else {
      this.setState({
        deleteShow: true,
        OrderID: OrderID,
        OrderNo: OrderNo,
        CompanyName: CompanyName,
        PrimaryEmailID: PrimaryEmailID,
        RoleID: RoleID,
        DeliveryStatus: DeliveryStatus,
      });
    }
  }
  deleteModalClose() {
    this.setState({ deleteShow: false, AdminRemark: "" });
  }
  followUpModalShow(OrderID, OrderNo) {
    this.setState({
      followUpShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
    });
  }
  followUpModalClose() {
    this.setState({ followUpShow: false });
  }

  toggleFollowInfoCollapse = () => {
    this.setState((prevState) => ({
      followInfoCollapse: !prevState.followInfoCollapse,
    }));
  };
  followUpSubmit() {
    const { userId, OrderID, Note } = this.state;

    this.setState({ isLoading: true });
    this.props
      .follow_up_add_action(userId, OrderID, Note)
      .then((data) => {
        if (data !== 1) {
          this.setState({ isLoading: false });
          this.getFollowUpNote();
          this.followUpModalClose();
          toast.success("Status submitted Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  piModalShow(OrderID, OrderNo, proformaList) {
    this.setState({
      PiShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      proformaList: proformaList,
    });
  }
  piModalClose() {
    this.setState({ PiShow: false });
  }
  isProformaDownload() {
    const { StatusID } = this.state
    console.log("StatusID", StatusID)
    if (StatusID >= 11) {
      return true;
    }
    return false;
  }
  IsCancelledButton(DeliveryStatus, PossesionSubmittedUser) {
    var isPosSubmitted;
    if (PossesionSubmittedUser == "") {
      isPosSubmitted = 0;
    } else {
      isPosSubmitted = 1;
    }
    if (
      DeliveryStatus === "Cancelled" ||
      DeliveryStatus === "Delivered" ||
      DeliveryStatus === "Rejected" ||
      isPosSubmitted == 1
    ) {
      return false;
    }
    return true;
  }
  IsFollowButton(DeliveryStatus) {
    if (DeliveryStatus === "Cancelled" || DeliveryStatus === "Delivered") {
      return false;
    }
    return true;
  }
  isApproved(DeliveryStatus) {
    if (DeliveryStatus === "Pending for Verification") {
      return true;
    }
    return false;
  }
  isSendPi(DeliveryStatus) {
    if (DeliveryStatus === "Approved" || DeliveryStatus === "Confirmed") {
      return true;
    }
    return false;
  }
  isGenerateReceipt(DeliveryStatus, AdditionalServiceApprovalStatus) {
    if (DeliveryStatus === "Approved" || DeliveryStatus === "Confirmed") {
      return true;
    } else {
      return false;
    }
  }
  navigateReceipt(ClientID, OrderID, CenterID) {
    this.props.navigate("/accountReceiptsAU", {
      state: {
        ClientID: ClientID,
        OrderID: OrderID,
        CenterID: CenterID,
        adminReceipt: true,
      },
    });
  }
  editModalShow(
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit,
    ClientID
  ) {
    this.setState({
      editShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      StatusID: StatusID,
      CenterID: CenterID,
      BookingDate: BookingDate,
      isEdit: isEdit,
      ClientID: ClientID,
    });
  }
  editModalClose() {
    this.setState({ editShow: false, isModifyEdit: false });
  }
  AgreeModification = (
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit = 1,
    ClientID,
    navAction
  ) => {
    if (StatusID == 11 || StatusID == 12 || StatusID == 16 || StatusID == 17) {
      this.setState({ isModifyEdit: true });
    } else {
      if (
        StatusID === 1 ||
        StatusID === 2 ||
        StatusID === 3 ||
        StatusID === 4
      ) {
        this.props.navigate("");
      } else if (StatusID === 5) {
        this.props.navigate("/companyInfo", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 6) {
        this.props.navigate("/BookingDetails", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 7) {
        this.props.navigate("/additionalServices", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 8) {
        this.props.navigate("/termsAndConditons", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 9) {
        this.props.navigate("/summary", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else if (StatusID === 10 || StatusID === 13) {
        this.props.navigate("/cart", {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            ClientID: ClientID,
          },
        });
      } else {
        this.props.navigate("");
      }
    }
  };
  IsModifyButton(
    Is_NoDue,
    DeliveryStatus,
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    ClientID
  ) {
    if (Is_NoDue == 0) {
      return (
        <>
          <a
            href="javascript:void(0);"
            onClick={() =>
              this.editModalShow(
                OrderID,
                OrderNo,
                StatusID,
                CenterID,
                BookingDate,
                1,
                ClientID
              )
            }
            className="btn btn-success my_custom_orderPage_btns m-2"
          >
            Modify Order
          </a>
        </>
      );
    } else {
      return false;
    }
  }
  onEditNavigate = (
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate,
    isEdit = 1,
    ClientID,
    navAction
  ) => {
    if (
      StatusID === 11 ||
      StatusID === 12 ||
      StatusID === 16 ||
      StatusID === 17
    ) {
      sessionStorage.removeItem("navAgain");
      sessionStorage.setItem("Is_modify", true);
      sessionStorage.setItem("OrderID", OrderID);
      sessionStorage.setItem("OrderNo", OrderNo);
      sessionStorage.setItem("centerID", CenterID);
      sessionStorage.setItem("ClientID", ClientID);
      sessionStorage.removeItem("bookArray");
      sessionStorage.removeItem("validationDateList");
      this.props.navigate(
        navAction == 1
          ? "/calenderView"
          : navAction == 2
            ? "/companyInfo"
            : navAction == 3
              ? "/BookingDetails"
              : navAction == 4
                ? "/additionalServices"
                : navAction == 5
                  ? "/termsAndConditons"
                  : navAction == 6
                    ? "/summary"
                    : "",
        {
          state: {
            OrderID: OrderID,
            OrderNo: OrderNo,
            StatusID: StatusID,
            CenterID: CenterID,
            BookingDate: BookingDate,
            isEdit: isEdit,
            ClientID: ClientID,
          },
        }
      );
    }
  };

  isCreditDebit(DeliveryStatus) {
    if (DeliveryStatus === "Confirmed") {
      return true;
    }
    return false;
  }
  isExitPass(
    Is_ExitPass,
    DeliveryStatus,
    ExitSubmittedDate,
    ExitPassBy,
    IsExitPassDate
  ) {
    const { MyOrdersData, OrderID, OrderNo, primaryEmailID, companyName } =
      this.state;
    var isExiSubmitted;
    if (ExitSubmittedDate == "") {
      isExiSubmitted = 0;
    } else {
      isExiSubmitted = 1;
    }
    if (
      ((Is_ExitPass === 0 || Is_ExitPass === 1) &&
        DeliveryStatus === "Cancelled") ||
      DeliveryStatus === "Incomplete" ||
      DeliveryStatus === "Pending for Verification"
    ) {
      return null;
    } else if (
      Is_ExitPass == 0 &&
      DeliveryStatus === "Confirmed" &&
      isExiSubmitted == 1
    ) {
      return (
        <a
          href="javascript:void(0);"
          className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
          onClick={() =>
            this.updateExitPass(
              this.props.location.state.OrderID ||
              MyOrdersData.map((data) => data.OrderID).join(""),
              this.props.location.state.OrderNo ||
              MyOrdersData.map((data) => data.OrderNo).join(""),
              this.props.location.state.CompanyName || companyName,
              this.props.location.state.PrimaryEmailID || primaryEmailID,
              MyOrdersData.map((data) => data.UUID).join("")
            )
          }
        >
          Generate Exit Pass
        </a>
      );
    } else if (
      (Is_ExitPass == 1 &&
        isExiSubmitted == 1 &&
        DeliveryStatus === "Confirmed") ||
      DeliveryStatus === "Delivered"
    ) {
      return (
        <a
          href="javascript:void(0);"
          className="make_paymentLink m-2"
          onClick={() =>
            this.downloadExitPass(
              this.props.location.state.OrderID ||
              MyOrdersData.map((data) => data.OrderID).join(""),
              this.props.location.state.OrderNo ||
              MyOrdersData.map((data) => data.OrderNo).join("")
            )
          }
        >
          <i className="fa fa-download" /> Exit Pass
          {/* <span>Generated By: {ExitPassBy}</span>
          <span>
            {moment(IsExitPassDate).utc().format("DD/MM/YYYY - hh:mm:ss")}
          </span> */}
        </a>
      );
    } else {
      return null;
    }
  }

  IsEventClosure(Is_Closure, DeliveryStatus) {
    if (Is_Closure === 1 && DeliveryStatus === "Confirmed") {
      return (
        <a
          href="javascript:void(0);"
          aria-disabled
          className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
        >
          Event Closure
        </a>
      ); // Hide both buttons if Is_Closure is false or DeliveryStatus is "Cancelled"
    }
    return null;
  }
  isFollowupCollapse(DeliveryStatus) {
    if (
      DeliveryStatus === "Incomplete" ||
      DeliveryStatus === "Approved" ||
      DeliveryStatus === "Cancellation Request"
    ) {
      return true; // Hide both buttons if Is_ExitPass is false or DeliveryStatus is "Cancelled"
    }
    return false;
  }
  isCancelCollapse(DeliveryStatus) {
    if (DeliveryStatus === "Cancelled") {
      return true; // Hide both buttons if Is_ExitPass is false or DeliveryStatus is "Cancelled"
    }
    return false;
  }
  isRejectCollapse(DeliveryStatus) {
    if (DeliveryStatus === "Rejected") {
      return true;
    }
    return false;
  }
  IsAddAdditionalServices(DeliveryStatus, paymentStatus) {
    if (
      DeliveryStatus === "Confirmed" ||
      DeliveryStatus === "Delivered" ||
      DeliveryStatus === "Approved" ||
      DeliveryStatus === "Pending for Verification"
    ) {
      return true;
    }
    return false;
  }

  editAdditionalDiscount(isAdditionalDiscountAllow, iscancel) {
    const { OrderID, AdditionalDiscount, AdditionalDiscountNote } = this.state;
    if (iscancel === true) {
      this.setState({
        isAdditionalDiscountAllow: true,
        AdditionalDiscount: "",
        AdditionalDiscountNote: "",
      });
    } else {
      if (isAdditionalDiscountAllow === false) {
        if (AdditionalDiscount == "") {
          toast.error("Please Enter Discount Amount", {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          });
        } else if (AdditionalDiscountNote == "") {
          toast.error("Please Enter Discount Amount Note", {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          });
        } else {
          const Confirmed = window.confirm(
            "Are you sure to Add this Additional Discount?"
          );
          if (Confirmed) {
            this.props
              .update_additional_discount(
                OrderID,
                AdditionalDiscount,
                AdditionalDiscountNote
              )
              .then((data) => {
                if (data.error !== 1) {
                  this.setState(
                    {
                      isAdditionalDiscountAllow: true,
                    },
                    () => {
                      this.getOrderEditDetails();
                      toast.success(
                        "Additional Discount Submitted Successfully",
                        {
                          position: "top-center",
                          theme: "colored",
                          autoClose: 1000,
                          hideProgressBar: true,
                        }
                      );
                    }
                  );
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 1000,
                      hideProgressBar: true,
                    });
                  }
                }
              });
          }
        }
      } else {
        this.setState({
          isAdditionalDiscountAllow: false,
        });
      }
    }
  }
  editSecurityDeposit(isSDAllow, iscancel) {
    const { OrderID, SecurityDeposit, SecurityDepositRemark } = this.state;
    if (iscancel === true) {
      this.setState({
        isSDAllow: true,
        SecurityDeposit: "",
        SecurityDepositRemark: "",
      });
    } else {
      if (isSDAllow === false) {
        if (SecurityDeposit == "") {
          toast.error("Please Enter Security Deposit", {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          });
        } else if (SecurityDepositRemark == "") {
          toast.error("Please Enter Security Deposit Remark", {
            position: "top-center",
            theme: "colored",
            autoClose: 1000,
            hideProgressBar: true,
          });
        } else {
          const Confirmed = window.confirm(
            "Are you sure to Update this Security Deposit?"
          );
          if (Confirmed) {
            this.props
              .update_security_deposit(
                OrderID,
                SecurityDeposit,
                SecurityDepositRemark
              )
              .then((data) => {
                if (data.error !== 1) {
                  this.setState(
                    {
                      isSDAllow: true,
                    },
                    () => {
                      this.getOrderEditDetails();
                      toast.success("Security Deposit Updated Successfully", {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 1000,
                        hideProgressBar: true,
                      });
                    }
                  );
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 1000,
                      hideProgressBar: true,
                    });
                  }
                }
              });
          }
        }
      } else {
        this.setState({
          isSDAllow: false,
        });
      }
    }
  }
  IsNoDue(
    Is_NoDue,
    DeliveryStatus,
    NoDueBy,
    NoDueDate,
    AdditionalServiceApprovalStatus,
    Outstanding,
    ProformaInvoiceID,
    ProformaInvoice_No,
    summaryArr
  ) {
    const { OrderID, OrderNo, companyName, primaryEmailID } = this.state;
    const isWithin24Hours = (bookingDate, bookingSlot) => {
      const [startTime] = bookingSlot.split(" - ");
      const [startHour, startPeriod] = startTime.split(" ");
      const [startHourNum, startMinute] = startHour.split(":");
      const startDate = new Date(
        `${bookingDate} ${startHourNum}:${startMinute} ${startPeriod}`
      );

      const currentTime = new Date();
      const timeDifference = (startDate - currentTime) / (1000 * 60 * 60); // Difference in hours

      return timeDifference <= 24;
    };

    // Check if any booking in summaryArr is within the next 24 hours
    const isAnyBookingWithin24Hours = summaryArr.some(
      ({ BookingDate, BookingSlot }) =>
        isWithin24Hours(BookingDate, BookingSlot)
    );

    switch (true) {
      case (Is_NoDue === 0 || Is_NoDue === 1) && DeliveryStatus === "Cancelled":
        return null;
      case Is_NoDue === 0 &&
        DeliveryStatus === "Confirmed" &&
        AdditionalServiceApprovalStatus == 1 &&
        Outstanding <= 0:
        // &&isAnyBookingWithin24Hours):
        return (
          <>
            <a
              href="javascript:void(0);"
              className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
              onClick={() =>
                this.generateNoDue(
                  this.props.location.state.OrderID || OrderID,
                  this.props.location.state.OrderNo || OrderNo,
                  this.props.location.state.CompanyName || companyName,
                  this.props.location.state.PrimaryEmailID || primaryEmailID,
                  ProformaInvoiceID,
                  ProformaInvoice_No
                )
              }
            >
              Generate No Due Certificate
            </a>
          </>
        );
      case (Is_NoDue === 1 && DeliveryStatus === "Confirmed") ||
        DeliveryStatus === "Delivered":
        return (
          <a
            href="javascript:void(0);"
            className="make_paymentLink m-2"
            onClick={() =>
              this.downloadNoDue(
                this.props.location.state.OrderID || OrderID,
                this.props.location.state.OrderNo || OrderNo
              )
            }
          >
            <i className="fa fa-download" /> No Due Certificate
            {/* <span>Generated By: {NoDueBy}</span>
                <span>
                  {moment(NoDueDate).utc().format("DD/MM/YYYY - hh:mm:ss")}
                </span> */}
          </a>
        );
      default:
        return null;
    }
  }

  renderPaymentForm(paymentStatus, DeliveryStatus) {
    const { encPayload, paymentAccessCode, MyOrdersData } = this.state;
    const Outstanding =
      DeliveryStatus === "Approved" ||
        DeliveryStatus === "Confirmed" ||
        DeliveryStatus === "Delivered"
        ? MyOrdersData.map((data) => data.proformaDetails[0]?.Outstanding).join(
          ", "
        )
        : null;
    if (DeliveryStatus === "Confirmed" || DeliveryStatus === "Delivered") {
      if (Outstanding <= 0 || paymentStatus === "Delivered") {
        return (
          <div className="d-flex align-items-center">
            <div className="mx-2">Booking Payment Status:</div>
            <div className="btn btn-success btn-sm">PAID</div>
          </div>
        ); // Display "Paid" if paymentStatus is "Full Payment"
      } else {
        return (
          <div className="d-flex align-items-center">
            <div className="mx-2">Booking Payment Status:</div>
            <div className="btn btn-danger btn-sm">UNPAID</div>
          </div>
        );
      }
    } else if (DeliveryStatus === "Approved") {
      return (
        <div className="d-flex align-items-center">
          <div className="mx-2">Booking Payment Status:</div>
          <div className="btn btn-danger btn-sm">UNPAID</div>
        </div>
      );
    } else {
      return null; // Return null for all other cases
    }
  }

  formatOrderDate(orDate) {
    const options = { day: "numeric", month: "long", year: "numeric" };
    const date = new Date(orDate);
    return date.toLocaleDateString(undefined, options);
  }
  formatDate(orDate) {
    if (typeof orDate !== "string" || !orDate.includes("/")) {
      console.error("Invalid or missing date format:", orDate);
      return "--"; // Return a default value or handle the error appropriately
    }

    // Convert orDate to a Date object if it's a string
    const date =
      typeof orDate === "string" ? this.parseDateFromString(orDate) : orDate;

    // Check if the Date object is valid
    if (isNaN(date.getTime())) {
      return "--"; // Return placeholder for invalid date
    }

    // Format the date using toLocaleDateString
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  parseDateFromString(dateString) {
    // Parse the date string assuming the format "dd/mm/yyyy"
    const parts = dateString.split("/");
    if (parts.length !== 3) {
      return new Date(NaN); // Return an invalid Date object
    }

    // Construct a new date string in "mm/dd/yyyy" format
    const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;

    // Attempt to create a Date object
    return new Date(formattedDate);
  }
  downloadBookingForm(OrderID, OrderNo) {
    const { userId } = this.state;
    const formattedOrderNo = OrderNo.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });
    this.props
      .download_booking_form_action(
        userId,
        OrderID,
        formattedOrderNo
      )
      .then((downloadData) => {
        if (downloadData.error !== 1) {
          this.setState({ isLoading: false });
          console.log(downloadData);

          // Open the report in a new tab
          const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
          window.open(url, "_blank");
        } else {
          if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(downloadData.msg, {
              position: "top-center",
              theme: "colored"
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }
  downloadPerformaInvoice(ProformaInvoiceID, ProformaInvoice_No, proformaType) {
    const { userId } = this.state;
    const formattedProformaInvoiceNo = ProformaInvoice_No.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });

    if (ProformaInvoiceID) {
      console.log(ProformaInvoiceID, formattedProformaInvoiceNo, proformaType);
      const selectedproformaType = proformaType.includes('Slot Booking' || 'Additionalservices') ? 1 : 0;
      this.props
        .download_performa_invoice_action(
          userId,
          ProformaInvoiceID,
          formattedProformaInvoiceNo, selectedproformaType
        )
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);

            // Open the report in a new tab
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored"
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot open: Proforma Invoice ID not found.", {
        position: "top-center", theme: "colored"
      });
    }
  }
  downloadNoDue(OrderID, OrderNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (OrderID) {
      const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
      this.props
        .download_no_due_action(userId, OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }
  downloadExitPass(OrderID, OrderNo) {
    const { userId } = this.state;
    this.setState({ isLoading: true });
    if (OrderID) {
      const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
      this.props
        .download_exitPass_action(userId, OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }
  generateNoDue(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    ProformaInvoiceID,
    ProformaInvoice_No
  ) {
    this.setState({ isLoading: true });
    this.props
      .generate_nodue_action(
        OrderID,
        OrderNo,
        CompanyName,
        PrimaryEmailID,
        ProformaInvoiceID,
        ProformaInvoice_No
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("No Due Generated Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getOrderEditDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  updateExitPass(OrderID, OrderNo, CompanyName, PrimaryEmailID, UUID) {
    this.setState({ isLoading: true });
    this.props
      .update_exit_pass_action(
        OrderID,
        OrderNo,
        CompanyName,
        PrimaryEmailID,
        UUID
      )
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Exit pass generated Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getOrderEditDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  updateClosure(OrderID) {
    this.setState({ isLoading: true });
    this.props
      .event_closure_action(OrderID)
      .then((data) => {
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("Event Closed Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getOrderEditDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleDelete(OrderID) {
    const {
      userId,
      OrderNo,
      CancellationReasonID,
      cancelNote,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      DeliveryStatus,
    } = this.state;
    this.setState({ isLoading: true });
    // First, execute order_cancel_reason_action
    if (DeliveryStatus == "Incomplete") {
      var confirmDelete = window.confirm(
        "Are you sure you want to cancel this Order?"
      );
      if (confirmDelete) {
        this.props
          .order_delete_action(OrderID, OrderNo, CompanyName, PrimaryEmailID)
          .then((data) => {
            if (data.error !== 1) {
              toast.success(
                `The Order: ${OrderNo} has been Cancelled Successfully.`,
                {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 4000,
                  hideProgressBar: true,
                }
              );
              this.getOrderEditDetails();
              this.setState({ isLoading: false });
              this.props.navigate("/orders");
            } else {
              if (
                data.msg == sessionExpireMessage ||
                data.msg == tokenInavlidMessage
              ) {
                //after session expire.....................
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }, 500);
              } else {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.getOrderEditDetails();
      }
    } else {
      this.props
        .order_cancel_reason_action(
          userId,
          OrderID,
          CancellationReasonID,
          cancelNote,
          OrderNo,
          CompanyName,
          PrimaryEmailID,
          RoleID
        )
        .then((data) => {
          if (data.error !== 1) {
            toast.success(
              `Your request to cancel the order ${OrderNo} has been submitted and send to the office. You will be intimated once Confirm.`,
              {
                position: "top-center",
                theme: "colored",
                autoClose: 4000,
                hideProgressBar: true,
              }
            );
            this.deleteModalClose();
            this.getOrderEditDetails();
            this.setState({ isLoading: false });
            this.props.navigate("/orders");
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                theme: "colored",
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  render() {
    const {
      isLoading, piSendShow, piFilePath, exitPiFilePath, taxInvoiceFilePath, PiType, ProformaInvoiceID, ProformaInvoice_No,
      FinalExitSubmit,
      isAccordionExpanded,
      isAdditionalDiscountAllow,
      isSDAllow,
      SecurityDeposit,
      SecurityDepositRemark,
      AdditionalDiscount,
      AdditionalDiscountNote,
      ExitSubmittedDate,
      exitListShow,
      PiShow,
      followInfoCollapse,
      ExitPassBy,
      IsExitPassDate,
      Is_ExitPass,
      Is_NoDue,
      NoDueBy,
      NoDueDate,
      userId,
      AdditionalServiceStatus,
      MyOrdersData,
      additionalChargesData,
      additionalChargesDetails,
      ChargeHeadID,
      ChargeHeadName,
      Charges,
      AdditionalHours,
      RentalDiscount,
      DiscountAmountNote,
      isInsertDiscountAllow,
      AdditionalHourCharges,
      OvernightCharges,
      OrderID,
      UUID,
      Date,
      OrderDate,
      ItmeCenter,
      StatusID,
      deleteShow,
      followUpShow,
      approveShow,
      rejectShow,
      OrderNo,
      Note,
      //client
      stateId,
      stateList,
      countryId,
      countryList,
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      CompanyStatus,
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      companyStatusList,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      accountTypeList,
      SAACompanyName,
      firstNameErr,
      lastNameErr,
      organizerErr,
      addressLine1Err,
      addressLine2Err,
      CityNameErr,
      countryIdErr,
      pincodeErr,
      Mobile1Err,
      primaryEmailIDErr,
      SAAFirstNameErr,
      SAALastNameErr,
      SAAAddressLine1Err,
      SAAAddressLine2Err,
      SAACityNameErr,
      SAACountryIdErr,
      SAAPincodeErr,
      SAAMobile1Err,
      SAAPrimaryEmailIDErr,
      PANCardNoErr,
      preTel,
      SAAPreTel,
      AreaCode,
      SAAAreaCode,
      NameonPANCardErr,
      accountNameErr,
      accountNoErr,
      accountTypeErr,
      bankNameErr,
      branchNameErr,
      IFSCCodeErr,
      SAACompanyNameErr,
      stateErr,
      SAAStateErr,
      isSAADisplayCityList,
      isDisplayStateList,
      isSAADisplayStateList,
      followUpList,
      cancellationReasonList,
      CancellationReasonID,
      rejectionReasonList,
      cancelNote,
      Is_Approved,
      RejectReason,
      RejectionNote,
      RejectReasonID,
      isEditMode,
      DeliveryStatus,
      RoleID,
      isEventServiceAllow,
      EventServiceAmount,
      EventServiceNote,
      //payment
      encPayload,
      paymentAccessCode,
      ToPay,
      blockedSlots,
      //Additional Services  \
      SliderValue,
      minPrice,
      maxPrice,
      vendorNameList,
      standardPremiumId,
      serviceName,
      addRequirement,
      standardPremiumList,
      standerdArray,
      isOpen,
      fileList,
      additionalServicesList,
      CenterID,
      show,
      CurrencyID,
      unlistedAddServices,
      OtherInformation,
      includedServices,
      externalServices,
      vendorPackageList,
      showPackageDetailsData,
      showtable,
      //booking Details
      EntryType,
      TypeOfEvent,
      SittingArrangement,
      bookingList,
      PossesionStartDate,
      PossesionEndDate,
      PossesionStartTime,
      PossesionEndTime,
      eventStartDate,
      eventEndDate,
      eventStartTime,
      eventEndTime,
      dismantleStartDate,
      dismantleEndDate,
      possessionTime,
      exitTime,
      dismantleStartTime,
      dismantleEndTime,
      BookingEventDataList,
      //list Possession & Exit
      possessionIncludedServicesList,
      possessionConsumableList,
      PossessionContactNameAndNumber,
      PosssesionOperationNameContact,
      oppPossessionSignatureData,
      ExitOperationNameContact,
      oppExitSignatureData,
      exitConsumableList,
      ExitContactNameAndNumber,
      possessionInhouseServicesList,
      exitIncludedServicesList,
      exitCheckList,
      possessionCheckList,
      exitInhouseServicesList,
      exitDataListFlag,
      possessionDataListFlag,
      possessionSignatureData,
      ExitSignatureData,
      isExitList,
      isPossessionList,
      PossesionSubmittedUser,
      PossesionSubmittedDate,
      existDataListFlag,
      exitSub,
      possessionSub,
      exitCheckListAllSelected,
      exitInstructionList,
      ExitSubmittedUser,
      possessionCheckListAllSelected,
      possessionMaterialNameAndServiceName,
      possessionMaterialList,
      possessionSecurityList,
      PossessionSecurityChecklistNote,
      exitMaterialNameAndServiceName,
      exitMaterialList,
      exitSecurityList,
      ExitSecurityChecklistNote,
      AdditionHours,
      exitVendorList,
      ExitSubmittedBy,
      possessionVendorList,
      unlistedAddServicesExit,
      AdditionHoursExit,
      electricityPossesion,
      electricityExit,
      //rest
      AdditionalServiceApprovalStatus,
      vendorFillList,
      VendorID,
      NameOfTheVendor,
      OrderAmount,
      ConvenienceFee,
      RefundAmount,
      deduction,
      finalAmount,
      ClientID,
      clientUser,
      AdminRemark,
      isAdditionalHourAllow,
      proformaList,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      EventCordinatorNameErr,
      EventCordinatorDesignationErr,
      EventCordinatorEmailErr,
      EventCordinatorMobileErr,
      PrimaryContactNameErr,
      PrimaryContactDesignationErr,
      PrimaryContactEmailErr,
      PrimaryContactMobileErr,
      downloadUrl,
      MembershipFilePath,
      isModifyEdit,
      editShow,
      isEdit,
      BookingDate,
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[18]} />

            <div className="thankYou_page">
              {/* <div class="row head_text">
  <div class="col-md-12 text-center">
    <i class="fa fa-check-circle"></i>
    <h6 class="text_title">Yay! Booking Confirmed!</h6>
  </div>
</div> */}
              <div className="thankYou_page_content">
                {MyOrdersData.length > 0 &&
                  MyOrdersData.map((data) => (
                    <div className="card product">
                      <div className="card-header">
                        <div className="order_no_and_date">
                          <div className="row">
                            <div className="col-md-6">
                              <p>Application No: {data.OrderID}</p>
                              <p>Order No : {data.OrderNo}</p>
                              <p>Order Date : {data.orderDate}</p>
                            </div>
                            <div className="col-md-6 text-right">
                              <h5>
                                {data.DeliveryStatus ===
                                  "Pending for Verification"
                                  ? "Pending for Action"
                                  : data.DeliveryStatus}
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="search_accordion search_card">
                          <div className="panel-group" id="accordion">
                            <div className="panel panel-default">
                              <div
                                className="panel-heading accordion-toggle collapsed"
                                data-toggle="collapse"
                                data-parent="#accordion"
                                data-target="#collapseOne"
                                aria-expanded={isAccordionExpanded}
                                onClick={() =>
                                  this.setState({
                                    isAccordionExpanded: !isAccordionExpanded,
                                  })
                                }
                              >
                                <h4 className="panel-title">
                                  Organizer Details
                                </h4>
                              </div>
                              <div
                                id="collapseOne"
                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                  }`}
                                aria-labelledby="headingOne"
                              >
                                <div class="text-right mx-3 row">
                                  <div class="col-10"></div>
                                  <div class="col-2">
                                    {isEditMode == true ? (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() => this.CompanyEditTrue()}
                                        className="btn btn-success"
                                      >
                                        Edit
                                      </a>
                                    ) : (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() => this.CompanyEditFalse()}
                                        className="btn btn-warning mx-2"
                                      >
                                        View
                                      </a>
                                    )}
                                  </div>
                                </div>
                                <div className="panel-body">
                                  <div className="card-body">
                                    <div className="company_info">
                                      <fieldset>
                                        <legend>
                                          Name and full address of the Organizer
                                        </legend>
                                        <div className="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={firstName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.firstName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {firstNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    First Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={lastName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.lastName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {lastNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Last Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={designation}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={50}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.designation(e)
                                                    }
                                                  />
                                                  <span class="floating-label-outside">
                                                    Designation
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={companyName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={100}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.organizerName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {organizerErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Organizer / Organization
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <label class="floating-label">
                                                  COUNTRY{" "}
                                                </label>
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                                  value={countryId}
                                                  disabled={isEditMode}
                                                  style={{
                                                    background: isEditMode
                                                      ? "#FAFAFA"
                                                      : "none",
                                                  }}
                                                  onChange={(e) =>
                                                    this.onCountryId(e)
                                                  }
                                                >
                                                  <option value="">
                                                    Country
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>
                                                  {countryList.length > 0 &&
                                                    countryList.map((item) => (
                                                      <option
                                                        key={item.Countryid}
                                                        value={item.Countryid}
                                                      >
                                                        {item.CountryName}
                                                      </option>
                                                    ))}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {countryIdErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={stateId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.onStateSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                  />
                                                  {isDisplayStateList &&
                                                    this.renderStateList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {stateErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    State Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={cityId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    onChange={(e) =>
                                                      this.onCitytSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                  />
                                                  {isDisplayCityList &&
                                                    this.renderCityList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {CityNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    City Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={addressLine1}
                                                    type="text"
                                                    disabled={isEditMode}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.addressLine1(e)
                                                    }
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {addressLine1Err}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Address Line 1{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={addressLine2}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.addressLine2(e)
                                                    }
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {addressLine2Err}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Address Line 2{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={pincode}
                                                    type="text"
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.pincode(e)
                                                    }
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {pincodeErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {countryId == "91" ||
                                                      countryId == "" ||
                                                      countryId == "Country*"
                                                      ? "Pincode"
                                                      : "ZipCode"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      value={ISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={Mobile1}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.mobile1(e)
                                                      }
                                                      maxLength={10}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {Mobile1Err}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Mobile 1{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      value={ISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={Mobile2}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.mobile2(e)
                                                      }
                                                      maxLength={10}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Mobile 2
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder={
                                                        countryId == "91" ||
                                                          countryId == "" ||
                                                          countryId == "Country*"
                                                          ? "STD"
                                                          : "ISD"
                                                      }
                                                      value={preTel}
                                                      required
                                                      disabled={isEditMode}
                                                      onChange={(e) =>
                                                        this.preTelephone(e)
                                                      }
                                                      maxLength={5}
                                                    />
                                                  </div>
                                                  {countryId != "91" &&
                                                    countryId != "" &&
                                                    countryId != "Country*" ? (
                                                    <div class="ISD">
                                                      <input
                                                        type="text"
                                                        class="outside"
                                                        placeholder="CODE"
                                                        value={AreaCode}
                                                        required
                                                        disabled={isEditMode}
                                                        onChange={(e) =>
                                                          this.areaCode(e)
                                                        }
                                                        maxLength={10}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <></>
                                                  )}
                                                  <div class="position-relative width_80">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      value={TelephoneNumber}
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.telephone(e)
                                                      }
                                                      maxLength={16}
                                                      disabled={isEditMode}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Telephone Number
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={primaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.primaryEmail(e)
                                                    }
                                                    maxLength={50}
                                                    disabled={isEditMode}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {primaryEmailIDErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Primary Email ID{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={secondaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.secondaryEmail(e)
                                                    }
                                                    maxLength={50}
                                                    disabled={isEditMode}
                                                  />
                                                  <span class="floating-label-outside">
                                                    Secondary Email ID{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={website}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.website(e)
                                                    }
                                                    maxLength={40}
                                                    disabled={isEditMode}
                                                  />
                                                  <span class="floating-label-outside">
                                                    Website{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                      <fieldset>
                                        <legend>
                                          Event Coordinator details{" "}
                                        </legend>

                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={EventCordinatorName}
                                                    type="text"
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorName:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        EventCordinatorNameErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {" "}
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      EventCordinatorDesignation
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorDesignation:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        EventCordinatorDesignationErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {
                                                        EventCordinatorDesignationErr
                                                      }
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Designation
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={EventCordinatorEmail}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorEmail:
                                                          e.target.value,
                                                        EventCordinatorEmailErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorEmailErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Email
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      EventCordinatorMobile
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorMobile:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        EventCordinatorMobileErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorMobileErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Mobile
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>

                                      <fieldset>
                                        <legend>
                                          Primary Contact details{" "}
                                        </legend>

                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    maxLength={30}
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactName:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        PrimaryContactNameErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {" "}
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      PrimaryContactDesignation
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactDesignation:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        PrimaryContactDesignationErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {
                                                        PrimaryContactDesignationErr
                                                      }
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Designation
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactEmail}
                                                    type="text"
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactEmail:
                                                          e.target.value,
                                                        PrimaryContactEmailErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactEmailErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Email
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactMobile}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    maxLength={30}
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactMobile:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        PrimaryContactMobileErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactMobileErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Mobile
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>

                                      <fieldset
                                        class={
                                          SameAsAbove
                                            ? "saveAsAbove_section"
                                            : ""
                                        }
                                      >
                                        <legend>Billing Address</legend>

                                        <div class="mb-2">
                                          <div class="bg">
                                            <div class="chiller_cb">
                                              <input
                                                value={SameAsAbove}
                                                id="SameAsAbove"
                                                type="checkbox"
                                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                                selected={SameAsAbove}
                                                checked={SameAsAbove}
                                                disabled={isEditMode}
                                                onClick={(e) =>
                                                  this.SameAsAbove(e)
                                                }
                                                placeholder=""
                                              />
                                              <label
                                                for="SameAsAbove"
                                                style={{ color: "#979797" }}
                                              >
                                                Same As Above
                                              </label>
                                              <span></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="outside_input_field">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAFirstName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAFirstName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAFirstNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAFirstNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    First Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAALastName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAALastName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAALastNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAALastNameErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Last Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAADesignation}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAADesignation:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Designation{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAACompanyName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={SameAsAbove}
                                                    style={{
                                                      background: SameAsAbove
                                                        ? "#FAFAFA"
                                                        : "none",
                                                    }}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAACompanyName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAACompanyNameErr: "",
                                                      })
                                                    }
                                                    maxLength={100}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAACompanyNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Organizer / Organization
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  value={SAACountryId}
                                                  disabled={SameAsAbove}
                                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                                  onChange={(e) =>
                                                    this.onSAACountryId(e)
                                                  }
                                                >
                                                  <option>
                                                    Country
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>

                                                  {countryList.length > 0 &&
                                                    countryList.map((item) => (
                                                      <option
                                                        key={item.Countryid}
                                                        value={item.Countryid}
                                                      >
                                                        {item.CountryName}
                                                      </option>
                                                    ))}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {SAACountryIdErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAStateId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.onSAAStateSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {isSAADisplayStateList &&
                                                    this.renderSAAStateList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAStateErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    State Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAACityId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.onSAACitytSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    disabled={SameAsAbove}
                                                    maxLength={30}
                                                  />
                                                  {isSAADisplayCityList &&
                                                    this.renderSAACityList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAACityNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    City Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAAddressLine1}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAAddressLine1:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAAddressLine1Err: "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAAddressLine1Err}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Address Line 1{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAAAddressLine2}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAAddressLine2:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAAddressLine2Err: "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAAddressLine2Err}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Address Line 2{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAPincode}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAPincode:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        SAAPincodeErr: "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAPincodeErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    {SAACountryId == "91" ||
                                                      SAACountryId == "" ||
                                                      SAACountryId == "Country*"
                                                      ? "Pincode"
                                                      : "ZipCode"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      value={SAAISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAAMobile1}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAAMobile1:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                          SAAMobile1Err: "",
                                                        })
                                                      }
                                                      maxLength={10}
                                                      disabled={SameAsAbove}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {SAAMobile1Err}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Mobile 1{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      value={SAAISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAAMobile2}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAAMobile2:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                        })
                                                      }
                                                      maxLength={10}
                                                      disabled={SameAsAbove}
                                                    />

                                                    <span class="floating-label-outside">
                                                      Mobile 2{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      onChange={(e) =>
                                                        this.setState({
                                                          preTel:
                                                            e.target.value,
                                                        })
                                                      }
                                                      placeholder={
                                                        SAACountryId == "91" ||
                                                          SAACountryId == "" ||
                                                          SAACountryId ==
                                                          "Country*"
                                                          ? "STD"
                                                          : "ISD"
                                                      }
                                                      value={SAAPreTel}
                                                      required
                                                      disabled={SameAsAbove}
                                                    />
                                                  </div>
                                                  {SAACountryId != "91" &&
                                                    SAACountryId != "" &&
                                                    SAACountryId != "Country*" ? (
                                                    <div class="ISD">
                                                      <input
                                                        type="text"
                                                        class="outside"
                                                        onChange={(e) =>
                                                          this.setState({
                                                            SAAAreaCode:
                                                              e.target.value,
                                                          })
                                                        }
                                                        placeholder="CODE"
                                                        value={SAAAreaCode}
                                                        required
                                                        disabled={SAAAreaCode}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <></>
                                                  )}
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAATelephoneNumber}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAATelephoneNumber:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                        })
                                                      }
                                                      disabled={SameAsAbove}
                                                      maxLength={16}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Telephone Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAAPrimaryEmailID}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAPrimaryEmailID:
                                                          e.target.value,
                                                        SAAPrimaryEmailIDErr:
                                                          "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAPrimaryEmailIDErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Primary Email ID{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAASecondaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAASecondaryEmailID:
                                                          e.target.value,
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Secondary Email ID{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAWebsite}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAWebsite:
                                                          e.target.value,
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={40}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Website{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                      {countryId == "91" ? (
                                        <fieldset>
                                          <legend>
                                            Organizer's / Organization's
                                            Information
                                          </legend>
                                          <div class="outside_input_field ">
                                            <div class="row">
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={registrationNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          registrationNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Registration Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={PANCardNo}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          PANCardNo:
                                                            e.target.value.toUpperCase(),
                                                          PANCardNoErr: "",
                                                        })
                                                      }
                                                      maxLength={10}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {PANCardNoErr}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      PAN Card No.{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={NameonPANCard}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          NameonPANCard:
                                                            e.target.value
                                                              .split(" ")
                                                              .map(
                                                                (word) =>
                                                                  word
                                                                    .charAt(0)
                                                                    .toUpperCase() +
                                                                  word.slice(1)
                                                              )
                                                              .join(" "),
                                                          NameonPANCardErr: "",
                                                        })
                                                      }
                                                      maxLength={50}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {NameonPANCardErr}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Name on PAN Card{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={GSTNo}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          GSTNo:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                    />
                                                    <span class="floating-label-outside">
                                                      GST No.{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={TANNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          TANNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      TAN Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={UINNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          UINNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      UIN Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </fieldset>
                                      ) : (
                                        <></>
                                      )}
                                      <fieldset>
                                        <legend>Banking details</legend>
                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={accountName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        accountName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        accountNameErr: "",
                                                      })
                                                    }
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {accountNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Account Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={accountNo}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        accountNo:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        accountNoErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {accountNoErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Account No.{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  value={accountType}
                                                  disabled={isEditMode}
                                                  style={{
                                                    background: isEditMode
                                                      ? "#FAFAFA"
                                                      : "none",
                                                  }}
                                                  onChange={(e) =>
                                                    this.setState({
                                                      accountType:
                                                        e.target.value,
                                                      accountTypeErr: "",
                                                    })
                                                  }
                                                >
                                                  <option>
                                                    Account Type
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>

                                                  {accountTypeList.length > 0 &&
                                                    accountTypeList.map(
                                                      (item) => (
                                                        <option>
                                                          {item.Accounttype}
                                                        </option>
                                                      )
                                                    )}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {accountTypeErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={bankName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        bankName: e.target.value
                                                          .split(" ")
                                                          .map(
                                                            (word) =>
                                                              word
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                              word.slice(1)
                                                          )
                                                          .join(" "),
                                                        bankNameErr: "",
                                                      })
                                                    }
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {bankNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Bank name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={branchName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        branchName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        branchNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {branchNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    branch name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={IFSCCode}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        IFSCCode:
                                                          e.target.value.toUpperCase(),
                                                        IFSCCodeErr: "",
                                                      })
                                                    }
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {IFSCCodeErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    {countryId == "91" ||
                                                      countryId == "" ||
                                                      countryId == "Country*"
                                                      ? "IFSC code"
                                                      : "Swift code"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                    <div className="row">
                                      <div className="mx-3">
                                        {isEditMode == false ? (
                                          <a
                                            href="javascript:void(0);"
                                            onClick={(e) => this.editCompany(e)}
                                            className="btn save_btn"
                                          >
                                            Save
                                          </a>
                                        ) : null}
                                      </div>
                                      <div className="mx-3">
                                        <a
                                          href="javascript:void(0);"
                                          onClick={() =>
                                            this.setState({
                                              isAccordionExpanded:
                                                !isAccordionExpanded,
                                              isEditMode: true,
                                              isAccordionExpanded: false,
                                            })
                                          }
                                          className="btn back_btn"
                                        >
                                          Close
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center gap-2 text-muted"
                          style={{ justifyContent: "space-between" }}
                        >
                          <div>
                            <h5 className="text-truncate head_text">
                              <a
                                href="javascript:void(0);"
                                className="text-dark"
                              >
                                {data.centerName}
                              </a>
                            </h5>
                            <p className="text-muted Address_para">
                              <i className="fa fa-map-marker" />
                              &nbsp;
                              {data.centerAdd}
                            </p>
                          </div>

                          <div className="row">
                            <div className="col-4">
                              <Link
                                to="bottom"
                                class="nav-link"
                                style={{ cursor: "pointer", background: '#87CEFA', color: 'white', borderRadius: '12px' }}
                                smooth={true}
                                duration={500}
                                offset={-100}
                              >
                                <i class="fa fa-solid fa-arrow-down"></i>
                              </Link>
                            </div>
                            {this.isProformaDownload() ? (
                              <div className="col-8">
                                <button
                                  onClick={() =>
                                    this.piModalShow(
                                      data.OrderID,
                                      data.OrderNo,
                                      proformaList
                                    )
                                  }
                                  class="btn btn-success btn-sm fs-12"
                                >
                                  {" "}
                                  <a>
                                    <i class="fa fa-download"></i> Download
                                  </a>
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row ml-1">
                        <div className="col-sm">
                          <ul className="nav nav-tabs" style={{ width: '30%' }}>
                            <li className="nav-item">
                              <Link
                                to="rental"
                                className="nav-link active"
                                style={{ cursor: "pointer" }}
                                smooth={true}
                                duration={500}
                                offset={-100}
                              >
                                Order Summary
                              </Link>
                            </li>

                            {this.IsAddAdditionalServices(
                              data.DeliveryStatus || this.props.location.state.DeliveryStatus,
                              data.paymentStatus
                            ) && (
                                <li className="nav-item">
                                  <Link
                                    to="additionalService"
                                    className="nav-link"
                                    style={{ cursor: "pointer" }}
                                    smooth={true}
                                    duration={500}
                                    offset={-100}
                                  >
                                    Additional Services
                                  </Link>
                                </li>
                              )}

                            {PossesionSubmittedUser !== "" && (
                              <li className="nav-item">
                                <Link
                                  to="checklist"
                                  className="nav-link"
                                  style={{ cursor: "pointer" }}
                                  smooth={true}
                                  duration={500}
                                  offset={-100}
                                >
                                  CheckList
                                </Link>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-8">
                          <div className="card-body order_edit_css">
                            <div className=" gy-3">
                              <Element name="rental" className="element">
                                <legend>Order Summary</legend>
                              </Element>
                              <fieldset style={{ marginLeft: '10px' }}>
                                <div className="slot_para">
                                  <h6>Summary</h6>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Type of Event</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Seating Arrangement</strong>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        {TypeOfEvent
                                          ? TypeOfEvent
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        {SittingArrangement
                                          ? SittingArrangement
                                          : "Not Available"}
                                      </span>
                                    </div>
                                  </div>

                                  <hr />
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Booking Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-3 padding_0">
                                      <span>
                                        <strong>Booking Slot</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Selected Hrs</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-3 padding_0 text-right">
                                      <span>
                                        <strong>Amount</strong>
                                      </span>
                                    </div>
                                  </div>

                                  {data.summary.map((summaryItem, index) => (
                                    <div key={index} className="row mr_0">
                                      <div className="col-md-4 padding_0">
                                        <span>
                                          {this.formatDate(
                                            summaryItem.BookingDate
                                          )}
                                        </span>
                                      </div>
                                      <div className="col-md-3 padding_0">
                                        <span>{summaryItem.BookingSlot}</span>
                                      </div>
                                      <div className="col-md-2 padding_0 text-center">
                                        <span>{summaryItem.Selectedhrs}</span>
                                      </div>
                                      <div className="col-md-3 padding_0 text-right">
                                        <span>
                                          {data.currency == "INR" ? "₹" : "$"}{" "}
                                          {summaryItem.NetAmount.toLocaleString(
                                            "en-IN"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="add_service_para" style={{ margin: '1rem' }}>
                                  <h6></h6>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Dates</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Start Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>End Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Start Time</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>End Time</strong>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mr_0">
                                    {/* <div className="col-md-4 padding_0">
                                    <span>Possession Date</span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {console.log(PossesionStartDate, "PossesionStartDate")}
                                      {PossesionStartDate
                                        ? this.formatDate(PossesionStartDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionEndDate
                                        ? this.formatDate(PossesionEndDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionStartTime
                                        ? PossesionStartTime
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionEndTime
                                        ? PossesionEndTime
                                        : "--"}
                                    </span>
                                  </div> */}
                                    {BookingEventDataList.map(
                                      (eventData, index) => (
                                        <React.Fragment key={index}>
                                          <div className="col-md-4 padding_0">
                                            <span>Event Date</span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventStartDate
                                                ? this.formatDate(
                                                  eventData.EventStartDate
                                                )
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventEndDate
                                                ? this.formatDate(
                                                  eventData.EventEndDate
                                                )
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventStartTime
                                                ? eventData.EventStartTime
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventEndTime
                                                ? eventData.EventEndTime
                                                : "--"}
                                            </span>
                                          </div>
                                        </React.Fragment>
                                      )
                                    )}

                                    {/* <div className="col-md-4 padding_0">
                                    <span>Dismantle Date</span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleStartDate
                                        ? this.formatDate(dismantleStartDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleEndDate
                                        ? this.formatDate(dismantleEndDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleStartTime
                                        ? dismantleStartTime
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleEndTime
                                        ? dismantleEndTime
                                        : "--"}
                                    </span>
                                  </div> */}
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                            <fieldset style={{ marginLeft: '10px' }}>
                              <div className="slot_para">
                                <h6>Billing Details</h6>
                                <div className="card-footer">
                                  <div className="align-items-center gy-3">
                                    <div className="">
                                      {this.isAdditionalHourShowFunction(
                                        data.DeliveryStatus,
                                        data.additionalChargesData,
                                        data.additionalChargesDetails
                                      )}

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          Venue Hire Charges
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.GrossAmount
                                              ? parseFloat(data.Price.GrossAmount).toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>

                                      {MyOrdersData.map(
                                        (data) => data.DeliveryStatus
                                      ).join(" ") === "Pending for Verification" ? (
                                        <div className="row text-muted">
                                          <div className="col-md-2 my_color">
                                            <b>Insert Discount Amount</b>
                                          </div>
                                          <div className="col-md-4"></div>
                                          <div className="my_color col-md-6 row">
                                            <div class="col-md-7">
                                              <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Discount Note"
                                                value={DiscountAmountNote}
                                                onChange={(e) =>
                                                  this.setState({
                                                    DiscountAmountNote:
                                                      e.target.value,
                                                  })
                                                }
                                                style={{
                                                  width: "99%",
                                                  marginRight: "5px",
                                                }}
                                                disabled={
                                                  isInsertDiscountAllow &&
                                                  Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            <div
                                              class={
                                                isInsertDiscountAllow == true
                                                  ? "col-md-4"
                                                  : "col-md-3"
                                              }
                                            >
                                              <input
                                                type="text"
                                                value={RentalDiscount}
                                                placeholder="Discount"
                                                class="form-control"
                                                onChange={(e) => {
                                                  const value = e.target.value;

                                                  const numericValue = value
                                                    .replace(/[^0-9.]/g, "")
                                                    .replace(/(\..*)\./g, "$1");
                                                  this.setState({
                                                    RentalDiscount: numericValue,
                                                  });
                                                }}
                                                style={{ width: "99%" }}
                                                disabled={
                                                  isInsertDiscountAllow &&
                                                  Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            {Is_NoDue == 0 ? (
                                              isInsertDiscountAllow ? (
                                                <div class="col-md-1">
                                                  <i
                                                    className="fa fa-edit action_btn_table"
                                                    onClick={() =>
                                                      this.updateRentalDiscount(
                                                        isInsertDiscountAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <div class="col-md-2">
                                                  <i
                                                    className="fa fa-save action_btn_table"
                                                    onClick={() =>
                                                      this.updateRentalDiscount(
                                                        isInsertDiscountAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                  <i
                                                    className="fa fa-close action_btn_table"
                                                    onClick={() =>
                                                      this.updateRentalDiscount(
                                                        isInsertDiscountAllow,
                                                        true
                                                      )
                                                    }
                                                  />
                                                </div>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ paddingTop: "5px", paddingBottom: '5px', justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_120 my_color">
                                          {data.IsMemberShip == 1 ? (
                                            <a
                                              href="javascript:void(0);"
                                              className="text-muted"
                                              onClick={() =>
                                                this.navigateToMemberShip(
                                                  data.ClientID,
                                                  data.CenterID,
                                                  data.OrderID,
                                                  data.OrderNo,
                                                  clientUser
                                                )
                                              }
                                            >
                                              Discount &nbsp; (Click and verify the
                                              membership)
                                            </a>
                                          ) : (
                                            <span className="text-muted">
                                              Discount
                                            </span>
                                          )}
                                        </div>
                                        <h5 className="fs-14 mb-0 text-danger">
                                          {data.IsMemberShip == 1 ? (
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                              }}
                                              title="View Membership File"
                                              target="_blank"
                                              href={`${downloadUrl + MembershipFilePath
                                                }`}
                                            >
                                              {" "}
                                              <i className="fa fa-file-pdf-o action_btn_table mx-2" />
                                              -{data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {parseInt(data.Price?.DiscountAmount, 10) ?
                                                  parseInt(data.Price?.DiscountAmount, 10).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) : "0.00"}
                                              </span>
                                              {""}
                                            </a>
                                          ) : (
                                            <>
                                              {data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {parseInt(data.Price?.DiscountAmount, 10) ?
                                                  parseInt(data.Price?.DiscountAmount, 10).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) : "0.00"}
                                              </span>
                                            </>
                                          )}
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b> A) Hire Venue Rental Net Amount</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.NetAmount
                                              ? data.Price?.NetAmount?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })
                                              : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ paddingTop: "5px", paddingBottom: '5px', justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>B) Additional Paid Service Total</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.ServiceTotal
                                              ? data.Price?.ServiceTotal?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })
                                              : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          Additional Hour Charges
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.additionalChargesDetails
                                              ?.AdditionalHourCharges
                                              ? data.additionalChargesDetails?.AdditionalHourCharges?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })
                                              : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      {this.isOvernightShowFunction(
                                        data.DeliveryStatus,
                                        data.additionalChargesData,
                                        data.additionalChargesDetails,
                                        data.currency
                                      )}

                                      {MyOrdersData.map(
                                        (data) => data.DeliveryStatus
                                      ).join(" ") === "Pending for Verification" ? (
                                        <div className="row text-muted">
                                          <div className="col-md-2 my_color">
                                            <b>Insert Additional Discount</b>
                                          </div>
                                          <div className="col-md-4"></div>
                                          <div className="my_color col-md-6 row">
                                            <div class="col-md-7">
                                              <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Discount Note"
                                                value={AdditionalDiscountNote}
                                                onChange={(e) =>
                                                  this.setState({
                                                    AdditionalDiscountNote:
                                                      e.target.value,
                                                  })
                                                }
                                                style={{
                                                  width: "99%",
                                                  marginRight: "5px",
                                                }}
                                                disabled={
                                                  isAdditionalDiscountAllow &&
                                                  Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            <div
                                              class={
                                                isAdditionalDiscountAllow == true
                                                  ? "col-md-4"
                                                  : "col-md-3"
                                              }
                                            >
                                              <input
                                                type="text"
                                                value={AdditionalDiscount}
                                                placeholder="Discount"
                                                class="form-control"
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  // Allow only numeric characters

                                                  const numericValue = value
                                                    .replace(/[^0-9.]/g, "")
                                                    .replace(/(\..*)\./g, "$1");
                                                  this.setState({
                                                    AdditionalDiscount:
                                                      numericValue,
                                                  });
                                                }}
                                                style={{ width: "99%" }}
                                                disabled={
                                                  isAdditionalDiscountAllow &&
                                                  Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            {Is_NoDue == 0 ? (
                                              isAdditionalDiscountAllow ? (
                                                <div class="col-md-1">
                                                  <i
                                                    className="fa fa-edit action_btn_table"
                                                    onClick={() =>
                                                      this.editAdditionalDiscount(
                                                        isAdditionalDiscountAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <div class="col-md-2">
                                                  <i
                                                    className="fa fa-save action_btn_table"
                                                    onClick={() =>
                                                      this.editAdditionalDiscount(
                                                        isAdditionalDiscountAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                  <i
                                                    className="fa fa-close action_btn_table"
                                                    onClick={() =>
                                                      this.editAdditionalDiscount(
                                                        isAdditionalDiscountAllow,
                                                        true
                                                      )
                                                    }
                                                  />
                                                </div>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="d-flex align-items-center gap-2 text-muted"
                                          style={{
                                            justifyContent: "space-between",
                                          }}
                                        >
                                          <div className="width_100 my_color">Additional Discount</div>

                                          {/* Display concatenated discount notes */}
                                          <div>
                                            {MyOrdersData.map((data) => data.AdditionalDiscountNote).join(" ")}
                                          </div>

                                          <h5 className="fs-14 mb-0 my_color">
                                            {MyOrdersData[0]?.currency === "INR" ? "₹" : "$"}
                                            <span className="product-line-price">
                                              {
                                                MyOrdersData.length
                                                  ? MyOrdersData.reduce(
                                                    (sum, data) => sum + parseFloat(data.AdditionalDiscount || 0),
                                                    0
                                                  ).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })
                                                  : "0.00"
                                              }
                                            </span>
                                          </h5>
                                        </div>

                                      )}
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_100 my_color">
                                          Sub Total Amount
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.SubTotal
                                              ? data.Price?.SubTotal?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })
                                              : "0.00"}
                                          </span>
                                        </h5>
                                      </div>

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          GST ( 18% )
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.GST
                                              ? data.Price?.GST?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })
                                              : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      {MyOrdersData.some(
                                        (data) =>
                                          data.DeliveryStatus ===
                                          "Pending for Verification" ||
                                          data.DeliveryStatus === "Approved" ||
                                          (data.DeliveryStatus === "Confirmed" &&
                                            data.Is_NoDue === 0)
                                      ) ? (
                                        <div className="row text-muted">
                                          <div className="col-md-2 my_color">
                                            <b>C) Manage Refundable Deposit</b>
                                          </div>
                                          <div className="col-md-4"></div>
                                          <div className="my_color col-md-6 row">
                                            <div class="col-md-7">
                                              <input
                                                type="text"
                                                class="form-control"
                                                placeholder="Remark"
                                                value={SecurityDepositRemark}
                                                onChange={(e) =>
                                                  this.setState({
                                                    SecurityDepositRemark:
                                                      e.target.value,
                                                  })
                                                }
                                                style={{
                                                  width: "99%",
                                                  marginRight: "5px",
                                                }}
                                                disabled={
                                                  isSDAllow && Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            <div
                                              class={
                                                isSDAllow == true
                                                  ? "col-md-4"
                                                  : "col-md-3"
                                              }
                                            >
                                              <input
                                                type="text"
                                                value={SecurityDeposit}
                                                placeholder="Deposit"
                                                class="form-control"
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  // Allow only numeric characters

                                                  const numericValue = value
                                                    .replace(/[^0-9.]/g, "")
                                                    .replace(/(\..*)\./g, "$1");
                                                  this.setState({
                                                    SecurityDeposit: numericValue,
                                                  });
                                                }}
                                                style={{ width: "99%" }}
                                                disabled={
                                                  isSDAllow && Is_NoDue == 0
                                                }
                                              />
                                            </div>
                                            {Is_NoDue == 0 ? (
                                              isSDAllow ? (
                                                <div class="col-md-1">
                                                  <i
                                                    className="fa fa-edit action_btn_table"
                                                    onClick={() =>
                                                      this.editSecurityDeposit(
                                                        isSDAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                </div>
                                              ) : (
                                                <div class="col-md-2">
                                                  <i
                                                    className="fa fa-save action_btn_table"
                                                    onClick={() =>
                                                      this.editSecurityDeposit(
                                                        isSDAllow,
                                                        false
                                                      )
                                                    }
                                                  />
                                                  <i
                                                    className="fa fa-close action_btn_table"
                                                    onClick={() =>
                                                      this.editSecurityDeposit(
                                                        isSDAllow,
                                                        true
                                                      )
                                                    }
                                                  />
                                                </div>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="d-flex align-items-center gap-2 text-muted"
                                          style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                        >
                                          <div className="width_100 my_color">
                                            C) Refundable Security Deposit
                                          </div>
                                          {MyOrdersData.map(
                                            (data) => data.Remark
                                          ).join(" ")}
                                          &nbsp;
                                          <h5 className="fs-14 mb-0 my_color">
                                            {data.currency == "INR" ? "₹" : "$"}
                                            <span className="product-line-price">
                                              {MyOrdersData.length
                                                ? MyOrdersData.map(data =>
                                                  parseFloat(data.SecurityDeposit).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  })
                                                ).join(" ") : "0.00"}
                                            </span>
                                          </h5>
                                        </div>
                                      )}
                                      {/* <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          Refundable Deposit
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {parseInt(data.Price?.SecurityDeposit, 10)
                                              ? parseInt(data.Price?.SecurityDeposit, 10).toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div> */}
                                      <hr
                                        style={{
                                          margin: "5px 0px",
                                          borderTop: "1px dashed rgba(0,0,0,.1)",
                                        }}
                                      />
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Total</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.Price?.Total
                                                ? data.Price?.Total?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                })
                                                : "0.00"}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Payment Recieved</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.proformaDetails[0]?.Paid ?
                                                data.proformaDetails[0]?.Paid?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : '0.00'}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Balance</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.proformaDetails[0]?.Outstanding ?
                                                data.proformaDetails[0]?.Outstanding?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : '0.00'}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-md-6">
                                        {this.renderPaymentForm(
                                          data.paymentStatus,
                                          MyOrdersData.map(
                                            (data) => data.DeliveryStatus
                                          ).join(" ")
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                        <div className="col-md-4" />
                      </div>
                      <hr />
                      {this.IsAddAdditionalServices(
                        data.DeliveryStatus,
                        data.paymentStatus
                      ) ? (
                        <>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="card-body order_edit_css">
                                <div className=" gy-3">
                                  <Element
                                    name="additionalService"
                                    className="element"
                                  >
                                    <legend>Additional Services</legend>
                                  </Element>
                                  {/* {AdditionalServiceApprovalStatus == 0 ? (
                                    <span style={{ color: "red" }}>
                                      *Kindly check the selected Additional
                                      Services and make changes if required and
                                      submit.
                                    </span>
                                  ) : null} */}
                                  <div
                                    className="slot_para"
                                    style={{ margin: "15px" }}
                                  >
                                    <div className="row">
                                      <div className="col-md-8">
                                        <div className="add_service_para">
                                          <fieldset>
                                            <div className="slot_para">
                                              <h6>Additional Services</h6>
                                              <div className="row mr_0">
                                                <div className="col-md-3 padding_0">
                                                  <span>
                                                    <strong>Services</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong>Type</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong>Quantity</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-right">
                                                  <span>
                                                    <strong>Amount (INR)</strong>
                                                  </span>
                                                </div>
                                              </div>

                                              {data.additionalServices.length > 0 ? (
                                                data.additionalServices.map(
                                                  (service, index) => (
                                                    <div
                                                      key={index}
                                                      className="row mr_0"
                                                    >
                                                      {service.Services ? (
                                                        <>
                                                          <div className="col-md-3 padding_0">
                                                            <span>
                                                              {service.Services}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-center">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "-"
                                                                : service.Type === "S"
                                                                  ? "Standard"
                                                                  : "Premium"}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-center">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "-"
                                                                : service.Quantity}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-right">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? ""
                                                                : data.currency ===
                                                                  "INR"
                                                                  ? "₹"
                                                                  : "$"}{" "}
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "RS. 16/- per kwh"
                                                                : service.GrossAmount
                                                                  ? service.GrossAmount.toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                  })
                                                                  : "0.00"}
                                                            </span>
                                                          </div>
                                                        </>
                                                      ) : null}
                                                    </div>
                                                  )
                                                )
                                              ) : (
                                                <div className="row mr_0">
                                                  <div className="col-md-8 text-center">
                                                    <hr />
                                                    <span>No Services Selected</span>
                                                  </div>
                                                </div>
                                              )}

                                              <hr />
                                              <div className="row mr_0">
                                                <div className="col-md-3 padding_0">
                                                  <span>
                                                    <strong>Total</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong></strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong></strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-right">
                                                  <span>
                                                    <strong> {data.currency == "INR" ? "₹" : "$"}
                                                      {data.Price?.ServiceTotal
                                                        ? data.Price?.ServiceTotal?.toLocaleString("en-IN", {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        })
                                                        : "0.00"}</strong>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </fieldset>
                                        </div>
                                      </div>
                                    </div>

                                    <hr />
                                    <div class="company_info">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <h6 class="additional_services">
                                            Included Services
                                          </h6>
                                          <ul class="Included_Services">
                                            {includedServices.length > 0 &&
                                              includedServices != null ? (
                                              includedServices.map(
                                                (data, i) => (
                                                  <li>
                                                    {data.InclusiveServices}
                                                  </li>
                                                )
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <h6 class="additional_services">
                                              Additional Paid Services
                                            </h6>

                                            <div className="custom_table">
                                              <div className="hack1">
                                                <div className="hack2">
                                                  <table
                                                    class="table table-bordered table-striped table-sm"
                                                    style={{
                                                      zIndex: "000",
                                                      position: "relative",
                                                    }}
                                                    id="tbl"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            width: "2%",
                                                          }}
                                                        ></th>
                                                        <th className="Service_col_width">
                                                          Services
                                                        </th>
                                                        <th
                                                          class="text-center Service_type_width"
                                                          style={{
                                                            width: "16%",
                                                          }}
                                                        >
                                                          Type
                                                        </th>
                                                        {CurrencyID != 2 ? (
                                                          <th
                                                            class="text-center Service_prize_width"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Price (INR){" "}
                                                          </th>
                                                        ) : (
                                                          <th
                                                            class="text-center"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Price (USD){" "}
                                                          </th>
                                                        )}
                                                        <th
                                                          class="text-center"
                                                          style={{
                                                            width: "10%",
                                                          }}
                                                        >
                                                          Quantity
                                                        </th>
                                                        {CurrencyID != 2 ? (
                                                          <th
                                                            class="text-right Service_prize_width"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Amount (INR){" "}
                                                          </th>
                                                        ) : (
                                                          <th
                                                            class="text-center"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Amount (USD){" "}
                                                          </th>
                                                        )}
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      {/* '₹' : '$' */}
                                                      {additionalServicesList.length >
                                                        0 &&
                                                        additionalServicesList !=
                                                        null ? (
                                                        additionalServicesList.map(
                                                          (std, i) => (
                                                            <>
                                                              {std.Is_SelectedServiceId ==
                                                                1 ? (
                                                                // <>
                                                                //     {
                                                                //         std.Name != "Electricity" ?
                                                                <tr key={i}>
                                                                  <td>
                                                                    <div class="bg">
                                                                      <div class="chiller_cb">
                                                                        <input
                                                                          type="checkbox"
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            if (
                                                                              PossesionSubmittedUser ==
                                                                              ""
                                                                            ) {
                                                                              this.checkbox(
                                                                                i,
                                                                                std.IsSelected,
                                                                                e
                                                                              );
                                                                            } else {
                                                                              return null;
                                                                            }
                                                                          }}
                                                                          id={`checkbox${i}`}
                                                                          checked={
                                                                            std.IsSelected
                                                                          }
                                                                        />
                                                                        <label
                                                                          for={`checkbox${i}`}
                                                                          style={{
                                                                            color:
                                                                              "#979797;",
                                                                          }}
                                                                        >
                                                                          &nbsp;
                                                                        </label>
                                                                        <span></span>
                                                                      </div>
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    <div>
                                                                      {std.Name}{" "}
                                                                      &nbsp;
                                                                      {std.FilePath !=
                                                                        "" ? (
                                                                        <a
                                                                          href="javascript:void(0);"
                                                                          data-toggle="modal"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            this.modalShow(
                                                                              std.FilePath,
                                                                              i
                                                                            )
                                                                          }
                                                                          data-target="#Additional_Services_img_Pop"
                                                                        >
                                                                          <i
                                                                            class="fa fa-picture-o"
                                                                            style={{
                                                                              color:
                                                                                "#006fff",
                                                                            }}
                                                                          ></i>
                                                                        </a>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                      &nbsp;
                                                                      {std.ServiceDetails !=
                                                                        null &&
                                                                        std.ServiceDetails !=
                                                                        "" ? (
                                                                        <span class="tooltip-col">
                                                                          <i
                                                                            class="fa fa-info-circle"
                                                                            aria-hidden="true"
                                                                          ></i>
                                                                          <span class="tooltiptext">
                                                                            {
                                                                              std.ServiceDetails
                                                                            }
                                                                          </span>
                                                                        </span>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </div>
                                                                  </td>
                                                                  {/* {std.Name != "Electricity" ? */}
                                                                  <td>
                                                                    <select
                                                                      class="form-control"
                                                                      value={
                                                                        std.ServiceType ==
                                                                          "S"
                                                                          ? "Standard"
                                                                          : "Premium"
                                                                      }
                                                                      disabled={
                                                                        !std.IsSelected ||
                                                                        std.Disabled !=
                                                                        2
                                                                      }
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      // onChange={(e) => this.stdPrm(e, i)}
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          PossesionSubmittedUser ==
                                                                          ""
                                                                        ) {
                                                                          this.onServicetypechange(
                                                                            e,
                                                                            i,
                                                                            std.Name,
                                                                            std.Quantity
                                                                          );
                                                                        } else {
                                                                          return null;
                                                                        }
                                                                      }}
                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                    >
                                                                      {standardPremiumList.length >
                                                                        0 &&
                                                                        standardPremiumList.map(
                                                                          (
                                                                            item
                                                                          ) => (
                                                                            <option
                                                                              key={
                                                                                item.ID
                                                                              }
                                                                              value={
                                                                                item.Type
                                                                              }
                                                                            >
                                                                              {
                                                                                item.Type
                                                                              }
                                                                            </option>
                                                                          )
                                                                        )}
                                                                    </select>
                                                                  </td>
                                                                  {std.Name !=
                                                                    "Event Services" ? (
                                                                    <td class="text-center">
                                                                      {std.CurrencyID !=
                                                                        2 ? (
                                                                        std.PriceInINR !=
                                                                          null ? (
                                                                          "₹ " +
                                                                          std.PriceInINR.toLocaleString(
                                                                            "en-IN"
                                                                          )
                                                                        ) : (
                                                                          <></>
                                                                        )
                                                                      ) : std.PriceInUSD !=
                                                                        null ? (
                                                                        "$ " +
                                                                        std.PriceInUSD.toLocaleString(
                                                                          "en-IN"
                                                                        )
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </td>
                                                                  ) : (
                                                                    <td class="text-center">
                                                                      -
                                                                    </td>
                                                                  )}
                                                                  {std.Name !=
                                                                    "Event Services" ? (
                                                                    <td class="text-center">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control text-center"
                                                                        value={
                                                                          std.Quantity
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          if (
                                                                            PossesionSubmittedUser ==
                                                                            ""
                                                                          ) {
                                                                            this.isQuantity(
                                                                              e,
                                                                              i,
                                                                              std.Name,
                                                                              std.MaxQuantity
                                                                            );
                                                                          } else {
                                                                            return null;
                                                                          }
                                                                        }}
                                                                        disabled={
                                                                          !std.IsSelected
                                                                        }
                                                                        style={{
                                                                          outline:
                                                                            "none",
                                                                        }}
                                                                      // maxLength={3}
                                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                      />
                                                                    </td>
                                                                  ) : (
                                                                    <td class="text-center">
                                                                      -
                                                                    </td>
                                                                  )}
                                                                  {std.Name !=
                                                                    "Event Services" ? (
                                                                    <>
                                                                      {std.CurrencyID ==
                                                                        1 ? (
                                                                        <td class="text-right">
                                                                          {std.IsSelected ==
                                                                            1
                                                                            ? "₹ " +
                                                                            std.Amount?.toLocaleString()
                                                                            : "-"}
                                                                        </td>
                                                                      ) : (
                                                                        <td class="text-right">
                                                                          {std.IsSelected ==
                                                                            1
                                                                            ? "$ " +
                                                                            std.Amount.toLocaleString()
                                                                            : "-"}
                                                                        </td>
                                                                      )}
                                                                    </>
                                                                  ) : (
                                                                    <td class="text-right">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control text-right"
                                                                        value={
                                                                          std.Amount
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          if (
                                                                            PossesionSubmittedUser ==
                                                                            ""
                                                                          ) {
                                                                            this.isAmountQuantity(
                                                                              e,
                                                                              i,
                                                                              std.Name,
                                                                              std.MaxQuantity
                                                                            );
                                                                          } else {
                                                                            return null;
                                                                          }
                                                                        }}
                                                                        disabled={
                                                                          !std.IsSelected ||
                                                                          sessionStorage.getItem(
                                                                            "roleId"
                                                                          ) == 3
                                                                        }
                                                                        style={{
                                                                          outline:
                                                                            "none",
                                                                        }}
                                                                      />
                                                                    </td>
                                                                  )}
                                                                </tr>
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </>
                                                          )
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            colSpan={6}
                                                            className="text-center"
                                                            style={{
                                                              color: "#F96302",
                                                            }}
                                                          >
                                                            Additional services
                                                            will be available
                                                            soon.
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <h6 class="additional_services">
                                              Additional Vendor Services
                                            </h6>
                                            <table
                                              class="table table-bordered table-striped table-sm"
                                              id="tbl"
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{ width: "5%" }}
                                                  ></th>
                                                  <th style={{ width: "25%" }}>
                                                    SERVICE
                                                  </th>
                                                  <th style={{ width: "18%" }}>
                                                    SELECT PACKAGE
                                                  </th>
                                                  <th style={{ width: "18%" }}>
                                                    VENDOR NAME
                                                  </th>
                                                  {/* <th>PRICE (INR)</th>
                                                                            <th style={{ width: "10%" }}>QUANTITY</th> */}
                                                  {/* <th style={{ width: "35%" }}>ADDITIONAL REQUIREMENT</th> */}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {externalServices.length > 0 &&
                                                  externalServices != null ? (
                                                  externalServices.map(
                                                    (data, i) => (
                                                      <tr>
                                                        <td>
                                                          <div class="bg">
                                                            <div class="chiller_cb">
                                                              <input
                                                                type="checkbox"
                                                                onClick={(e) =>
                                                                  this.externalServicesCheckbox(
                                                                    i,
                                                                    data.IsSelected,
                                                                    e
                                                                  )
                                                                }
                                                                id={`externalServicesCheckbox${i}`}
                                                                checked={
                                                                  data.IsSelected
                                                                }
                                                                disabled={
                                                                  PossesionSubmittedUser ==
                                                                    ""
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                              <label
                                                                for={`externalServicesCheckbox${i}`}
                                                                style={{
                                                                  color:
                                                                    "#979797;",
                                                                }}
                                                              >
                                                                &nbsp;
                                                              </label>
                                                              <span></span>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td>{data.Service}</td>
                                                        {data.IsSelected ==
                                                          1 ? (
                                                          <>
                                                            {data.Package ==
                                                              null ? (
                                                              <td
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  background:
                                                                    "#fcf5f3",
                                                                }}
                                                                onClick={() =>
                                                                  this.serviceModalShow(
                                                                    data.ServiceID,
                                                                    i,
                                                                    data.Service,
                                                                    data.AdditionalRequirement
                                                                  )
                                                                }
                                                              >
                                                                <a title="Select Package">
                                                                  {" "}
                                                                  Select Package
                                                                  <span class="mendatory_class">
                                                                    *
                                                                  </span>
                                                                </a>
                                                              </td>
                                                            ) : (
                                                              <td>
                                                                <a
                                                                  title="Select Package"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    this.serviceModalShow(
                                                                      data.ServiceID,
                                                                      i,
                                                                      data.Service,
                                                                      data.AdditionalRequirement
                                                                    )
                                                                  }
                                                                >
                                                                  <i
                                                                    class="fa fa-edit"
                                                                    style={{
                                                                      fontSize:
                                                                        "14px",
                                                                    }}
                                                                  ></i>{" "}
                                                                  {data.Package}
                                                                </a>
                                                              </td>
                                                            )}
                                                          </>
                                                        ) : (
                                                          <td>{"-"}</td>
                                                        )}

                                                        <td>
                                                          {data.Package !=
                                                            null &&
                                                            data.IsSelected !=
                                                            0 ? (
                                                            <>
                                                              {data.CompanyName}
                                                            </>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </td>
                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td
                                                      colSpan={12}
                                                      className="text-center"
                                                    >
                                                      Record not found
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div className="col-md-12">
                                          {/* <h6 class="additional_services">Any other</h6> */}
                                          {/* additional_services
                                                            unListed-additional-services */}
                                          <h6 className="additional_services">
                                            Any additional services required not
                                            listed above will be check by
                                            operation team and can be made
                                            available on the basis of type and
                                            avalability.
                                          </h6>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <textarea
                                              maxLength={1000}
                                              value={unlistedAddServices}
                                              disabled={
                                                PossesionSubmittedUser != ""
                                              }
                                              onChange={(e) => {
                                                if (
                                                  PossesionSubmittedUser == ""
                                                ) {
                                                  this.setState({
                                                    unlistedAddServices:
                                                      e.target.value,
                                                  });
                                                } else {
                                                  return null;
                                                }
                                              }}
                                              style={{ height: "80px" }}
                                              class="form-control"
                                              rows="2"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div className="col-md-12">
                                          {/* <h6 class="additional_services">Any other</h6> */}
                                          {/* additional_services
                                                            unListed-additional-services */}
                                          <h6 className="additional_services">
                                            Other Information
                                          </h6>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <textarea
                                              maxLength={1000}
                                              value={OtherInformation}
                                              disabled={
                                                PossesionSubmittedUser != ""
                                              }
                                              onChange={(e) => {
                                                if (
                                                  PossesionSubmittedUser == ""
                                                ) {
                                                  this.setState({
                                                    OtherInformation:
                                                      e.target.value,
                                                  });
                                                } else {
                                                  return null;
                                                }
                                              }}
                                              style={{ height: "60px" }}
                                              class="form-control"
                                              rows="2"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {PossesionSubmittedUser == "" ? (
                                      <div class="col-md-12 my_buttons">
                                        <button
                                          onClick={() =>
                                            this.handleOrderAdditionalServiceApproval()
                                          }
                                          class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                        >
                                          Confirm Services{" "}
                                        </button>
                                      </div>
                                    ) : (
                                      <div class="col-md-12 my_buttons">
                                        <button
                                          disabled={
                                            PossesionSubmittedUser != ""
                                          }
                                          class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                        >
                                          Confirmed{" "}
                                        </button>
                                        <span>
                                          {data.isAdditionalServicesBy}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                      <div
                        className="thankYou_page"
                        style={{ marginTop: "0px" }}
                      >
                        <div class="row">
                          {PossesionSubmittedUser != "" ? (
                            <>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <Element
                                      name="checklist"
                                      className="element"
                                    >
                                      <legend>Possession</legend>
                                    </Element>
                                  </div>
                                  <div class="card-body">
                                    <div class="company_info">
                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Possession Time
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl" style={{ width: "50%", height: '40px' }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>Possession time :</th>
                                            <th style={{ width: "40%" }}>
                                              {moment(possessionTime)
                                                .utc()
                                                .format("DD/MM/YYYY hh:mm:ss")}
                                            </th>
                                          </tr>
                                        </thead>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Inhouse Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {possessionIncludedServicesList.length >
                                            0 &&
                                            possessionIncludedServicesList !=
                                            null ? (
                                            possessionIncludedServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                          id={`ServiceCheck1${i}`}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`ServiceCheck1${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      verticalAlign: "middle",
                                                    }}
                                                  >
                                                    <div>
                                                      {data.InclusiveServices}
                                                    </div>
                                                  </td>
                                                  <td class="text-center">
                                                    <input
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      type="text"
                                                      value={data.Quantity}
                                                      disabled={true}
                                                      maxLength={3}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Additional Paid Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th colSpan={1}></th>
                                            <th class="text-center">
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {possessionInhouseServicesList.length >
                                            0 &&
                                            possessionInhouseServicesList !=
                                            null ? (
                                            possessionInhouseServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          id={`ServiceCheck2${i}`}
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`ServiceCheck2${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td colSpan={2}>
                                                      <div>{data.Name}</div>
                                                    </td>
                                                  ) : (
                                                    <td>Electricity</td>
                                                  )}
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td
                                                      class="text-center"
                                                      style={{ width: "15%" }}
                                                    >
                                                      <input
                                                        type="text"
                                                        value={data.Quantity}
                                                        maxLength={3}
                                                        disabled={true}
                                                        class="form-control coustome-checkbox"
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      />
                                                    </td>
                                                  ) : (
                                                    <td
                                                      colSpan={2}
                                                      style={{
                                                        color: "#212529",
                                                        marginBottom: "0px",
                                                      }}
                                                    >
                                                      Electricity rate –RS. 16/-
                                                      per kwh
                                                    </td>
                                                  )}
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      External Services
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Service</th>
                                          <th>Vendor</th>
                                          {/* <th>Contact Details</th> */}
                                          {/* <th>Clearance</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionVendorList != "" &&
                                          possessionVendorList.length > 0 ? (
                                          possessionVendorList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Service}</td>
                                                <td>{data.Vendor}</td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      Consumable
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th colSpan={2}>Consumable</th>
                                          {/* <th style={{width:'5%'}}>Action</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionConsumableList != "" &&
                                          possessionConsumableList.length > 0 ? (
                                          possessionConsumableList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`possessionConsumable${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`possessionConsumable${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      Material List
                                    </h6>
                                    <div className="search_accordion search_card  m-0">
                                      <div
                                        className="panel-group"
                                        id="accordion"
                                      >
                                        {possessionMaterialNameAndServiceName.length >
                                          0 ? (
                                          possessionMaterialNameAndServiceName.map(
                                            (item, index) => (
                                              <div
                                                className="panel panel-default mb-2"
                                                style={{
                                                  background: "#f3f3f3",
                                                }}
                                              >
                                                <div
                                                  className="panel-heading accordion-toggle collapsed p-2"
                                                  data-toggle="collapse"
                                                  data-parent="#accordion"
                                                  data-target="#collapseOne"
                                                  onClick={() =>
                                                    this.toggleCollapse(
                                                      item.isCollapsed,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <h5
                                                    className="panel-title d-flex"
                                                    style={{
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    {/* <span className='packages'></span> */}
                                                    <span className="packages">
                                                      {item.VendorName} /{" "}
                                                      {item.ServiceName}
                                                    </span>
                                                  </h5>
                                                </div>
                                                <div
                                                  id="collapseContent"
                                                  style={{
                                                    display: !item.isCollapsed
                                                      ? "none"
                                                      : "block",
                                                  }}
                                                >
                                                  <div
                                                    className="thankYou_page"
                                                    style={{ margin: "0px" }}
                                                  >
                                                    <div
                                                      class="row"
                                                      style={{
                                                        padding:
                                                          "0px 21px 0px 33px",
                                                      }}
                                                    >
                                                      <table
                                                        class="table table-bordered table-material mb-2"
                                                        id="tbl"
                                                        style={{
                                                          background: "#ffff",
                                                        }}
                                                      >
                                                        <thead>
                                                          <tr>
                                                            <th
                                                              style={{
                                                                width: "5%",
                                                              }}
                                                            ></th>
                                                            <th>
                                                              Material Name
                                                            </th>
                                                            <th
                                                              style={{
                                                                width: "15%",
                                                              }}
                                                            >
                                                              Quantity
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {possessionMaterialList !=
                                                            "" &&
                                                            possessionMaterialList.length >
                                                            0 ? (
                                                            possessionMaterialList.map(
                                                              (data, i) => (
                                                                <>
                                                                  {data.VendorID ==
                                                                    item.VendorID ? (
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "5%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          class="bg"
                                                                          style={{
                                                                            justifyContent:
                                                                              "center",
                                                                            alignItems:
                                                                              "center",
                                                                          }}
                                                                        >
                                                                          <div class="chiller_cb">
                                                                            <input
                                                                              type="checkbox"
                                                                              id={`possessionMaterial${i}`}
                                                                              checked={
                                                                                data.IsSelected
                                                                              }
                                                                            />
                                                                            <label
                                                                              for={`possessionMaterial${i}`}
                                                                              style={{
                                                                                color:
                                                                                  "#979797;",
                                                                              }}
                                                                            >
                                                                              &nbsp;
                                                                            </label>
                                                                            <span></span>
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                      <td>
                                                                        {
                                                                          data.MaterialName
                                                                        }
                                                                      </td>
                                                                      <td>
                                                                        <input
                                                                          type="text"
                                                                          className="form-control coustome-checkbox"
                                                                          value={
                                                                            data.PossessionQuantity
                                                                          }
                                                                          disabled={
                                                                            true
                                                                          }
                                                                        />
                                                                      </td>
                                                                    </tr>
                                                                  ) : (
                                                                    <></>
                                                                  )}
                                                                </>
                                                              )
                                                            )
                                                          ) : (
                                                            <tr>
                                                              <td
                                                                colSpan={4}
                                                                className="text-center"
                                                                style={{
                                                                  color:
                                                                    "#F96302",
                                                                }}
                                                              >
                                                                Record not found
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                      <div class="form-group w-100 mb-3">
                                                        <h6
                                                          style={{
                                                            color: "#35b3e6",
                                                            margin: "0px",
                                                          }}
                                                        >
                                                          Note:
                                                        </h6>
                                                        <textarea
                                                          maxLength={500}
                                                          value={item.Note}
                                                          style={{
                                                            height: "80px",
                                                          }}
                                                          disabled={true}
                                                          class="form-control"
                                                          rows="3"
                                                          placeholder="Type here..."
                                                        ></textarea>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl"
                                          >
                                            <tbody>
                                              <td
                                                style={{
                                                  color: "#F96302",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Record not found
                                              </td>
                                            </tbody>
                                          </table>
                                        )}
                                      </div>
                                    </div>

                                    {/* <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Center Security List
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th colSpan={2}>
                                            Center Security List
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionSecurityList != "" &&
                                        possessionSecurityList.length > 0 ? (
                                          possessionSecurityList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`possessionSecurityList${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`possessionSecurityList${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Security List Note:
                                    </h6>
                                    <div class="row">
                                      <div
                                        class="col-md-12"
                                        style={{ padding: "0 15px" }}
                                      >
                                        <div class="form-group">
                                          <textarea
                                            maxLength={500}
                                            value={
                                              PossessionSecurityChecklistNote
                                            }
                                            style={{ height: "150px" }}
                                            disabled={true}
                                            class="form-control"
                                            rows="3"
                                            placeholder="Type here..."
                                          ></textarea>
                                        </div>
                                      </div>
                                    </div> */}

                                    <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Electricity
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            Electricity Units Reading on
                                            Possesion
                                          </th>
                                          <th style={{ width: "20%" }}>
                                            <input
                                              style={{ textAlign: "center" }}
                                              disabled={true}
                                              value={electricityPossesion}
                                              type="text"
                                              maxLength={10}
                                              class="form-control coustome-checkbox"
                                            />
                                          </th>
                                        </tr>
                                      </thead>
                                    </table>

                                    <div
                                      class="Checklist_div mb-3"
                                      style={{ marginTop: "30px" }}
                                    >
                                      <div className="bg checklist">
                                        <div class="chiller_cb" style={{}}>
                                          <input
                                            id={`possessionCheckListAllSelected`}
                                            checked={
                                              possessionCheckListAllSelected
                                            }
                                            type="checkbox"
                                          />
                                          <label
                                            for={`possessionCheckListAllSelected`}
                                            style={{
                                              fontSize: "13px",
                                              color: "#212529",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            {" "}
                                            Select All
                                          </label>
                                          <span></span>
                                          <span></span>
                                        </div>
                                      </div>
                                      {possessionCheckList.length > 0 &&
                                        possessionCheckList != null ? (
                                        possessionCheckList.map((data, i) => (
                                          <>
                                            <div className="bg checklist">
                                              <div
                                                class="chiller_cb"
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <input
                                                  id={`possessionCheckList${i}`}
                                                  checked={data.IsSelected}
                                                  type="checkbox"
                                                />
                                                <label
                                                  for={`possessionCheckList${i}`}
                                                  style={{
                                                    fontSize: "13px",
                                                    color: "#212529",
                                                    fontWeight: "normal",
                                                  }}
                                                >
                                                  {data.Name}
                                                  <span
                                                    class="mendatory_class"
                                                    style={{
                                                      marginLeft: "18px",
                                                      border: "none",
                                                    }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <span></span>
                                                <span></span>
                                              </div>
                                            </div>
                                          </>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={6}
                                            className="text-center"
                                            style={{ color: "#F96302" }}
                                          >
                                            Record not found
                                          </td>
                                        </tr>
                                      )}
                                    </div>

                                    <div
                                      class="d-flex align-items-center"
                                      style={{
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>
                                            Contact Name And Number
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <textarea
                                            value={
                                              PossessionContactNameAndNumber
                                            }
                                            disabled={true}
                                            // onChange={(e) => this.setState({ PossessionContactNameAndNumber: e.target.value })}
                                            style={{
                                              resize: "none",
                                              height: "100px",
                                            }}
                                            className="form-control"
                                            cols={100}
                                          />
                                        </div>
                                      </div>
                                      <div className="d-flex">
                                        <div>
                                          <label>
                                            Client Signature
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <div
                                            class="client_signature_box"
                                            style={{
                                              border: "1px solid #c9c8c8",
                                            }}
                                          >
                                            <img
                                              src={possessionSignatureData}
                                              style={{
                                                width: 250,
                                                height: 125,
                                              }}
                                              alt="Saved Signature"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="d-flex align-items-center mt-4"
                                      style={{
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>
                                            Operations Contact Name And Number
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <textarea
                                            value={
                                              PosssesionOperationNameContact
                                            }
                                            disabled={true}
                                            // onChange={(e) => this.setState({ PosssesionOperationNameContact: e.target.value })}
                                            style={{
                                              resize: "none",
                                              height: "100px",
                                            }}
                                            className="form-control"
                                            cols={100}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      class="d-flex align-items-center"
                                      style={{
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                      }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>
                                            Operations Signature
                                            <span class="mendatory_class">
                                              *
                                            </span>
                                          </label>
                                          <div
                                            class="client_signature_box"
                                            style={{
                                              border: "1px solid #c9c8c8",
                                            }}
                                          >
                                            <img
                                              src={oppPossessionSignatureData}
                                              style={{
                                                width: 250,
                                                height: 125,
                                              }}
                                              alt="Saved Signature"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          marginTop: "110px",
                                          display: "flex",
                                          flexDirection: "column",
                                        }}
                                      >
                                        <span style={{ color: "#979797" }}>
                                          Possession Submitted by{" "}
                                          {PossesionSubmittedUser}
                                        </span>
                                        <span style={{ color: "#979797" }}>
                                          {moment(PossesionSubmittedDate)
                                            .utc()
                                            .format("DD/MM/YYYY hh:mm:ss")}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}

                          {FinalExitSubmit == true &&
                            ExitSubmittedDate != "" ? (
                            <>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <Element
                                      name="checklist"
                                      className="element"
                                    >
                                      <legend>Exit</legend>
                                    </Element>
                                  </div>
                                  <div class="card-body">
                                    <div class="company_info">
                                      <div className="row">
                                        <div className="col-6">
                                          <h6 style={{ color: "#35b3e6" }}>
                                            {" "}
                                            Exit Time
                                          </h6>
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl" style={{ width: "100%", height: '40px' }}
                                          >
                                            <thead>
                                              <tr>
                                                <th>Exit time :</th>
                                                <th style={{ width: "40%" }}>
                                                  {moment(exitTime)
                                                    .utc()
                                                    .format("DD/MM/YYYY hh:mm:ss")}
                                                </th>
                                              </tr>
                                            </thead>
                                          </table>
                                        </div>
                                        <div className="col-6">
                                          <h6 style={{ color: "#35b3e6" }}>
                                            {" "}
                                            Additional hours
                                          </h6>
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl" style={{ width: "100%" }}
                                          >
                                            <thead>
                                              <tr>
                                                <th>Additional hours Utilized</th>
                                                <th style={{ width: "40%" }}>
                                                  <input
                                                    style={{ textAlign: "center" }}
                                                    value={AdditionHours}
                                                    disabled={true}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        AdditionHours:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                      })
                                                    }
                                                    type="text"
                                                    maxLength={3}
                                                    class="form-control coustome-checkbox"
                                                  />
                                                </th>
                                              </tr>
                                            </thead>
                                          </table>
                                        </div>
                                      </div>
                                      <h6 style={{ color: "#35b3e6" }}>
                                        Inhouse Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitIncludedServicesList.length >
                                            0 &&
                                            exitIncludedServicesList != null ? (
                                            exitIncludedServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          checked={
                                                            data.IsSelected ||
                                                            data.Is_checked
                                                          }
                                                          id={`existIncludedCheckbox${i}`}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`existIncludedCheckbox${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div>
                                                      {data.InclusiveServices}
                                                    </div>
                                                  </td>
                                                  <td class="text-center">
                                                    <input
                                                      type="text"
                                                      value={data.Quantity}
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      maxLength={3}
                                                      disabled={true}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Additional Paid Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th colSpan={2}></th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                            <th
                                              class="text-center"
                                              style={{ width: "131px" }}
                                            >
                                              Additional Quantity
                                            </th>
                                            {/* <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Rate
                                  </th>
                                  <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Amount (INR)
                                  </th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitInhouseServicesList.length > 0 &&
                                            exitInhouseServicesList != null ? (
                                            exitInhouseServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          id={`exitInhouseServicesList${i}`}
                                                          checked={
                                                            data.IsSelected ||
                                                            data.Is_checked
                                                          }
                                                          // disabled={true}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`exitInhouseServicesList${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td colSpan={3}>
                                                      <div>{data.Name}</div>
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      <div>Electricity</div>
                                                    </td>
                                                  )}
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <>
                                                      <td class="text-center">
                                                        <input
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                          type="text"
                                                          value={data.Quantity}
                                                          disabled={true}
                                                          class="form-control coustome-checkbox"
                                                        />
                                                      </td>
                                                    </>
                                                  ) : (
                                                    <td
                                                      colSpan={3}
                                                      style={{
                                                        color: "#212529",
                                                        marginBottom: "0px",
                                                      }}
                                                    >
                                                      Electricity rate –RS. 16/-
                                                      per kwh
                                                    </td>
                                                  )}
                                                  <td class="text-center">
                                                    <input
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      type="text"
                                                      value={
                                                        data.AdditionalQuantity
                                                      }
                                                      disabled={true}
                                                      maxLength={3}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        External Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        style={{
                                          zIndex: "000",
                                          position: "relative",
                                        }}
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Service</th>
                                            <th>Vendor</th>
                                            <th>
                                              Contact Details
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </th>
                                            <th style={{ width: "5%" }}>
                                              Clearance
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitVendorList != "" &&
                                            exitVendorList.length > 0 ? (
                                            exitVendorList.map((data, i) => (
                                              <tr>
                                                <td>{data.ServiceName}</td>
                                                <td>{data.VendorName}</td>
                                                <td>
                                                  <input
                                                    value={data.ContactDetails}
                                                    type="text"
                                                    className="form-control"
                                                    disabled={true}
                                                    maxLength={500}
                                                  />
                                                </td>
                                                <td>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`vendorCheckboxSelect${i}`}
                                                        checked={
                                                          data.IsClearanceGiven
                                                        }
                                                      />
                                                      <label
                                                        for={`vendorCheckboxSelect${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Consumable
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th colSpan={2}>Consumable</th>
                                            {/* <th style={{width:'5%'}}>Action</th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitConsumableList != "" &&
                                            exitConsumableList.length > 0 ? (
                                            exitConsumableList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>{data.Name}</td>
                                                  <td style={{ width: "5%" }}>
                                                    <div
                                                      class="bg"
                                                      style={{
                                                        justifyContent:
                                                          "center",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div class="chiller_cb">
                                                        <input
                                                          type="checkbox"
                                                          id={`exitConsumable${i}`}
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                        />
                                                        <label
                                                          for={`exitConsumable${i}`}
                                                          style={{
                                                            color: "#979797;",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Material List
                                      </h6>
                                      <div className="search_accordion search_card  m-0">
                                        <div
                                          className="panel-group"
                                          id="accordion"
                                        >
                                          {exitMaterialNameAndServiceName.length >
                                            0 ? (
                                            exitMaterialNameAndServiceName.map(
                                              (item, index) => (
                                                <>
                                                  <div
                                                    className="panel panel-default mb-2"
                                                    style={{
                                                      background: "#f3f3f3",
                                                    }}
                                                  >
                                                    <div
                                                      className="panel-heading accordion-toggle collapsed p-2"
                                                      data-toggle="collapse"
                                                      data-parent="#accordion"
                                                      data-target="#collapseOne"
                                                      onClick={() =>
                                                        this.toggleCollapse2(
                                                          item.isCollapsed,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <h4
                                                        className="panel-title d-flex"
                                                        style={{
                                                          justifyContent:
                                                            "space-between",
                                                        }}
                                                      >
                                                        {/* <span className='packages'></span> */}
                                                        <span className="packages">
                                                          {item.VendorName} /{" "}
                                                          {item.ServiceName}
                                                        </span>
                                                      </h4>
                                                    </div>
                                                    <div
                                                      id="collapseContent"
                                                      style={{
                                                        display:
                                                          !item.isCollapsed
                                                            ? "none"
                                                            : "block",
                                                      }}
                                                    >
                                                      <div
                                                        className="thankYou_page"
                                                        style={{
                                                          margin: "0px",
                                                        }}
                                                      >
                                                        <div
                                                          class="row"
                                                          style={{
                                                            padding:
                                                              "0px 21px 0px 33px",
                                                          }}
                                                        >
                                                          <table
                                                            class="table table-bordered table-material"
                                                            id="tbl"
                                                            style={{
                                                              background:
                                                                "#ffff",
                                                            }}
                                                          >
                                                            <thead>
                                                              <tr>
                                                                <th
                                                                  style={{
                                                                    width: "5%",
                                                                  }}
                                                                ></th>
                                                                <th>
                                                                  Material Name
                                                                </th>
                                                                <th
                                                                  style={{
                                                                    width:
                                                                      "15%",
                                                                  }}
                                                                >
                                                                  Quantity
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {exitMaterialList !=
                                                                "" &&
                                                                exitMaterialList.length >
                                                                0 ? (
                                                                exitMaterialList.map(
                                                                  (data, i) => (
                                                                    <>
                                                                      {data.VendorID ==
                                                                        item.VendorID ? (
                                                                        <tr>
                                                                          <td
                                                                            style={{
                                                                              width:
                                                                                "5%",
                                                                            }}
                                                                          >
                                                                            <div
                                                                              class="bg"
                                                                              style={{
                                                                                justifyContent:
                                                                                  "center",
                                                                                alignItems:
                                                                                  "center",
                                                                              }}
                                                                            >
                                                                              <div class="chiller_cb">
                                                                                <input
                                                                                  type="checkbox"
                                                                                  id={`exitMaterial${i}`}
                                                                                  checked={
                                                                                    data.IsSelected
                                                                                  }
                                                                                />
                                                                                <label
                                                                                  for={`exitMaterial${i}`}
                                                                                  style={{
                                                                                    color:
                                                                                      "#979797;",
                                                                                  }}
                                                                                >
                                                                                  &nbsp;
                                                                                </label>
                                                                                <span></span>
                                                                              </div>
                                                                            </div>
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              data.MaterialName
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            <input
                                                                              type="text"
                                                                              className="form-control coustome-checkbox"
                                                                              disabled={
                                                                                true
                                                                              }
                                                                              value={
                                                                                data.PossessionQuantity
                                                                              }
                                                                            />
                                                                          </td>
                                                                        </tr>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </>
                                                                  )
                                                                )
                                                              ) : (
                                                                <tr>
                                                                  <td
                                                                    colSpan={4}
                                                                    className="text-center"
                                                                    style={{
                                                                      color:
                                                                        "#F96302",
                                                                    }}
                                                                  >
                                                                    Record not
                                                                    found
                                                                  </td>
                                                                </tr>
                                                              )}
                                                            </tbody>
                                                          </table>
                                                          <div class="form-group w-100 mb-3">
                                                            <h6
                                                              style={{
                                                                color:
                                                                  "#35b3e6",
                                                                margin: "0px",
                                                              }}
                                                            >
                                                              Note:
                                                            </h6>
                                                            <textarea
                                                              maxLength={500}
                                                              value={item.Note}
                                                              style={{
                                                                height: "80px",
                                                              }}
                                                              disabled={true}
                                                              class="form-control"
                                                              rows="3"
                                                              placeholder="Type here..."
                                                            ></textarea>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )
                                            )
                                          ) : (
                                            <table
                                              class="table table-bordered table-striped table-sm"
                                              id="tbl"
                                            >
                                              <tbody>
                                                <td
                                                  style={{
                                                    color: "#F96302",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Record not found
                                                </td>
                                              </tbody>
                                            </table>
                                          )}
                                        </div>
                                      </div>
                                      <h6 style={{ color: "#35b3e6" }}>
                                        Electricity
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>
                                              Electricity Units Reading on Exit{" "}
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              <input
                                                style={{ textAlign: "center" }}
                                                disabled={true}
                                                value={electricityExit}
                                                type="text"
                                                maxLength={10}
                                                class="form-control coustome-checkbox"
                                              />
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>Total Consumed units</td>
                                            <td style={{ textAlign: "center" }}>
                                              {electricityExit <
                                                electricityPossesion
                                                ? 0
                                                : electricityExit -
                                                electricityPossesion}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div
                                        class="Checklist_div mb-3"
                                        style={{ marginTop: "30px" }}
                                      >
                                        <div className="bg checklist">
                                          <div class="chiller_cb" style={{}}>
                                            <input
                                              id={`exitCheckListAllSelected`}
                                              checked={exitCheckListAllSelected}
                                              disabled={true}
                                              type="checkbox"
                                            />
                                            <label
                                              for={`exitCheckListAllSelected`}
                                              style={{
                                                fontSize: "13px",
                                                color: "#212529",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              {" "}
                                              Select All
                                            </label>
                                            <span></span>
                                            <span></span>
                                          </div>
                                        </div>
                                        {exitInstructionList.length > 0 &&
                                          exitInstructionList != null ? (
                                          exitInstructionList.map((data, i) => (
                                            <>
                                              <div
                                                className="bg checklist"
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <div class="chiller_cb">
                                                  <input
                                                    id={`exitInstructionCheckbox${i}`}
                                                    checked={data.IsSelected}
                                                    type="checkbox"
                                                  />
                                                  <label
                                                    for={`exitInstructionCheckbox${i}`}
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#212529",
                                                      fontWeight: "normal",
                                                    }}
                                                  >
                                                    {data.Name}
                                                    <span
                                                      class="mendatory_class"
                                                      style={{
                                                        marginLeft: "18px",
                                                        border: "none",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <span></span>
                                                </div>
                                              </div>
                                            </>
                                          ))
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={6}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}

                                        <div class="row mt-2">
                                          <div className="col-md-12">
                                            <h6 className="additional_services">
                                              Remark
                                            </h6>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <textarea
                                                maxLength={500}
                                                value={unlistedAddServices}
                                                style={{ height: "180px" }}
                                                disabled={true}
                                                class="form-control"
                                                rows="3"
                                                placeholder="Type here..."
                                              ></textarea>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="d-flex align-items-center"
                                        style={{
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>
                                              Client Contact Name And Number
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </label>
                                            <textarea
                                              value={ExitContactNameAndNumber}
                                              disabled={true}
                                              // onChange={(e) => this.setState({ ExitContactNameAndNumber: e.target.value })}
                                              style={{
                                                resize: "none",
                                                height: "100px",
                                              }}
                                              className="form-control"
                                              cols={100}
                                            />
                                          </div>
                                        </div>
                                        <div className="d-flex">
                                          <div>
                                            <label>
                                              Client Signature
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </label>
                                            <div
                                              class="client_signature_box"
                                              style={{
                                                border: "1px solid #c9c8c8",
                                              }}
                                            >
                                              <img
                                                src={ExitSignatureData}
                                                style={{
                                                  width: 250,
                                                  height: 125,
                                                }}
                                                alt="Saved Signature"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <h6
                                        style={{
                                          color: "#35b3e6",
                                          marginTop: "20px",
                                        }}
                                      >
                                        Center Security List
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th colSpan={2}>
                                              Center Security List
                                            </th>
                                            {/* <th style={{width:'5%'}}>Action</th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitSecurityList != "" &&
                                            exitSecurityList.length > 0 ? (
                                            exitSecurityList.map((data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`exitSecurityList${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`exitSecurityList${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6
                                        style={{
                                          color: "#35b3e6",
                                          marginTop: "20px",
                                        }}
                                      >
                                        Security List Note:
                                      </h6>
                                      <div class="row">
                                        <div
                                          class="col-md-12"
                                          style={{ padding: "0 15px" }}
                                        >
                                          <div class="form-group">
                                            <textarea
                                              maxLength={500}
                                              value={ExitSecurityChecklistNote}
                                              style={{ height: "150px" }}
                                              disabled={true}
                                              class="form-control"
                                              rows="3"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="d-flex align-items-center mt-4"
                                        style={{
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>
                                              Operations Contact Name And Number
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </label>
                                            <textarea
                                              value={ExitOperationNameContact}
                                              disabled={true}
                                              // onChange={(e) => this.setState({ ExitOperationNameContact: e.target.value })}
                                              style={{
                                                resize: "none",
                                                height: "100px",
                                              }}
                                              className="form-control"
                                              cols={100}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        class="d-flex align-items-center"
                                        style={{
                                          justifyContent: "space-between",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>
                                              Operations Signature
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </label>
                                            <div
                                              class="client_signature_box"
                                              style={{
                                                border: "1px solid #c9c8c8",
                                              }}
                                            >
                                              <img
                                                src={oppExitSignatureData}
                                                style={{
                                                  width: 250,
                                                  height: 125,
                                                }}
                                                alt="Saved Signature"
                                              />
                                            </div>
                                          </div>
                                        </div>

                                        <div
                                          style={{
                                            marginTop: "110px",
                                            display: existDataListFlag
                                              ? "flex"
                                              : "",
                                            flexDirection: existDataListFlag
                                              ? "column"
                                              : "",
                                          }}
                                          className="d-flex"
                                        >
                                          <>
                                            <span style={{ color: "#979797" }}>
                                              Exit Submitted by{" "}
                                              {ExitSubmittedUser}
                                            </span>
                                            <span style={{ color: "#979797" }}>
                                              {moment(ExitSubmittedDate)
                                                .utc()
                                                .format("DD/MM/YYYY hh:mm:ss")}
                                            </span>
                                          </>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className="card-footer">
                        <Element name="bottom" className="element">
                          <div className="align-items-center gy-3">
                            <div className="row">
                              <div className="col-md-12 text-left">
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => this.backToOrders()}
                                  className="btn btn-warning my_custom_orderPage_btns m-2"
                                >
                                  Back to List
                                </a>
                                {this.IsModifyButton(
                                  data.Is_NoDue,
                                  data.DeliveryStatus,
                                  data.OrderID,
                                  data.OrderNo,
                                  data.StatusID,
                                  data.CenterID,
                                  data.summary
                                    .map((data) => data.BookingDate)
                                    .join(","),
                                  data.ClientID
                                )}
                                {this.isCreditDebit(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", ")
                                ) ? (
                                  <>
                                    <a
                                      onClick={() =>
                                        this.navigateToCreditNote(
                                          data.OrderID,
                                          data.ClientID,
                                          this.props.location.state
                                            .PrimaryEmailID || primaryEmailID
                                        )
                                      }
                                      href="javascript:void(0);"
                                      className="btn btn-success my_custom_orderPage_btns m-2"
                                    >
                                      Create Credit Note
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      onClick={() =>
                                        this.navigateToDebitNote(
                                          data.OrderID,
                                          data.ClientID,
                                          this.props.location.state
                                            .PrimaryEmailID || primaryEmailID
                                        )
                                      }
                                      className="btn btn-success my_custom_orderPage_btns m-2"
                                    >
                                      Create Debit Note
                                    </a>
                                  </>
                                ) : null}
                                {this.IsCancelledButton(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", "),
                                  PossesionSubmittedUser
                                ) ? (
                                  <>
                                    {MyOrdersData.map(
                                      (data) => data.DeliveryStatus
                                    ).join("") == "Incomplete" ? (
                                      <a
                                        href="javascript:void(0);"
                                        className="btn btn-dark my_custom_orderPage_btns m-2"
                                        onClick={() =>
                                          this.handleDelete(data.OrderID)
                                        }
                                      >
                                        {" "}
                                        Cancel Order
                                      </a>
                                    ) : (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() =>
                                          this.deleteModalShow(
                                            data.OrderID,
                                            MyOrdersData.map(
                                              (data) => data.orderNo
                                            ).join(", "),
                                            this.props.location.state
                                              .CompanyName || companyName,
                                            this.props.location.state
                                              .PrimaryEmailID || primaryEmailID,
                                            data.RoleID,
                                            data.Price.Total,
                                            moment(
                                              data.summary[0].BookingDate
                                            ).format("DD-MM-YYYY"),
                                            data.cancelArr.CancellationReason,
                                            data.cancelArr.CancellationReasonID,
                                            MyOrdersData.map(
                                              (data) => data.DeliveryStatus
                                            ).join(", ")
                                          )
                                        }
                                        className="btn btn-dark my_custom_orderPage_btns m-2"
                                      >
                                        Cancel Order
                                      </a>
                                    )}
                                  </>
                                ) : null}

                                {this.IsFollowButton(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", ")
                                ) ? (
                                  <>
                                    <a
                                      onClick={() =>
                                        this.followUpModalShow(
                                          data.OrderID,
                                          MyOrdersData.map(
                                            (data) => data.orderNo
                                          ).join(", ")
                                        )
                                      }
                                      href="javascript:void(0);"
                                      className="btn btn-success my_custom_orderPage_btns m-2"
                                    >
                                      Status
                                    </a>
                                  </>
                                ) : null}

                                {this.isApproved(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", ")
                                ) ? (
                                  <>
                                    <a
                                      onClick={() =>
                                        this.handleOrderApproval(1)
                                      }
                                      href="javascript:void(0);"
                                      className="btn btn-danger my_custom_orderPage_btns m-2"
                                    >
                                      Approve
                                    </a>
                                    <a
                                      href="javascript:void(0);"
                                      onClick={() => this.rejectModalShow()}
                                      className="btn btn-dark my_custom_orderPage_btns m-2"
                                    >
                                      Not Available
                                    </a>
                                    <div>
                                      <span
                                        style={{
                                          color: "red",
                                          marginLeft: "1rem",
                                        }}
                                      >
                                        *In case of Non Availability of the
                                        venue please call the customer/ client
                                        before action
                                      </span>
                                    </div>
                                  </>
                                ) : null}

                                {this.isSendPi(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", ")
                                ) ? (
                                  <>
                                    <a
                                      onClick={() =>
                                        this.openSendPiModal(PiType, ProformaInvoiceID, ProformaInvoice_No, OrderID, piFilePath, OrderNo)
                                      }
                                      href="javascript:void(0);"
                                      className="btn btn-danger my_custom_orderPage_btns m-2"
                                    >
                                      Send PI
                                    </a>

                                  </>
                                ) : null}

                                {this.isGenerateReceipt(
                                  MyOrdersData.map(
                                    (data) => data.DeliveryStatus
                                  ).join(", "),
                                  AdditionalServiceApprovalStatus
                                ) ? (
                                  <>
                                    <a
                                      onClick={() =>
                                        this.navigateReceipt(
                                          data.ClientID,
                                          data.OrderID,
                                          data.CenterID
                                        )
                                      }
                                      href="javascript:void(0);"
                                      className="btn btn-success my_custom_orderPage_btns m-2"
                                    >
                                      Generate Receipt
                                    </a>
                                  </>
                                ) : null}
                                {/* {this.IsNoDue(
                                  data.Is_NoDue,
                                  data.DeliveryStatus,
                                  data.NoDueBy,
                                  data.NoDueDate,
                                  AdditionalServiceApprovalStatus,
                                  data.proformaDetails.find(
                                    (proforma) =>
                                      proforma.proformaType ===
                                      "Additionalservices"
                                  )?.Outstanding,
                                  data.proformaDetails.find(
                                    (proforma) =>
                                      proforma.proformaType === "Slot Booking"
                                  )?.ProformaInvoiceID,
                                  data.proformaDetails.find(
                                    (proforma) =>
                                      proforma.proformaType === "Slot Booking"
                                  )?.ProformaInvoice_No,
                                  data.summary
                                )}
                                {this.isExitPass(
                                  data.Is_ExitPass,
                                  data.DeliveryStatus,
                                  ExitSubmittedDate,
                                  data.ExitPassBy,
                                  data.IsExitPassDate
                                )}
                                {this.IsEventClosure(
                                  data.Is_Closure,
                                  data.DeliveryStatus
                                )} */}
                              </div>
                            </div>
                            {this.isFollowupCollapse(
                              MyOrdersData.map(
                                (data) => data.DeliveryStatus
                              ).join(", ")
                            ) ? (
                              <>
                                <hr />
                                <div className="system_info">
                                  <div className="row row_margin collpase_arrow_cursor">
                                    <div
                                      className="col-md-6 col-sm-6 col-7"
                                      onClick={this.toggleFollowInfoCollapse}
                                    >
                                      <span>
                                        <i
                                          className={`fa ${followInfoCollapse
                                            ? "fa-chevron-down"
                                            : "fa-chevron-up"
                                            } CRM_rotate_data`}
                                          style={{
                                            fontSize: "12px",
                                            color: "#898989",
                                          }}
                                        ></i>
                                        <span
                                          className="heading_text"
                                          style={{ paddingLeft: "5px" }}
                                        >
                                          Status Info
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-5 text-right"></div>
                                  </div>
                                  <hr
                                    style={{
                                      marginTop: "0px",
                                      marginBottom: "15px",
                                      border: "1px solid #c0c0c0",
                                    }}
                                  />
                                  <div
                                    className={`collapse ${followInfoCollapse ? "" : "show"
                                      }`}
                                    id="Sys_info"
                                  >
                                    <div class="form-group">
                                      {followUpList &&
                                        followUpList.length > 0 ? (
                                        followUpList.map((data, index) => (
                                          <div class="row" key={index}>
                                            <div class="col-md-4 mb-3">
                                              <div class="form-group">
                                                <label
                                                  class="sys_info_label"
                                                  for="email"
                                                >
                                                  {index + 1}.{" "}
                                                  {data.FollowupDate
                                                    ? moment(
                                                      data.FollowupDate
                                                    ).format("DD-MM-YYYY")
                                                    : null}{" "}
                                                  | {data.FollowupBy}
                                                </label>
                                                <p class="Sys_info_style mx-3">
                                                  {data.Note}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <p>No follow-up notes available.</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {this.isCancelCollapse(
                              MyOrdersData.map(
                                (data) => data.DeliveryStatus
                              ).join(", ")
                            ) ? (
                              <>
                                <hr />
                                <div className="system_info">
                                  <div className="row row_margin collpase_arrow_cursor">
                                    <div
                                      className="col-md-6 col-sm-6 col-7"
                                      onClick={this.toggleFollowInfoCollapse}
                                    >
                                      <span>
                                        <i
                                          className={`fa ${followInfoCollapse
                                            ? "fa-chevron-down"
                                            : "fa-chevron-up"
                                            } CRM_rotate_data`}
                                          style={{
                                            fontSize: "12px",
                                            color: "#898989",
                                          }}
                                        ></i>
                                        <span
                                          className="heading_text"
                                          style={{ paddingLeft: "5px" }}
                                        >
                                          Cancellation Info
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-5 text-right"></div>
                                  </div>
                                  <hr
                                    style={{
                                      marginTop: "0px",
                                      marginBottom: "15px",
                                      border: "1px solid #c0c0c0",
                                    }}
                                  />
                                  <div
                                    className={`collapse ${followInfoCollapse ? "" : "show"
                                      }`}
                                    id="Sys_info"
                                  >
                                    <div class="form-group">
                                      {MyOrdersData.length > 0 &&
                                        MyOrdersData.map((data, index) => (
                                          <div class="row" key={index}>
                                            {data.cancelArr && (
                                              <div class="col-md-4 mb-3">
                                                <div class="form-group">
                                                  <label
                                                    class="sys_info_label"
                                                    for="email"
                                                  >
                                                    {index + 1}.{" "}
                                                    {data.cancelArr[0]
                                                      .DeletedDate
                                                      ? moment(
                                                        data.cancelArr[0]
                                                          .DeletedDate
                                                      ).format("DD-MM-YYYY")
                                                      : null}{" "}
                                                    |{" "}
                                                    {
                                                      data.cancelArr[0]
                                                        .DeletedBy
                                                    }
                                                  </label>
                                                  <p class="Sys_info_style mx-3">
                                                    Reason:{" "}
                                                    {data.cancelArr[0]
                                                      .CancellationReason ==
                                                      null
                                                      ? "No Cancellation Reason Available"
                                                      : data.cancelArr[0]
                                                        .CancellationReason}
                                                  </p>
                                                  <p class="Sys_info_style mx-3">
                                                    Description:{" "}
                                                    {data.cancelArr[0]
                                                      .CancellationNote == ""
                                                      ? "No Cancellation Note Available"
                                                      : data.cancelArr[0]
                                                        .CancellationNote}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            {this.isRejectCollapse(
                              MyOrdersData.map(
                                (data) => data.DeliveryStatus
                              ).join(", ")
                            ) ? (
                              <>
                                <hr />
                                <div className="system_info">
                                  <div className="row row_margin collpase_arrow_cursor">
                                    <div
                                      className="col-md-6 col-sm-6 col-7"
                                      onClick={this.toggleFollowInfoCollapse}
                                    >
                                      <span>
                                        <i
                                          className={`fa ${followInfoCollapse
                                            ? "fa-chevron-down"
                                            : "fa-chevron-up"
                                            } CRM_rotate_data`}
                                          style={{
                                            fontSize: "12px",
                                            color: "#898989",
                                          }}
                                        ></i>
                                        <span
                                          className="heading_text"
                                          style={{ paddingLeft: "5px" }}
                                        >
                                          Rejection Info
                                        </span>
                                      </span>
                                    </div>
                                    <div className="col-md-6 col-sm-6 col-5 text-right"></div>
                                  </div>
                                  <hr
                                    style={{
                                      marginTop: "0px",
                                      marginBottom: "15px",
                                      border: "1px solid #c0c0c0",
                                    }}
                                  />
                                  <div
                                    className={`collapse ${followInfoCollapse ? "" : "show"
                                      }`}
                                    id="Sys_info"
                                  >
                                    <div class="form-group">
                                      {MyOrdersData.length > 0 &&
                                        MyOrdersData.map((data, index) => (
                                          <div class="row" key={index}>
                                            {data.RejectionData && (
                                              <div class="col-md-4 mb-3">
                                                <div class="form-group">
                                                  <label
                                                    class="sys_info_label"
                                                    for="email"
                                                  >
                                                    {index + 1}.{" "}
                                                    {data.RejectionData[0]
                                                      .RejectDate
                                                      ? moment(
                                                        data.RejectionData[0]
                                                          .RejectDate
                                                      ).format("DD-MM-YYYY")
                                                      : null}{" "}
                                                    |{" "}
                                                    {
                                                      data.RejectionData[0]
                                                        .RejectName
                                                    }
                                                  </label>
                                                  <p class="Sys_info_style mx-3">
                                                    <b>Reason: </b>
                                                    {data.RejectionData[0]
                                                      .RejectionReason == null
                                                      ? "No Rejection Reason Available"
                                                      : data.RejectionData[0]
                                                        .RejectionReason}
                                                  </p>
                                                  <p class="Sys_info_style mx-3 my-1">
                                                    <b>Rejection Note: </b>
                                                    {data.RejectionData[0]
                                                      .RejectionNote == null
                                                      ? "No Rejection Note Available"
                                                      : data.RejectionData[0]
                                                        .RejectionNote}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : null}
                            <Modal
                              show={piSendShow}
                              // onHide={this.piModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Proforma Invoice for Order: {OrderNo}
                                </Modal.Title>

                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  {piFilePath && (
                                    <iframe
                                      title="Proforma Invoice Report"
                                      src={piFilePath}
                                      style={{
                                        width: "100%",
                                        height: "600px",
                                        border: "none",
                                      }}
                                    />
                                  )}
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.sendPIMail(PiType, OrderID, OrderNo, companyName, primaryEmailID, ProformaInvoiceID, ProformaInvoice_No)}
                                >
                                  Send PI
                                </Button>
                                <Button
                                  variant="secondary"
                                  onClick={() => this.setState({ piSendShow: false }, () => this.getOrderEditDetails())}
                                >
                                  Close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={PiShow}
                              // onHide={this.piModalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Download Proforma & Booking Form
                                </Modal.Title>
                                <span
                                  onClick={() => this.piModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <Tab.Container defaultActiveKey="pi">
                                  <Nav
                                    variant="tabs"
                                    className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                                    role="tablist"
                                  >
                                    <Nav.Item>
                                      <Nav.Link eventKey="pi">
                                        Proforma Invoice
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link eventKey="bookingform">
                                        Booking Form
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                  <Tab.Content>
                                    <Tab.Pane eventKey="pi">
                                      <div class="form-group">
                                        <h5>Proforma Invoice List</h5>
                                        <table className="table table-striped table-hover">
                                          <thead>
                                            <tr>
                                              <th scope="col">Sr.No</th>
                                              <th scope="col">
                                                Proforma Invoice No.
                                              </th>
                                              <th scope="col">
                                                Proforma Invoice Type
                                              </th>
                                              <th scope="col">Download</th>
                                            </tr>
                                          </thead>
                                          <tbody id="show_proformainvoices">
                                            {proformaList.length > 0 ? (
                                              proformaList.map((data) =>
                                                data.map((data2, i) => (
                                                  <tr key={data2.ProformaInvoiceID}>
                                                    <td colSpan="">{i + 1}</td>
                                                    <td>
                                                      {data2.ProformaInvoice_No}
                                                    </td>
                                                    <td>
                                                      {data2.ProformaType === "Additionalservices" ? "Rental & Additional Services" : data2.ProformaType ===
                                                        ("Slot Booking") ? "Rental" : "Additional Amount"}
                                                    </td>
                                                    <td>
                                                      <a
                                                        title="Download Proforma"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                          this.downloadPerformaInvoice(
                                                            data2.ProformaInvoiceID,
                                                            data2.ProformaInvoice_No, data2.proformaType
                                                          )
                                                        }
                                                      >
                                                        <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                                      </a>
                                                    </td>
                                                  </tr>
                                                ))
                                              )
                                            ) : (
                                              <tr>
                                                <td colSpan="4">
                                                  No Proforma Details Found!
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="bookingform">
                                      <div class="form-group">
                                        <h5>Booking Form</h5>
                                        <table className="table table-striped table-hover">
                                          <thead>
                                            <tr>
                                              <th scope="col">
                                                Application No
                                              </th>
                                              <th scope="col">
                                                Order No.
                                              </th>
                                              <th scope="col">Download</th>
                                            </tr>
                                          </thead>
                                          <tbody id="show_proformainvoices">
                                            {StatusID >= 11 ? <>
                                              <tr>
                                                <td>{OrderID}</td>
                                                <td>{OrderNo}</td>
                                                <td>
                                                  <a
                                                    title="Download Booking Form"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => this.downloadBookingForm(OrderID, OrderNo)}
                                                  >
                                                    <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                                  </a>
                                                </td>
                                              </tr>
                                            </> : <>
                                              <tr>
                                                <td colSpan="3" />
                                                No Booking Form Available!
                                              </tr>
                                            </>}
                                          </tbody>
                                        </table>
                                      </div>
                                    </Tab.Pane>
                                  </Tab.Content>
                                </Tab.Container>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.piModalClose()}
                                >
                                  Close
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={rejectShow}
                              // onHide={this.rejectModalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Reject Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.rejectModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <h5>Rejection of Booking Form</h5>
                                  <hr />
                                </div>
                                <div class="form-group">
                                  <label>Reason</label>
                                  <select
                                    id="country"
                                    name="Reason"
                                    value={RejectReasonID}
                                    onClick={(e) => {
                                      // Get the selected option element
                                      const selectedOption =
                                        e.target.options[
                                        e.target.selectedIndex
                                        ];
                                      // Get the ID and Reason from the selected option
                                      const selectedReasonId =
                                        selectedOption.value;
                                      const selectedReason =
                                        selectedOption.text;

                                      this.setState({
                                        RejectReasonID: selectedReasonId,
                                        RejectReason: selectedReason,
                                      });
                                    }}
                                    onChange={(e) => {
                                      const selectedReasonId = e.target.value;

                                      this.setState({
                                        RejectReasonID: selectedReasonId,
                                      });
                                    }}
                                    className="form-control floating-control"
                                  >
                                    <option value="">SELECT REASON</option>
                                    {rejectionReasonList.length > 0 &&
                                      rejectionReasonList.map((data) => (
                                        <option
                                          key={data.RejectReasonID}
                                          value={data.RejectReasonID}
                                        >
                                          {data.RejectReason}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Rejection Note</label>
                                  <textarea
                                    value={RejectionNote}
                                    onChange={(e) =>
                                      this.setState({
                                        RejectionNote: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.handleOrderApproval(0)} // "SUBMIT" button
                                >
                                  Submit
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={deleteShow}
                              // onHide={this.deleteModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Cancel Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.deleteModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <h5>CANCELLATION & REFUND</h5>
                                  <hr />
                                  <ul>
                                    <li>
                                      Once the ITME Center receives the online
                                      application forms for booking,
                                      cancellation of participation or reduction
                                      in requirements/packages will not be
                                      allowed after confirmation.
                                    </li>
                                    <li>
                                      If on any terms the event if canceled by
                                      the client then the cancellation charges
                                      will be as follows:
                                      <ol>
                                        <li>
                                          <strong>
                                            Event Cancelled 15 days prior – 25 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 10 days prior –75 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                        <li>
                                          <strong>
                                            Event Cancelled 5 days prior – 100 %
                                            of the Total amount.
                                          </strong>
                                        </li>
                                      </ol>
                                    </li>
                                    <li>
                                      The date on which written communication
                                      conveying full or partial cancellation is
                                      received by the Authority will be
                                      considered as the effective date for
                                      determining the cancellation charges.
                                    </li>
                                    <li>
                                      The advance amount / refundable amount and
                                      security deposit (if any) will be paid
                                      after deducting applicable taxes, banking
                                      charges, and administrative charges.
                                    </li>
                                  </ul>
                                </div>
                                <div class="form-group">
                                  <table
                                    className="table table-bordered"
                                    style={{ maxWidth: "25rem" }}
                                  >
                                    <tbody>
                                      <tr>
                                        <th>Order Amount</th>
                                        <td>
                                          {" "}
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={OrderAmount}
                                            onChange={(e) =>
                                              this.setState({
                                                OrderAmount: e.target.value,
                                              })
                                            }
                                            disabled
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Service Charges</th>
                                        <td>
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={ConvenienceFee.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>
                                              this.setState({
                                                ConvenienceFee: e.target.value,
                                              })
                                            }
                                          />
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Total Refundable</th>
                                        <td>
                                          <input
                                            className="col-sm-12"
                                            type="text"
                                            value={RefundAmount.toLocaleString(
                                              "en-IN"
                                            )}
                                            onChange={(e) =>
                                              this.setState({
                                                RefundAmount: e.target.value,
                                              })
                                            }
                                            disabled
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="form-group">
                                  <label>Reason</label>
                                  <select
                                    id="country"
                                    name="Reason"
                                    value={CancellationReasonID}
                                    onChange={(e) => {
                                      const selectedReasonId = e.target.value;
                                      this.setState({
                                        CancellationReasonID: selectedReasonId,
                                      });
                                    }}
                                    className="form-control floating-control"
                                  >
                                    <option value="">SELECT REASON</option>
                                    {cancellationReasonList.length > 0 &&
                                      cancellationReasonList.map((data) => (
                                        <option
                                          key={data.CancellationReasonID}
                                          value={data.CancellationReasonID}
                                        >
                                          {data.Name}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div class="form-group">
                                  <label>Cancellation Note</label>
                                  <textarea
                                    value={
                                      cancelNote
                                        ? cancelNote
                                        : "No cancellation Note Submitted"
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        cancelNote: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                                <div class="form-group">
                                  <label>Internal Remark</label>
                                  <textarea
                                    value={AdminRemark}
                                    onChange={(e) =>
                                      this.setState({
                                        AdminRemark: e.target.value,
                                      })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="danger"
                                  onClick={() => this.handleDelete(OrderID)} // "SUBMIT" button
                                >
                                  Confirm
                                </Button>
                              </Modal.Footer>
                            </Modal>
                            <Modal
                              show={followUpShow}
                              // onHide={this.followUpModalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>Status Note</Modal.Title>
                                <span
                                  onClick={() => this.followUpModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <textarea
                                    value={Note}
                                    onChange={(e) =>
                                      this.setState({ Note: e.target.value })
                                    }
                                    class="form-control"
                                    rows={3}
                                    defaultValue={""}
                                  />
                                </div>
                              </Modal.Body>

                              <Modal.Footer>
                                <Button
                                  variant="success"
                                  onClick={() => this.followUpSubmit()}
                                >
                                  Submit
                                </Button>
                                <Button
                                  variant="secondary"
                                  onClick={() => this.followUpModalClose()} // "SUBMIT" button
                                >
                                  close
                                </Button>
                              </Modal.Footer>
                            </Modal>

                            <Modal
                              show={isOpen}
                              size="lg"
                            // onHide={this.serviceModalClose}
                            >
                              <Modal.Header className="pb-0">
                                <Modal.Title style={{ width: "100%" }}>
                                  <div
                                    className=" d-flex mr-5 mb-4"
                                    style={{ justifyContent: "space-between" }}
                                  >
                                    <div className="pack-name">
                                      <span>
                                        {" "}
                                        Available package for{" "}
                                        <span
                                          style={{
                                            fontSize: "20px",
                                            color: "#1976D2",
                                          }}
                                        >
                                          {serviceName}
                                        </span>
                                      </span>
                                    </div>
                                    <div className="d-flex">
                                      <div className="mr-4 m-1">Pricing : </div>
                                      <div>
                                        <Box sx={{ width: 200 }}>
                                          <Slider
                                            value={SliderValue}
                                            onChangeCommitted={(e, value) =>
                                              this.onSliderHandleChange(
                                                e,
                                                value
                                              )
                                            }
                                            onChange={(e) =>
                                              this.setState({
                                                SliderValue: e.target.value,
                                              })
                                            }
                                            valueLabelDisplay="on"
                                            max={100000}
                                            marks={marks}
                                            step={null}
                                          />
                                        </Box>
                                      </div>
                                      {/* <div>
                                        <button
                                            onClick={() => this.onSearchPackage()}
                                            class="btn btn-info ml-3 p-1"
                                        >
                                            Search
                                        </button>
                                    </div> */}
                                    </div>
                                  </div>
                                </Modal.Title>
                                <span
                                  onClick={this.serviceModalClose}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body
                                className="pb-0 p-3 cat-pop"
                                style={{
                                  marginBottom: "0px",
                                  overflowY: "auto",
                                }}
                              >
                                {/* <div>
                            <span className='mr-2'>Minimum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={minPrice != 0 ? minPrice : ''}
                                onChange={(e) => this.onPrice(e, 'min')}
                                maxLength={6}
                                disabled
                            />
                        </div>
                        <div>
                            <span className='mr-2'>Maximum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={maxPrice != 0 ? maxPrice : ''}
                                onChange={(e) => this.onPrice(e, 'max')}
                                maxLength={6}
                                disabled
                            />
                        </div> */}
                                <div className="">
                                  <div
                                    className="search_accordion search_card  m-0"
                                    style={{ background: "none" }}
                                  >
                                    <div className="panel-group" id="accordion">
                                      {vendorNameList.length > 0 ? (
                                        vendorNameList.map((item, i) => (
                                          <div
                                            className="panel panel-default mb-2"
                                            style={{ background: "#f3f3f3" }}
                                          >
                                            <div
                                              className="panel-heading accordion-toggle collapsed p-2"
                                              data-toggle="collapse"
                                              data-parent="#accordion"
                                              data-target="#collapseOne"
                                              onClick={() =>
                                                this.toggleCollapseAdditionalService(
                                                  item.isCollapsed,
                                                  i
                                                )
                                              }
                                            >
                                              <h4
                                                className="panel-title d-flex"
                                                style={{
                                                  justifyContent:
                                                    "space-between",
                                                }}
                                              >
                                                <span
                                                  style={{ marginTop: "5px" }}
                                                >
                                                  {item.name}
                                                </span>
                                                <span className="packages">
                                                  {item.frequency} Options
                                                </span>
                                              </h4>
                                            </div>
                                            <div
                                              id="collapseContent"
                                              style={{
                                                display: !item.isCollapsed
                                                  ? "none"
                                                  : "block",
                                              }}
                                            >
                                              <div
                                                className="thankYou_page"
                                                style={{ marginTop: "0px" }}
                                              >
                                                <div class="row">
                                                  <div class="col-md-12">
                                                    {vendorPackageList.length >
                                                      0 &&
                                                      vendorPackageList != "" ? (
                                                      vendorPackageList.map(
                                                        (data, i) => (
                                                          <>
                                                            {data.VendorID ==
                                                              item.VendorID ? (
                                                              <div
                                                                class="card"
                                                                style={{
                                                                  marginBottom:
                                                                    "10px",
                                                                }}
                                                              >
                                                                <div class="card-body p-2">
                                                                  <div class="company_info d-flex">
                                                                    <div class="bg">
                                                                      <div class="chiller_cb">
                                                                        <input
                                                                          id={`vendorPackageCheckbox${i}`}
                                                                          type="checkbox"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            this.vendorPackageCheckbox(
                                                                              i,
                                                                              data.IsSelected,
                                                                              e
                                                                            )
                                                                          }
                                                                          checked={
                                                                            data.IsSelected
                                                                          }
                                                                        />
                                                                        <label
                                                                          for={`vendorPackageCheckbox${i}`}
                                                                          style={{
                                                                            color:
                                                                              "#000",
                                                                            fontSize:
                                                                              "13px",
                                                                          }}
                                                                        >
                                                                          {" "}
                                                                          &emsp;{" "}
                                                                        </label>
                                                                        <span></span>
                                                                      </div>
                                                                    </div>

                                                                    <div
                                                                      style={{
                                                                        width:
                                                                          "100%",
                                                                      }}
                                                                    >
                                                                      <p className="m-0">
                                                                        {
                                                                          data.VendorName
                                                                        }{" "}
                                                                        /{" "}
                                                                        <spa className="pac-nam">
                                                                          {
                                                                            data.Package
                                                                          }
                                                                        </spa>
                                                                      </p>
                                                                      <div
                                                                        class="card"
                                                                        style={{
                                                                          width:
                                                                            "100%",
                                                                          margin:
                                                                            "5px 0 5px 0",
                                                                        }}
                                                                      >
                                                                        <div class="card-body p-2">
                                                                          <pre
                                                                            style={{
                                                                              margin: 0,
                                                                              padding: 0,
                                                                            }}
                                                                            dangerouslySetInnerHTML={{
                                                                              __html:
                                                                                data.PackageDetails,
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      {data.FilePath !=
                                                                        null ? (
                                                                        <p className="m-0">
                                                                          {" "}
                                                                          Images:{" "}
                                                                          <a
                                                                            title="Show Images"
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                              fontSize:
                                                                                "18px",
                                                                            }}
                                                                            onClick={() =>
                                                                              this.vendorModalShow(
                                                                                data.FilePath
                                                                              )
                                                                            }
                                                                          >
                                                                            <i class="fa fa-image"></i>
                                                                          </a>
                                                                        </p>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            ) : (
                                                              <></>
                                                            )}
                                                          </>
                                                        )
                                                      )
                                                    ) : (
                                                      <tr>
                                                        <td
                                                          colSpan={12}
                                                          className="text-center"
                                                        >
                                                          Record not found
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <></>
                                      )}
                                      {vendorPackageList.length > 0 &&
                                        vendorPackageList != "" ? (
                                        <>
                                          <p className="m-0 pt-2 bot-add">
                                            Additional Requirement:
                                          </p>
                                          <CKEditor
                                            editor={ClassicEditor}
                                            data={addRequirement}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              this.additionRequirement(data);
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </Modal.Body>
                              <div className="model-footer model-footer p-2 pt-0 pr-3">
                                <div style={{ textAlign: "right" }}>
                                  {vendorPackageList.length > 0 &&
                                    vendorPackageList != "" ? (
                                    <button
                                      onClick={() =>
                                        this.setState({ isOpen: false })
                                      }
                                      class="btn btn-outline-success mr-2"
                                    >
                                      Submit
                                    </button>
                                  ) : (
                                    <></>
                                  )}
                                  <button
                                    onClick={() => this.serviceModalClose()}
                                    class="btn btn-outline-secondary mr-2"
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            </Modal>

                            <Modal
                              show={show}
                              onHide={this.vendorModalClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>Vendor Images</Modal.Title>
                                <span
                                  onClick={this.vendorModalClose}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body style={{ marginBottom: "0px" }}>
                                {/* {
                            fileList.length && */}

                                <OwlCarousel
                                  style={{ zIndex: "1" }}
                                  items={1}
                                  loop
                                  nav
                                  margin={20}
                                >
                                  {fileList != "" ? (
                                    fileList.map((imageUrl, i) => (
                                      <>
                                        <img
                                          alt=""
                                          title=""
                                          src={downloadUrl + imageUrl.trim()}
                                          className="booking_page_img"
                                        />
                                      </>
                                    ))
                                  ) : (
                                    <></>
                                  )}
                                </OwlCarousel>
                                {/* } */}
                              </Modal.Body>
                            </Modal>

                            <Modal
                              show={showtable}
                              onHide={this.tablePackageDetailsClose}
                              size="md"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Vendor Package Details
                                </Modal.Title>
                                <span
                                  onClick={this.tablePackageDetailsClose}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body style={{ marginBottom: "0px" }}>
                                {/* {
                            fileList.length && */}
                                <div>
                                  <pre
                                    dangerouslySetInnerHTML={{
                                      __html: showPackageDetailsData,
                                    }}
                                  />
                                </div>
                                {/* } */}
                              </Modal.Body>
                            </Modal>
                            <Modal
                              show={editShow}
                              // onHide={this.editModalClose}
                              size="lg"
                            >
                              <Modal.Header>
                                <Modal.Title>
                                  Modify Order: {OrderNo}
                                </Modal.Title>
                                <span
                                  onClick={() => this.editModalClose()}
                                  style={{
                                    cursor: "pointer",
                                    fontWeight: "800",
                                  }}
                                >
                                  X
                                </span>
                              </Modal.Header>

                              <Modal.Body>
                                <div class="form-group">
                                  <ol>
                                    <h5>Order Modification</h5>
                                    <hr />
                                    <li>
                                      Any postponement date is allowed only once
                                      after that you cannot change the date
                                    </li>
                                    <li>
                                      After the postponement/change of the date
                                      of the booking, you cannot cancel the
                                      booking.
                                    </li>
                                    <li>
                                      If you cancel the booking after the change
                                      of the date, your total amount will be
                                      forfeited.
                                    </li>
                                    <li>
                                      The change of booking date will be allowed
                                      only on the availability of the venue and
                                      on a first come first serve basis
                                    </li>
                                  </ol>
                                </div>
                                <Button
                                  variant="success"
                                  onClick={() =>
                                    this.AgreeModification(
                                      OrderID,
                                      OrderNo,
                                      StatusID,
                                      CenterID,
                                      BookingDate,
                                      isEdit,
                                      ClientID,
                                      0
                                    )
                                  }
                                >
                                  Agree
                                </Button>

                                <hr />
                                {isModifyEdit ? (
                                  <table className="table table-bordered table-striped">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Navigate to</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>1</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              1
                                            )
                                          }
                                        >
                                          Calendar View
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>2</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              2
                                            )
                                          }
                                        >
                                          Organiser's Info
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>3</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              3
                                            )
                                          }
                                        >
                                          Booking Details
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>4</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              4
                                            )
                                          }
                                        >
                                          Additional Services
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>5</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              5
                                            )
                                          }
                                        >
                                          Terms & conditions
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>6</td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            this.onEditNavigate(
                                              OrderID,
                                              OrderNo,
                                              StatusID,
                                              CenterID,
                                              BookingDate,
                                              isEdit,
                                              ClientID,
                                              6
                                            )
                                          }
                                        >
                                          Summary
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ) : null}
                              </Modal.Body>
                            </Modal>
                          </div>
                        </Element>
                      </div>
                    </div>
                  ))}
                {/* <div class="total_card_count">
    <div class="card">
      <div class="card-body bg_grey">
        <div class="d-flex total_div">
          <div class="total_text">Total : </div>
          <h5 class="fs-14 mb-0 total_count_text">₹ <span class="product-line-price">2,26,500</span></h5>
        </div>
      </div>
    </div>
  </div> */}
              </div>
            </div>
          </main>
          <style type="text/css">{floatingLabelCSS}</style>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    order_delete_action,
    fill_action,
    order_edit_details,
    download_performa_invoice_action,
    client_detail_action,
    client_add_action,
    follow_up_add_action,
    get_follow_up_action,
    order_cancel_reason_action,
    download_no_due_action,
    generate_nodue_action,
    order_approval_action,
    get_booking_Details_action,
    get_additional_services_action,
    event_closure_action,
    update_exit_pass_action,
    update_additional_service_approval_action,
    get_possession_list_action,
    get_exist_list_action,
    update_additional_hour,
    download_exitPass_action,
    getServiceVendorPackageDetail_action,
    update_additional_discount,
    update_rental_discount,
    update_security_deposit,
    update_event_service, send_approval_pi_mail_action,
    download_booking_form_action
  })(OrdersEdit)
);
